/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v11.17.4.0 (NJsonSchema v9.10.46.0 (Newtonsoft.Json v9.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var AssetContextViewModel = /** @class */ (function () {
    function AssetContextViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AssetContextViewModel.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"] !== undefined ? data["tenantId"] : null;
            this.name = data["name"] !== undefined ? data["name"] : null;
            this.code = data["code"] !== undefined ? data["code"] : null;
            this.city = data["city"] !== undefined ? data["city"] : null;
            this.zipCode = data["zipCode"] !== undefined ? data["zipCode"] : null;
            this.companyName = data["companyName"] !== undefined ? data["companyName"] : null;
            this.scopeId = data["scopeId"] !== undefined ? data["scopeId"] : null;
            this.hasConditionalChildren = data["hasConditionalChildren"] !== undefined ? data["hasConditionalChildren"] : null;
            this.parentTenantId = data["parentTenantId"] !== undefined ? data["parentTenantId"] : null;
        }
    };
    AssetContextViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AssetContextViewModel();
        result.init(data);
        return result;
    };
    AssetContextViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["code"] = this.code !== undefined ? this.code : null;
        data["city"] = this.city !== undefined ? this.city : null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null;
        data["scopeId"] = this.scopeId !== undefined ? this.scopeId : null;
        data["hasConditionalChildren"] = this.hasConditionalChildren !== undefined ? this.hasConditionalChildren : null;
        data["parentTenantId"] = this.parentTenantId !== undefined ? this.parentTenantId : null;
        return data;
    };
    return AssetContextViewModel;
}());
export { AssetContextViewModel };
/** View model containing all required data to configure an asset definition for individual customer. */
var AssetDefinitionCustomerViewModel = /** @class */ (function () {
    function AssetDefinitionCustomerViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AssetDefinitionCustomerViewModel.prototype.init = function (data) {
        if (data) {
            this.tenantAssetDefinitionId = data["tenantAssetDefinitionId"] !== undefined ? data["tenantAssetDefinitionId"] : null;
            this.customerId = data["customerId"] !== undefined ? data["customerId"] : null;
            this.assetDefinitionId = data["assetDefinitionId"] !== undefined ? data["assetDefinitionId"] : null;
            if (data["serviceCenterIds"] && data["serviceCenterIds"].constructor === Array) {
                this.serviceCenterIds = [];
                for (var _i = 0, _a = data["serviceCenterIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.serviceCenterIds.push(item);
                }
            }
            if (data["softwareVersions"] && data["softwareVersions"].constructor === Array) {
                this.softwareVersions = [];
                for (var _b = 0, _c = data["softwareVersions"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.softwareVersions.push(item);
                }
            }
            if (data["symptomCodeGroups"] && data["symptomCodeGroups"].constructor === Array) {
                this.symptomCodeGroups = [];
                for (var _d = 0, _e = data["symptomCodeGroups"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.symptomCodeGroups.push(AssetStatusCodeGroupViewModel.fromJS(item));
                }
            }
            if (data["bundleContentDefinitions"] && data["bundleContentDefinitions"].constructor === Array) {
                this.bundleContentDefinitions = [];
                for (var _f = 0, _g = data["bundleContentDefinitions"]; _f < _g.length; _f++) {
                    var item = _g[_f];
                    this.bundleContentDefinitions.push(BundleContentDefinitionViewModel.fromJS(item));
                }
            }
            this.countSymptomCodes = data["countSymptomCodes"] !== undefined ? data["countSymptomCodes"] : null;
            this.countServiceCodes = data["countServiceCodes"] !== undefined ? data["countServiceCodes"] : null;
        }
    };
    AssetDefinitionCustomerViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AssetDefinitionCustomerViewModel();
        result.init(data);
        return result;
    };
    AssetDefinitionCustomerViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantAssetDefinitionId"] = this.tenantAssetDefinitionId !== undefined ? this.tenantAssetDefinitionId : null;
        data["customerId"] = this.customerId !== undefined ? this.customerId : null;
        data["assetDefinitionId"] = this.assetDefinitionId !== undefined ? this.assetDefinitionId : null;
        if (this.serviceCenterIds && this.serviceCenterIds.constructor === Array) {
            data["serviceCenterIds"] = [];
            for (var _i = 0, _a = this.serviceCenterIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["serviceCenterIds"].push(item);
            }
        }
        if (this.softwareVersions && this.softwareVersions.constructor === Array) {
            data["softwareVersions"] = [];
            for (var _b = 0, _c = this.softwareVersions; _b < _c.length; _b++) {
                var item = _c[_b];
                data["softwareVersions"].push(item);
            }
        }
        if (this.symptomCodeGroups && this.symptomCodeGroups.constructor === Array) {
            data["symptomCodeGroups"] = [];
            for (var _d = 0, _e = this.symptomCodeGroups; _d < _e.length; _d++) {
                var item = _e[_d];
                data["symptomCodeGroups"].push(item.toJSON());
            }
        }
        if (this.bundleContentDefinitions && this.bundleContentDefinitions.constructor === Array) {
            data["bundleContentDefinitions"] = [];
            for (var _f = 0, _g = this.bundleContentDefinitions; _f < _g.length; _f++) {
                var item = _g[_f];
                data["bundleContentDefinitions"].push(item.toJSON());
            }
        }
        data["countSymptomCodes"] = this.countSymptomCodes !== undefined ? this.countSymptomCodes : null;
        data["countServiceCodes"] = this.countServiceCodes !== undefined ? this.countServiceCodes : null;
        return data;
    };
    return AssetDefinitionCustomerViewModel;
}());
export { AssetDefinitionCustomerViewModel };
var AssetStatusCodeGroupViewModel = /** @class */ (function () {
    function AssetStatusCodeGroupViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AssetStatusCodeGroupViewModel.prototype.init = function (data) {
        if (data) {
            this.assetStatusCodeGroupId = data["assetStatusCodeGroupId"] !== undefined ? data["assetStatusCodeGroupId"] : null;
            this.name = data["name"] !== undefined ? data["name"] : null;
            this.key = data["key"] !== undefined ? data["key"] : null;
            this.tenantId = data["tenantId"] !== undefined ? data["tenantId"] : null;
            this.order = data["order"] !== undefined ? data["order"] : null;
            if (data["assetStatusCodes"] && data["assetStatusCodes"].constructor === Array) {
                this.assetStatusCodes = [];
                for (var _i = 0, _a = data["assetStatusCodes"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.assetStatusCodes.push(AssetStatusCodeViewModel.fromJS(item));
                }
            }
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (var _b = 0, _c = data["translations"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.translations.push(TranslationViewModel.fromJS(item));
                }
            }
        }
    };
    AssetStatusCodeGroupViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AssetStatusCodeGroupViewModel();
        result.init(data);
        return result;
    };
    AssetStatusCodeGroupViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["assetStatusCodeGroupId"] = this.assetStatusCodeGroupId !== undefined ? this.assetStatusCodeGroupId : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["key"] = this.key !== undefined ? this.key : null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null;
        data["order"] = this.order !== undefined ? this.order : null;
        if (this.assetStatusCodes && this.assetStatusCodes.constructor === Array) {
            data["assetStatusCodes"] = [];
            for (var _i = 0, _a = this.assetStatusCodes; _i < _a.length; _i++) {
                var item = _a[_i];
                data["assetStatusCodes"].push(item.toJSON());
            }
        }
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (var _b = 0, _c = this.translations; _b < _c.length; _b++) {
                var item = _c[_b];
                data["translations"].push(item.toJSON());
            }
        }
        return data;
    };
    return AssetStatusCodeGroupViewModel;
}());
export { AssetStatusCodeGroupViewModel };
var AssetStatusCodeViewModel = /** @class */ (function () {
    function AssetStatusCodeViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AssetStatusCodeViewModel.prototype.init = function (data) {
        if (data) {
            this.assetStatusCodeId = data["assetStatusCodeId"] !== undefined ? data["assetStatusCodeId"] : null;
            this.code = data["code"] !== undefined ? data["code"] : null;
            this.description = data["description"] !== undefined ? data["description"] : null;
            this.codeGroupId = data["codeGroupId"] !== undefined ? data["codeGroupId"] : null;
            this.codeGroupName = data["codeGroupName"] !== undefined ? data["codeGroupName"] : null;
            if (data["codeGroupTranslations"] && data["codeGroupTranslations"].constructor === Array) {
                this.codeGroupTranslations = [];
                for (var _i = 0, _a = data["codeGroupTranslations"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.codeGroupTranslations.push(TranslationViewModel.fromJS(item));
                }
            }
            this.codeType = data["codeType"] !== undefined ? data["codeType"] : null;
            this.key = data["key"] !== undefined ? data["key"] : null;
            this.assetDefinitionId = data["assetDefinitionId"] !== undefined ? data["assetDefinitionId"] : null;
            this.order = data["order"] !== undefined ? data["order"] : null;
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (var _b = 0, _c = data["translations"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.translations.push(TranslationViewModel.fromJS(item));
                }
            }
        }
    };
    AssetStatusCodeViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AssetStatusCodeViewModel();
        result.init(data);
        return result;
    };
    AssetStatusCodeViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["assetStatusCodeId"] = this.assetStatusCodeId !== undefined ? this.assetStatusCodeId : null;
        data["code"] = this.code !== undefined ? this.code : null;
        data["description"] = this.description !== undefined ? this.description : null;
        data["codeGroupId"] = this.codeGroupId !== undefined ? this.codeGroupId : null;
        data["codeGroupName"] = this.codeGroupName !== undefined ? this.codeGroupName : null;
        if (this.codeGroupTranslations && this.codeGroupTranslations.constructor === Array) {
            data["codeGroupTranslations"] = [];
            for (var _i = 0, _a = this.codeGroupTranslations; _i < _a.length; _i++) {
                var item = _a[_i];
                data["codeGroupTranslations"].push(item.toJSON());
            }
        }
        data["codeType"] = this.codeType !== undefined ? this.codeType : null;
        data["key"] = this.key !== undefined ? this.key : null;
        data["assetDefinitionId"] = this.assetDefinitionId !== undefined ? this.assetDefinitionId : null;
        data["order"] = this.order !== undefined ? this.order : null;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (var _b = 0, _c = this.translations; _b < _c.length; _b++) {
                var item = _c[_b];
                data["translations"].push(item.toJSON());
            }
        }
        return data;
    };
    return AssetStatusCodeViewModel;
}());
export { AssetStatusCodeViewModel };
var TranslationViewModel = /** @class */ (function () {
    function TranslationViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TranslationViewModel.prototype.init = function (data) {
        if (data) {
            this.languageId = data["languageId"] !== undefined ? data["languageId"] : null;
            this.languageCode = data["languageCode"] !== undefined ? data["languageCode"] : null;
            this.translation = data["translation"] !== undefined ? data["translation"] : null;
            this.key = data["key"] !== undefined ? data["key"] : null;
        }
    };
    TranslationViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TranslationViewModel();
        result.init(data);
        return result;
    };
    TranslationViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId !== undefined ? this.languageId : null;
        data["languageCode"] = this.languageCode !== undefined ? this.languageCode : null;
        data["translation"] = this.translation !== undefined ? this.translation : null;
        data["key"] = this.key !== undefined ? this.key : null;
        return data;
    };
    return TranslationViewModel;
}());
export { TranslationViewModel };
export var CodeTypeEnum;
(function (CodeTypeEnum) {
    CodeTypeEnum[CodeTypeEnum["RepairCode"] = 0] = "RepairCode";
    CodeTypeEnum[CodeTypeEnum["SymptomCode"] = 1] = "SymptomCode";
    CodeTypeEnum[CodeTypeEnum["ServiceCode"] = 2] = "ServiceCode";
})(CodeTypeEnum || (CodeTypeEnum = {}));
var BundleContentDefinitionViewModel = /** @class */ (function () {
    function BundleContentDefinitionViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BundleContentDefinitionViewModel.prototype.init = function (data) {
        if (data) {
            this.bundleContentDefinitionId = data["bundleContentDefinitionId"] !== undefined ? data["bundleContentDefinitionId"] : null;
            this.bundleDefinitionId = data["bundleDefinitionId"] !== undefined ? data["bundleDefinitionId"] : null;
            this.assetDefinitionId = data["assetDefinitionId"] !== undefined ? data["assetDefinitionId"] : null;
            this.usageType = data["usageType"] !== undefined ? data["usageType"] : null;
            this.required = data["required"] !== undefined ? data["required"] : null;
            this.assetTypeDescription = data["assetTypeDescription"] !== undefined ? data["assetTypeDescription"] : null;
            this.assetDefinitionName = data["assetDefinitionName"] !== undefined ? data["assetDefinitionName"] : null;
            this.pictureUrl = data["pictureUrl"] !== undefined ? data["pictureUrl"] : null;
        }
    };
    BundleContentDefinitionViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BundleContentDefinitionViewModel();
        result.init(data);
        return result;
    };
    BundleContentDefinitionViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["bundleContentDefinitionId"] = this.bundleContentDefinitionId !== undefined ? this.bundleContentDefinitionId : null;
        data["bundleDefinitionId"] = this.bundleDefinitionId !== undefined ? this.bundleDefinitionId : null;
        data["assetDefinitionId"] = this.assetDefinitionId !== undefined ? this.assetDefinitionId : null;
        data["usageType"] = this.usageType !== undefined ? this.usageType : null;
        data["required"] = this.required !== undefined ? this.required : null;
        data["assetTypeDescription"] = this.assetTypeDescription !== undefined ? this.assetTypeDescription : null;
        data["assetDefinitionName"] = this.assetDefinitionName !== undefined ? this.assetDefinitionName : null;
        data["pictureUrl"] = this.pictureUrl !== undefined ? this.pictureUrl : null;
        return data;
    };
    return BundleContentDefinitionViewModel;
}());
export { BundleContentDefinitionViewModel };
var AssetDefinitionViewModel = /** @class */ (function () {
    function AssetDefinitionViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AssetDefinitionViewModel.prototype.init = function (data) {
        if (data) {
            this.assetDefinitionId = data["assetDefinitionId"] !== undefined ? data["assetDefinitionId"] : null;
            this.name = data["name"] !== undefined ? data["name"] : null;
            this.fullName = data["fullName"] !== undefined ? data["fullName"] : null;
            this.dummySerialNumber = data["dummySerialNumber"] !== undefined ? data["dummySerialNumber"] : null;
            this.description = data["description"] !== undefined ? data["description"] : null;
            this.picture = data["picture"] !== undefined ? data["picture"] : null;
            this.rmaGeneration = data["rmaGeneration"] !== undefined ? data["rmaGeneration"] : null;
            this.showInfoScreen = data["showInfoScreen"] !== undefined ? data["showInfoScreen"] : null;
            this.assetTypeId = data["assetTypeId"] !== undefined ? data["assetTypeId"] : null;
            this.assetTypeName = data["assetTypeName"] !== undefined ? data["assetTypeName"] : null;
            this.manufacturerId = data["manufacturerId"] !== undefined ? data["manufacturerId"] : null;
            this.erpAssetDefinitionId = data["erpAssetDefinitionId"] !== undefined ? data["erpAssetDefinitionId"] : null;
            this.notActive = data["notActive"] !== undefined ? data["notActive"] : null;
            this.minSnLength = data["minSnLength"] !== undefined ? data["minSnLength"] : null;
            this.maxSnLength = data["maxSnLength"] !== undefined ? data["maxSnLength"] : null;
            this.serialNumberOptional = data["serialNumberOptional"] !== undefined ? data["serialNumberOptional"] : null;
            this.softwareVersionId = data["softwareVersionId"] !== undefined ? data["softwareVersionId"] : null;
            if (data["softwareVersions"] && data["softwareVersions"].constructor === Array) {
                this.softwareVersions = [];
                for (var _i = 0, _a = data["softwareVersions"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.softwareVersions.push(SoftwareVersionViewModel.fromJS(item));
                }
            }
            if (data["repairCodes"] && data["repairCodes"].constructor === Array) {
                this.repairCodes = [];
                for (var _b = 0, _c = data["repairCodes"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.repairCodes.push(AssetStatusCodeGroupViewModel.fromJS(item));
                }
            }
            this.fileName = data["fileName"] !== undefined ? data["fileName"] : null;
            this.fileBase64Content = data["fileBase64Content"] !== undefined ? data["fileBase64Content"] : null;
            this.pictureUrl = data["pictureUrl"] !== undefined ? data["pictureUrl"] : null;
            this.countRepairCodes = data["countRepairCodes"] !== undefined ? data["countRepairCodes"] : null;
        }
    };
    AssetDefinitionViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AssetDefinitionViewModel();
        result.init(data);
        return result;
    };
    AssetDefinitionViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["assetDefinitionId"] = this.assetDefinitionId !== undefined ? this.assetDefinitionId : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null;
        data["dummySerialNumber"] = this.dummySerialNumber !== undefined ? this.dummySerialNumber : null;
        data["description"] = this.description !== undefined ? this.description : null;
        data["picture"] = this.picture !== undefined ? this.picture : null;
        data["rmaGeneration"] = this.rmaGeneration !== undefined ? this.rmaGeneration : null;
        data["showInfoScreen"] = this.showInfoScreen !== undefined ? this.showInfoScreen : null;
        data["assetTypeId"] = this.assetTypeId !== undefined ? this.assetTypeId : null;
        data["assetTypeName"] = this.assetTypeName !== undefined ? this.assetTypeName : null;
        data["manufacturerId"] = this.manufacturerId !== undefined ? this.manufacturerId : null;
        data["erpAssetDefinitionId"] = this.erpAssetDefinitionId !== undefined ? this.erpAssetDefinitionId : null;
        data["notActive"] = this.notActive !== undefined ? this.notActive : null;
        data["minSnLength"] = this.minSnLength !== undefined ? this.minSnLength : null;
        data["maxSnLength"] = this.maxSnLength !== undefined ? this.maxSnLength : null;
        data["serialNumberOptional"] = this.serialNumberOptional !== undefined ? this.serialNumberOptional : null;
        data["softwareVersionId"] = this.softwareVersionId !== undefined ? this.softwareVersionId : null;
        if (this.softwareVersions && this.softwareVersions.constructor === Array) {
            data["softwareVersions"] = [];
            for (var _i = 0, _a = this.softwareVersions; _i < _a.length; _i++) {
                var item = _a[_i];
                data["softwareVersions"].push(item.toJSON());
            }
        }
        if (this.repairCodes && this.repairCodes.constructor === Array) {
            data["repairCodes"] = [];
            for (var _b = 0, _c = this.repairCodes; _b < _c.length; _b++) {
                var item = _c[_b];
                data["repairCodes"].push(item.toJSON());
            }
        }
        data["fileName"] = this.fileName !== undefined ? this.fileName : null;
        data["fileBase64Content"] = this.fileBase64Content !== undefined ? this.fileBase64Content : null;
        data["pictureUrl"] = this.pictureUrl !== undefined ? this.pictureUrl : null;
        data["countRepairCodes"] = this.countRepairCodes !== undefined ? this.countRepairCodes : null;
        return data;
    };
    return AssetDefinitionViewModel;
}());
export { AssetDefinitionViewModel };
var SoftwareVersionViewModel = /** @class */ (function () {
    function SoftwareVersionViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SoftwareVersionViewModel.prototype.init = function (data) {
        if (data) {
            this.softwareVersionId = data["softwareVersionId"] !== undefined ? data["softwareVersionId"] : null;
            this.softwareVersionNumber = data["softwareVersionNumber"] !== undefined ? data["softwareVersionNumber"] : null;
            this.description = data["description"] !== undefined ? data["description"] : null;
            this.assetDefinitionId = data["assetDefinitionId"] !== undefined ? data["assetDefinitionId"] : null;
            this.tenantId = data["tenantId"] !== undefined ? data["tenantId"] : null;
        }
    };
    SoftwareVersionViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SoftwareVersionViewModel();
        result.init(data);
        return result;
    };
    SoftwareVersionViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["softwareVersionId"] = this.softwareVersionId !== undefined ? this.softwareVersionId : null;
        data["softwareVersionNumber"] = this.softwareVersionNumber !== undefined ? this.softwareVersionNumber : null;
        data["description"] = this.description !== undefined ? this.description : null;
        data["assetDefinitionId"] = this.assetDefinitionId !== undefined ? this.assetDefinitionId : null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null;
        return data;
    };
    return SoftwareVersionViewModel;
}());
export { SoftwareVersionViewModel };
var AssetHistoryItemViewModel = /** @class */ (function () {
    function AssetHistoryItemViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AssetHistoryItemViewModel.prototype.init = function (data) {
        if (data) {
            this.date = data["date"] ? new Date(data["date"].toString()) : null;
            this.event = data["event"] !== undefined ? data["event"] : null;
            this.isPeakDevice = data["isPeakDevice"] !== undefined ? data["isPeakDevice"] : null;
            this.oldLocation = data["oldLocation"] !== undefined ? data["oldLocation"] : null;
            this.newLocation = data["newLocation"] !== undefined ? data["newLocation"] : null;
            this.rmaEventKey = data["rmaEventKey"] !== undefined ? data["rmaEventKey"] : null;
            this.rmaId = data["rmaId"] !== undefined ? data["rmaId"] : null;
            this.bundleChangeEventType = data["bundleChangeEventType"] !== undefined ? data["bundleChangeEventType"] : null;
            this.userName = data["userName"] !== undefined ? data["userName"] : null;
        }
    };
    AssetHistoryItemViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AssetHistoryItemViewModel();
        result.init(data);
        return result;
    };
    AssetHistoryItemViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : null;
        data["event"] = this.event !== undefined ? this.event : null;
        data["isPeakDevice"] = this.isPeakDevice !== undefined ? this.isPeakDevice : null;
        data["oldLocation"] = this.oldLocation !== undefined ? this.oldLocation : null;
        data["newLocation"] = this.newLocation !== undefined ? this.newLocation : null;
        data["rmaEventKey"] = this.rmaEventKey !== undefined ? this.rmaEventKey : null;
        data["rmaId"] = this.rmaId !== undefined ? this.rmaId : null;
        data["bundleChangeEventType"] = this.bundleChangeEventType !== undefined ? this.bundleChangeEventType : null;
        data["userName"] = this.userName !== undefined ? this.userName : null;
        return data;
    };
    return AssetHistoryItemViewModel;
}());
export { AssetHistoryItemViewModel };
export var AssetHistoryEvent;
(function (AssetHistoryEvent) {
    AssetHistoryEvent[AssetHistoryEvent["BundleChange"] = 0] = "BundleChange";
    AssetHistoryEvent[AssetHistoryEvent["Relocation"] = 1] = "Relocation";
    AssetHistoryEvent[AssetHistoryEvent["Rma"] = 2] = "Rma";
    AssetHistoryEvent[AssetHistoryEvent["DataChange"] = 3] = "DataChange";
    AssetHistoryEvent[AssetHistoryEvent["PeakChange"] = 4] = "PeakChange";
    AssetHistoryEvent[AssetHistoryEvent["Created"] = 5] = "Created";
    AssetHistoryEvent[AssetHistoryEvent["ServiceContractChange"] = 6] = "ServiceContractChange";
    AssetHistoryEvent[AssetHistoryEvent["ServiceContractAdded"] = 7] = "ServiceContractAdded";
    AssetHistoryEvent[AssetHistoryEvent["ServiceContractRemoved"] = 8] = "ServiceContractRemoved";
    AssetHistoryEvent[AssetHistoryEvent["Lost"] = 9] = "Lost";
    AssetHistoryEvent[AssetHistoryEvent["Found"] = 10] = "Found";
})(AssetHistoryEvent || (AssetHistoryEvent = {}));
var AssetStatusCodeGroupEditModel = /** @class */ (function () {
    function AssetStatusCodeGroupEditModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AssetStatusCodeGroupEditModel.prototype.init = function (data) {
        if (data) {
            this.assetStatusCodeGroupId = data["assetStatusCodeGroupId"] !== undefined ? data["assetStatusCodeGroupId"] : null;
            this.name = data["name"] !== undefined ? data["name"] : null;
            this.key = data["key"] !== undefined ? data["key"] : null;
            this.tenantId = data["tenantId"] !== undefined ? data["tenantId"] : null;
            this.notActive = data["notActive"] !== undefined ? data["notActive"] : null;
            this.order = data["order"] !== undefined ? data["order"] : null;
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (var _i = 0, _a = data["translations"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.translations.push(TranslationViewModel.fromJS(item));
                }
            }
        }
    };
    AssetStatusCodeGroupEditModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AssetStatusCodeGroupEditModel();
        result.init(data);
        return result;
    };
    AssetStatusCodeGroupEditModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["assetStatusCodeGroupId"] = this.assetStatusCodeGroupId !== undefined ? this.assetStatusCodeGroupId : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["key"] = this.key !== undefined ? this.key : null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null;
        data["notActive"] = this.notActive !== undefined ? this.notActive : null;
        data["order"] = this.order !== undefined ? this.order : null;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (var _i = 0, _a = this.translations; _i < _a.length; _i++) {
                var item = _a[_i];
                data["translations"].push(item.toJSON());
            }
        }
        return data;
    };
    return AssetStatusCodeGroupEditModel;
}());
export { AssetStatusCodeGroupEditModel };
var AssetStatusCodeGroupSelectViewModel = /** @class */ (function () {
    function AssetStatusCodeGroupSelectViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AssetStatusCodeGroupSelectViewModel.prototype.init = function (data) {
        if (data) {
            this.assetStatusCodeGroupId = data["assetStatusCodeGroupId"] !== undefined ? data["assetStatusCodeGroupId"] : null;
            this.name = data["name"] !== undefined ? data["name"] : null;
            this.key = data["key"] !== undefined ? data["key"] : null;
            this.tenantId = data["tenantId"] !== undefined ? data["tenantId"] : null;
            this.order = data["order"] !== undefined ? data["order"] : null;
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (var _i = 0, _a = data["translations"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.translations.push(TranslationViewModel.fromJS(item));
                }
            }
        }
    };
    AssetStatusCodeGroupSelectViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AssetStatusCodeGroupSelectViewModel();
        result.init(data);
        return result;
    };
    AssetStatusCodeGroupSelectViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["assetStatusCodeGroupId"] = this.assetStatusCodeGroupId !== undefined ? this.assetStatusCodeGroupId : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["key"] = this.key !== undefined ? this.key : null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null;
        data["order"] = this.order !== undefined ? this.order : null;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (var _i = 0, _a = this.translations; _i < _a.length; _i++) {
                var item = _a[_i];
                data["translations"].push(item.toJSON());
            }
        }
        return data;
    };
    return AssetStatusCodeGroupSelectViewModel;
}());
export { AssetStatusCodeGroupSelectViewModel };
var AssetTypeEditViewModel = /** @class */ (function () {
    function AssetTypeEditViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AssetTypeEditViewModel.prototype.init = function (data) {
        if (data) {
            this.assetTypeId = data["assetTypeId"] !== undefined ? data["assetTypeId"] : null;
            this.description = data["description"] !== undefined ? data["description"] : null;
            this.notActive = data["notActive"] !== undefined ? data["notActive"] : null;
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (var _i = 0, _a = data["translations"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.translations.push(TranslationViewModel.fromJS(item));
                }
            }
        }
    };
    AssetTypeEditViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AssetTypeEditViewModel();
        result.init(data);
        return result;
    };
    AssetTypeEditViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["assetTypeId"] = this.assetTypeId !== undefined ? this.assetTypeId : null;
        data["description"] = this.description !== undefined ? this.description : null;
        data["notActive"] = this.notActive !== undefined ? this.notActive : null;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (var _i = 0, _a = this.translations; _i < _a.length; _i++) {
                var item = _a[_i];
                data["translations"].push(item.toJSON());
            }
        }
        return data;
    };
    return AssetTypeEditViewModel;
}());
export { AssetTypeEditViewModel };
var AssetTypeViewModel = /** @class */ (function () {
    function AssetTypeViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AssetTypeViewModel.prototype.init = function (data) {
        if (data) {
            this.assetTypeId = data["assetTypeId"] !== undefined ? data["assetTypeId"] : null;
            this.description = data["description"] !== undefined ? data["description"] : null;
            this.key = data["key"] !== undefined ? data["key"] : null;
            if (data["translation"] && data["translation"].constructor === Array) {
                this.translation = [];
                for (var _i = 0, _a = data["translation"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.translation.push(TranslationViewModel.fromJS(item));
                }
            }
        }
    };
    AssetTypeViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AssetTypeViewModel();
        result.init(data);
        return result;
    };
    AssetTypeViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["assetTypeId"] = this.assetTypeId !== undefined ? this.assetTypeId : null;
        data["description"] = this.description !== undefined ? this.description : null;
        data["key"] = this.key !== undefined ? this.key : null;
        if (this.translation && this.translation.constructor === Array) {
            data["translation"] = [];
            for (var _i = 0, _a = this.translation; _i < _a.length; _i++) {
                var item = _a[_i];
                data["translation"].push(item.toJSON());
            }
        }
        return data;
    };
    return AssetTypeViewModel;
}());
export { AssetTypeViewModel };
var AssetViewModel = /** @class */ (function () {
    function AssetViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AssetViewModel.prototype.init = function (data) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : null;
            this.assetId = data["assetId"] !== undefined ? data["assetId"] : null;
            this.serialNumber = data["serialNumber"] !== undefined ? data["serialNumber"] : null;
            this.description = data["description"] !== undefined ? data["description"] : null;
            this.tenantCode = data["tenantCode"] !== undefined ? data["tenantCode"] : null;
            this.replacementDeviceSN = data["replacementDeviceSN"] !== undefined ? data["replacementDeviceSN"] : null;
            this.bookInDate = data["bookInDate"] ? new Date(data["bookInDate"].toString()) : null;
            this.approveDate = data["approveDate"] ? new Date(data["approveDate"].toString()) : null;
            this.responseDate = data["responseDate"] ? new Date(data["responseDate"].toString()) : null;
            this.notActive = data["notActive"] !== undefined ? data["notActive"] : null;
            this.isManual = data["isManual"] !== undefined ? data["isManual"] : null;
            this.isPeakDevice = data["isPeakDevice"] !== undefined ? data["isPeakDevice"] : null;
            this.deliveryStartDate = data["deliveryStartDate"] ? new Date(data["deliveryStartDate"].toString()) : null;
            this.inventoryNumber = data["inventoryNumber"] !== undefined ? data["inventoryNumber"] : null;
            this.stateOfHealth = data["stateOfHealth"] !== undefined ? data["stateOfHealth"] : null;
            this.stateOfHealthDate = data["stateOfHealthDate"] ? new Date(data["stateOfHealthDate"].toString()) : null;
            this.isInternal = data["isInternal"] !== undefined ? data["isInternal"] : null;
            this.blockedForRmaId = data["blockedForRmaId"] !== undefined ? data["blockedForRmaId"] : null;
            this.tenantType = data["tenantType"] !== undefined ? data["tenantType"] : null;
            this.isInExchangePool = data["isInExchangePool"] !== undefined ? data["isInExchangePool"] : null;
            this.canStartRMA = data["canStartRMA"] !== undefined ? data["canStartRMA"] : null;
            this.blockedForRmaIdDate = data["blockedForRmaIdDate"] ? new Date(data["blockedForRmaIdDate"].toString()) : null;
            this.tenantId = data["tenantId"] !== undefined ? data["tenantId"] : null;
            this.tenantName = data["tenantName"] !== undefined ? data["tenantName"] : null;
            this.parentTenantName = data["parentTenantName"] !== undefined ? data["parentTenantName"] : null;
            this.locationName = data["locationName"] !== undefined ? data["locationName"] : null;
            this.locationId = data["locationId"] !== undefined ? data["locationId"] : null;
            this.assetDefinitionId = data["assetDefinitionId"] !== undefined ? data["assetDefinitionId"] : null;
            this.assetDefinitionName = data["assetDefinitionName"] !== undefined ? data["assetDefinitionName"] : null;
            this.softwareVersionId = data["softwareVersionId"] !== undefined ? data["softwareVersionId"] : null;
            this.softwareVersionNumber = data["softwareVersionNumber"] !== undefined ? data["softwareVersionNumber"] : null;
            this.manufacturerName = data["manufacturerName"] !== undefined ? data["manufacturerName"] : null;
            this.assetTypeDescription = data["assetTypeDescription"] !== undefined ? data["assetTypeDescription"] : null;
            this.assetTypeKey = data["assetTypeKey"] !== undefined ? data["assetTypeKey"] : null;
            this.assetDefinitionDescription = data["assetDefinitionDescription"] !== undefined ? data["assetDefinitionDescription"] : null;
            this.contractNumber = data["contractNumber"] !== undefined ? data["contractNumber"] : null;
            this.contractValid = data["contractValid"] !== undefined ? data["contractValid"] : null;
            this.allowAdditionalRepair = data["allowAdditionalRepair"] !== undefined ? data["allowAdditionalRepair"] : null;
            this.rmaActive = data["rmaActive"] !== undefined ? data["rmaActive"] : null;
            this.rmaId = data["rmaId"] !== undefined ? data["rmaId"] : null;
            this.rmaStatus = data["rmaStatus"] !== undefined ? data["rmaStatus"] : null;
            this.rmaExchangedAssetId = data["rmaExchangedAssetId"] !== undefined ? data["rmaExchangedAssetId"] : null;
            this.rmaExchangeAssetSent = data["rmaExchangeAssetSent"] !== undefined ? data["rmaExchangeAssetSent"] : null;
            this.parentRmaExchangedAssetId = data["parentRmaExchangedAssetId"] !== undefined ? data["parentRmaExchangedAssetId"] : null;
            this.parentRmaExchangeAssetSent = data["parentRmaExchangeAssetSent"] !== undefined ? data["parentRmaExchangeAssetSent"] : null;
            this.pictureUrl = data["pictureUrl"] !== undefined ? data["pictureUrl"] : null;
            this.rmaDeviceChecked = data["rmaDeviceChecked"] !== undefined ? data["rmaDeviceChecked"] : null;
            this.rmaDeviceRepaired = data["rmaDeviceRepaired"] !== undefined ? data["rmaDeviceRepaired"] : null;
            this.rmaDeviceVerified = data["rmaDeviceVerified"] !== undefined ? data["rmaDeviceVerified"] : null;
            this.serviceContract = data["serviceContract"] ? ServiceContractViewModel.fromJS(data["serviceContract"]) : null;
            this.serialNumberOptional = data["serialNumberOptional"] !== undefined ? data["serialNumberOptional"] : null;
            this.hasRepairCenter = data["hasRepairCenter"] !== undefined ? data["hasRepairCenter"] : null;
            this.requirePostRepair = data["requirePostRepair"] !== undefined ? data["requirePostRepair"] : null;
            this.selfTestTextKeyCode = data["selfTestTextKeyCode"] !== undefined ? data["selfTestTextKeyCode"] : null;
            this.requireExchange = data["requireExchange"] !== undefined ? data["requireExchange"] : null;
            this.sendToRepairCenter = data["sendToRepairCenter"] !== undefined ? data["sendToRepairCenter"] : null;
            this.createBundleDuringExchange = data["createBundleDuringExchange"] !== undefined ? data["createBundleDuringExchange"] : null;
            this.canCreateBundle = data["canCreateBundle"] !== undefined ? data["canCreateBundle"] : null;
            this.canRepair = data["canRepair"] !== undefined ? data["canRepair"] : null;
            if (data["softwareVersions"] && data["softwareVersions"].constructor === Array) {
                this.softwareVersions = [];
                for (var _i = 0, _a = data["softwareVersions"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.softwareVersions.push(SoftwareVersionViewModel.fromJS(item));
                }
            }
            this.status = data["status"] !== undefined ? data["status"] : null;
            this.hasDeliveryService = data["hasDeliveryService"] !== undefined ? data["hasDeliveryService"] : null;
            this.isUserReseller = data["isUserReseller"] !== undefined ? data["isUserReseller"] : null;
            this.imei = data["imei"] !== undefined ? data["imei"] : null;
            this.macAddress = data["macAddress"] !== undefined ? data["macAddress"] : null;
            this.bluetoothMacAddress = data["bluetoothMacAddress"] !== undefined ? data["bluetoothMacAddress"] : null;
            this.osVersion = data["osVersion"] !== undefined ? data["osVersion"] : null;
            this.securityPatchInstalled = data["securityPatchInstalled"] !== undefined ? data["securityPatchInstalled"] : null;
            this.hasInventoryData = data["hasInventoryData"] !== undefined ? data["hasInventoryData"] : null;
            this.hasSensorData = data["hasSensorData"] !== undefined ? data["hasSensorData"] : null;
            this.hasCoordinateData = data["hasCoordinateData"] !== undefined ? data["hasCoordinateData"] : null;
            this.canRelocate = data["canRelocate"] !== undefined ? data["canRelocate"] : null;
            this.rollInTaskId = data["rollInTaskId"] !== undefined ? data["rollInTaskId"] : null;
            this.manufacturingDate = data["manufacturingDate"] ? new Date(data["manufacturingDate"].toString()) : null;
            this.acquisitionDate = data["acquisitionDate"] ? new Date(data["acquisitionDate"].toString()) : null;
            this.rollOutDate = data["rollOutDate"] ? new Date(data["rollOutDate"].toString()) : null;
            this.wlanIp = data["wlanIp"] !== undefined ? data["wlanIp"] : null;
            this.phoneNumber = data["phoneNumber"] !== undefined ? data["phoneNumber"] : null;
            this.pin = data["pin"] !== undefined ? data["pin"] : null;
            this.puk = data["puk"] !== undefined ? data["puk"] : null;
            this.purchaseDate = data["purchaseDate"] ? new Date(data["purchaseDate"].toString()) : null;
            this.guaranteeDate = data["guaranteeDate"] ? new Date(data["guaranteeDate"].toString()) : null;
            this.lastConnectionDate = data["lastConnectionDate"] ? new Date(data["lastConnectionDate"].toString()) : null;
            this.leftRepairs = data["leftRepairs"] !== undefined ? data["leftRepairs"] : null;
            this.leftRepairsNumber = data["leftRepairsNumber"] !== undefined ? data["leftRepairsNumber"] : null;
        }
    };
    AssetViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AssetViewModel();
        result.init(data);
        return result;
    };
    AssetViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null;
        data["assetId"] = this.assetId !== undefined ? this.assetId : null;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null;
        data["description"] = this.description !== undefined ? this.description : null;
        data["tenantCode"] = this.tenantCode !== undefined ? this.tenantCode : null;
        data["replacementDeviceSN"] = this.replacementDeviceSN !== undefined ? this.replacementDeviceSN : null;
        data["bookInDate"] = this.bookInDate ? this.bookInDate.toISOString() : null;
        data["approveDate"] = this.approveDate ? this.approveDate.toISOString() : null;
        data["responseDate"] = this.responseDate ? this.responseDate.toISOString() : null;
        data["notActive"] = this.notActive !== undefined ? this.notActive : null;
        data["isManual"] = this.isManual !== undefined ? this.isManual : null;
        data["isPeakDevice"] = this.isPeakDevice !== undefined ? this.isPeakDevice : null;
        data["deliveryStartDate"] = this.deliveryStartDate ? this.deliveryStartDate.toISOString() : null;
        data["inventoryNumber"] = this.inventoryNumber !== undefined ? this.inventoryNumber : null;
        data["stateOfHealth"] = this.stateOfHealth !== undefined ? this.stateOfHealth : null;
        data["stateOfHealthDate"] = this.stateOfHealthDate ? this.stateOfHealthDate.toISOString() : null;
        data["isInternal"] = this.isInternal !== undefined ? this.isInternal : null;
        data["blockedForRmaId"] = this.blockedForRmaId !== undefined ? this.blockedForRmaId : null;
        data["tenantType"] = this.tenantType !== undefined ? this.tenantType : null;
        data["isInExchangePool"] = this.isInExchangePool !== undefined ? this.isInExchangePool : null;
        data["canStartRMA"] = this.canStartRMA !== undefined ? this.canStartRMA : null;
        data["blockedForRmaIdDate"] = this.blockedForRmaIdDate ? this.blockedForRmaIdDate.toISOString() : null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null;
        data["tenantName"] = this.tenantName !== undefined ? this.tenantName : null;
        data["parentTenantName"] = this.parentTenantName !== undefined ? this.parentTenantName : null;
        data["locationName"] = this.locationName !== undefined ? this.locationName : null;
        data["locationId"] = this.locationId !== undefined ? this.locationId : null;
        data["assetDefinitionId"] = this.assetDefinitionId !== undefined ? this.assetDefinitionId : null;
        data["assetDefinitionName"] = this.assetDefinitionName !== undefined ? this.assetDefinitionName : null;
        data["softwareVersionId"] = this.softwareVersionId !== undefined ? this.softwareVersionId : null;
        data["softwareVersionNumber"] = this.softwareVersionNumber !== undefined ? this.softwareVersionNumber : null;
        data["manufacturerName"] = this.manufacturerName !== undefined ? this.manufacturerName : null;
        data["assetTypeDescription"] = this.assetTypeDescription !== undefined ? this.assetTypeDescription : null;
        data["assetTypeKey"] = this.assetTypeKey !== undefined ? this.assetTypeKey : null;
        data["assetDefinitionDescription"] = this.assetDefinitionDescription !== undefined ? this.assetDefinitionDescription : null;
        data["contractNumber"] = this.contractNumber !== undefined ? this.contractNumber : null;
        data["contractValid"] = this.contractValid !== undefined ? this.contractValid : null;
        data["allowAdditionalRepair"] = this.allowAdditionalRepair !== undefined ? this.allowAdditionalRepair : null;
        data["rmaActive"] = this.rmaActive !== undefined ? this.rmaActive : null;
        data["rmaId"] = this.rmaId !== undefined ? this.rmaId : null;
        data["rmaStatus"] = this.rmaStatus !== undefined ? this.rmaStatus : null;
        data["rmaExchangedAssetId"] = this.rmaExchangedAssetId !== undefined ? this.rmaExchangedAssetId : null;
        data["rmaExchangeAssetSent"] = this.rmaExchangeAssetSent !== undefined ? this.rmaExchangeAssetSent : null;
        data["parentRmaExchangedAssetId"] = this.parentRmaExchangedAssetId !== undefined ? this.parentRmaExchangedAssetId : null;
        data["parentRmaExchangeAssetSent"] = this.parentRmaExchangeAssetSent !== undefined ? this.parentRmaExchangeAssetSent : null;
        data["pictureUrl"] = this.pictureUrl !== undefined ? this.pictureUrl : null;
        data["rmaDeviceChecked"] = this.rmaDeviceChecked !== undefined ? this.rmaDeviceChecked : null;
        data["rmaDeviceRepaired"] = this.rmaDeviceRepaired !== undefined ? this.rmaDeviceRepaired : null;
        data["rmaDeviceVerified"] = this.rmaDeviceVerified !== undefined ? this.rmaDeviceVerified : null;
        data["serviceContract"] = this.serviceContract ? this.serviceContract.toJSON() : null;
        data["serialNumberOptional"] = this.serialNumberOptional !== undefined ? this.serialNumberOptional : null;
        data["hasRepairCenter"] = this.hasRepairCenter !== undefined ? this.hasRepairCenter : null;
        data["requirePostRepair"] = this.requirePostRepair !== undefined ? this.requirePostRepair : null;
        data["selfTestTextKeyCode"] = this.selfTestTextKeyCode !== undefined ? this.selfTestTextKeyCode : null;
        data["requireExchange"] = this.requireExchange !== undefined ? this.requireExchange : null;
        data["sendToRepairCenter"] = this.sendToRepairCenter !== undefined ? this.sendToRepairCenter : null;
        data["createBundleDuringExchange"] = this.createBundleDuringExchange !== undefined ? this.createBundleDuringExchange : null;
        data["canCreateBundle"] = this.canCreateBundle !== undefined ? this.canCreateBundle : null;
        data["canRepair"] = this.canRepair !== undefined ? this.canRepair : null;
        if (this.softwareVersions && this.softwareVersions.constructor === Array) {
            data["softwareVersions"] = [];
            for (var _i = 0, _a = this.softwareVersions; _i < _a.length; _i++) {
                var item = _a[_i];
                data["softwareVersions"].push(item.toJSON());
            }
        }
        data["status"] = this.status !== undefined ? this.status : null;
        data["hasDeliveryService"] = this.hasDeliveryService !== undefined ? this.hasDeliveryService : null;
        data["isUserReseller"] = this.isUserReseller !== undefined ? this.isUserReseller : null;
        data["imei"] = this.imei !== undefined ? this.imei : null;
        data["macAddress"] = this.macAddress !== undefined ? this.macAddress : null;
        data["bluetoothMacAddress"] = this.bluetoothMacAddress !== undefined ? this.bluetoothMacAddress : null;
        data["osVersion"] = this.osVersion !== undefined ? this.osVersion : null;
        data["securityPatchInstalled"] = this.securityPatchInstalled !== undefined ? this.securityPatchInstalled : null;
        data["hasInventoryData"] = this.hasInventoryData !== undefined ? this.hasInventoryData : null;
        data["hasSensorData"] = this.hasSensorData !== undefined ? this.hasSensorData : null;
        data["hasCoordinateData"] = this.hasCoordinateData !== undefined ? this.hasCoordinateData : null;
        data["canRelocate"] = this.canRelocate !== undefined ? this.canRelocate : null;
        data["rollInTaskId"] = this.rollInTaskId !== undefined ? this.rollInTaskId : null;
        data["manufacturingDate"] = this.manufacturingDate ? this.manufacturingDate.toISOString() : null;
        data["acquisitionDate"] = this.acquisitionDate ? this.acquisitionDate.toISOString() : null;
        data["rollOutDate"] = this.rollOutDate ? this.rollOutDate.toISOString() : null;
        data["wlanIp"] = this.wlanIp !== undefined ? this.wlanIp : null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null;
        data["pin"] = this.pin !== undefined ? this.pin : null;
        data["puk"] = this.puk !== undefined ? this.puk : null;
        data["purchaseDate"] = this.purchaseDate ? this.purchaseDate.toISOString() : null;
        data["guaranteeDate"] = this.guaranteeDate ? this.guaranteeDate.toISOString() : null;
        data["lastConnectionDate"] = this.lastConnectionDate ? this.lastConnectionDate.toISOString() : null;
        data["leftRepairs"] = this.leftRepairs !== undefined ? this.leftRepairs : null;
        data["leftRepairsNumber"] = this.leftRepairsNumber !== undefined ? this.leftRepairsNumber : null;
        return data;
    };
    return AssetViewModel;
}());
export { AssetViewModel };
var ServiceContractViewModel = /** @class */ (function () {
    function ServiceContractViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ServiceContractViewModel.prototype.init = function (data) {
        if (data) {
            this.serviceContractId = data["serviceContractId"] !== undefined ? data["serviceContractId"] : null;
            this.contractNumber = data["contractNumber"] !== undefined ? data["contractNumber"] : null;
            this.ownerTenantName = data["ownerTenantName"] !== undefined ? data["ownerTenantName"] : null;
            this.clientTenantName = data["clientTenantName"] !== undefined ? data["clientTenantName"] : null;
            this.manufacturerName = data["manufacturerName"] !== undefined ? data["manufacturerName"] : null;
            this.ownerTenantId = data["ownerTenantId"] !== undefined ? data["ownerTenantId"] : null;
            this.clientTenantId = data["clientTenantId"] !== undefined ? data["clientTenantId"] : null;
            this.manufacturerId = data["manufacturerId"] !== undefined ? data["manufacturerId"] : null;
            this.validFrom = data["validFrom"] ? new Date(data["validFrom"].toString()) : null;
            this.validEnd = data["validEnd"] ? new Date(data["validEnd"].toString()) : null;
            this.description = data["description"] !== undefined ? data["description"] : null;
            this.notActive = data["notActive"] !== undefined ? data["notActive"] : null;
            this.slidingExpirationInMonths = data["slidingExpirationInMonths"] !== undefined ? data["slidingExpirationInMonths"] : null;
        }
    };
    ServiceContractViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ServiceContractViewModel();
        result.init(data);
        return result;
    };
    ServiceContractViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["serviceContractId"] = this.serviceContractId !== undefined ? this.serviceContractId : null;
        data["contractNumber"] = this.contractNumber !== undefined ? this.contractNumber : null;
        data["ownerTenantName"] = this.ownerTenantName !== undefined ? this.ownerTenantName : null;
        data["clientTenantName"] = this.clientTenantName !== undefined ? this.clientTenantName : null;
        data["manufacturerName"] = this.manufacturerName !== undefined ? this.manufacturerName : null;
        data["ownerTenantId"] = this.ownerTenantId !== undefined ? this.ownerTenantId : null;
        data["clientTenantId"] = this.clientTenantId !== undefined ? this.clientTenantId : null;
        data["manufacturerId"] = this.manufacturerId !== undefined ? this.manufacturerId : null;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : null;
        data["validEnd"] = this.validEnd ? this.validEnd.toISOString() : null;
        data["description"] = this.description !== undefined ? this.description : null;
        data["notActive"] = this.notActive !== undefined ? this.notActive : null;
        data["slidingExpirationInMonths"] = this.slidingExpirationInMonths !== undefined ? this.slidingExpirationInMonths : null;
        return data;
    };
    return ServiceContractViewModel;
}());
export { ServiceContractViewModel };
export var Status;
(function (Status) {
    Status[Status["Active"] = 1] = "Active";
    Status[Status["Retired"] = 2] = "Retired";
    Status[Status["Lost"] = 3] = "Lost";
    Status[Status["UnderInvestigation"] = 4] = "UnderInvestigation";
})(Status || (Status = {}));
var AssetExceptionViewModel = /** @class */ (function () {
    function AssetExceptionViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AssetExceptionViewModel.prototype.init = function (data) {
        if (data) {
            this.exceptionMessage = data["exceptionMessage"] !== undefined ? data["exceptionMessage"] : null;
            this.assetId = data["assetId"] !== undefined ? data["assetId"] : null;
        }
    };
    AssetExceptionViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AssetExceptionViewModel();
        result.init(data);
        return result;
    };
    AssetExceptionViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["exceptionMessage"] = this.exceptionMessage !== undefined ? this.exceptionMessage : null;
        data["assetId"] = this.assetId !== undefined ? this.assetId : null;
        return data;
    };
    return AssetExceptionViewModel;
}());
export { AssetExceptionViewModel };
var BundleContentViewModel = /** @class */ (function () {
    function BundleContentViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BundleContentViewModel.prototype.init = function (data) {
        if (data) {
            this.bundleContentId = data["bundleContentId"] !== undefined ? data["bundleContentId"] : null;
            this.bundleContentDefinitionId = data["bundleContentDefinitionId"] !== undefined ? data["bundleContentDefinitionId"] : null;
            this.bundleDefinitionId = data["bundleDefinitionId"] !== undefined ? data["bundleDefinitionId"] : null;
            this.contentGroupId = data["contentGroupId"] !== undefined ? data["contentGroupId"] : null;
            this.assetId = data["assetId"] !== undefined ? data["assetId"] : null;
            this.tenantId = data["tenantId"] !== undefined ? data["tenantId"] : null;
            this.serialNumber = data["serialNumber"] !== undefined ? data["serialNumber"] : null;
            this.assetDefinitionId = data["assetDefinitionId"] !== undefined ? data["assetDefinitionId"] : null;
            this.assetDefinitionName = data["assetDefinitionName"] !== undefined ? data["assetDefinitionName"] : null;
            this.assetDefinitionFullName = data["assetDefinitionFullName"] !== undefined ? data["assetDefinitionFullName"] : null;
            this.pictureUrl = data["pictureUrl"] !== undefined ? data["pictureUrl"] : null;
            this.assetTypeId = data["assetTypeId"] !== undefined ? data["assetTypeId"] : null;
            this.manufacturerId = data["manufacturerId"] !== undefined ? data["manufacturerId"] : null;
            this.assetTypeDescription = data["assetTypeDescription"] !== undefined ? data["assetTypeDescription"] : null;
            this.usageType = data["usageType"] !== undefined ? data["usageType"] : null;
            this.manufacturerName = data["manufacturerName"] !== undefined ? data["manufacturerName"] : null;
            this.serialNumberOptional = data["serialNumberOptional"] !== undefined ? data["serialNumberOptional"] : null;
            this.included = data["included"] !== undefined ? data["included"] : null;
            this.sendToRepairCenter = data["sendToRepairCenter"] !== undefined ? data["sendToRepairCenter"] : null;
        }
    };
    BundleContentViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BundleContentViewModel();
        result.init(data);
        return result;
    };
    BundleContentViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["bundleContentId"] = this.bundleContentId !== undefined ? this.bundleContentId : null;
        data["bundleContentDefinitionId"] = this.bundleContentDefinitionId !== undefined ? this.bundleContentDefinitionId : null;
        data["bundleDefinitionId"] = this.bundleDefinitionId !== undefined ? this.bundleDefinitionId : null;
        data["contentGroupId"] = this.contentGroupId !== undefined ? this.contentGroupId : null;
        data["assetId"] = this.assetId !== undefined ? this.assetId : null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null;
        data["assetDefinitionId"] = this.assetDefinitionId !== undefined ? this.assetDefinitionId : null;
        data["assetDefinitionName"] = this.assetDefinitionName !== undefined ? this.assetDefinitionName : null;
        data["assetDefinitionFullName"] = this.assetDefinitionFullName !== undefined ? this.assetDefinitionFullName : null;
        data["pictureUrl"] = this.pictureUrl !== undefined ? this.pictureUrl : null;
        data["assetTypeId"] = this.assetTypeId !== undefined ? this.assetTypeId : null;
        data["manufacturerId"] = this.manufacturerId !== undefined ? this.manufacturerId : null;
        data["assetTypeDescription"] = this.assetTypeDescription !== undefined ? this.assetTypeDescription : null;
        data["usageType"] = this.usageType !== undefined ? this.usageType : null;
        data["manufacturerName"] = this.manufacturerName !== undefined ? this.manufacturerName : null;
        data["serialNumberOptional"] = this.serialNumberOptional !== undefined ? this.serialNumberOptional : null;
        data["included"] = this.included !== undefined ? this.included : null;
        data["sendToRepairCenter"] = this.sendToRepairCenter !== undefined ? this.sendToRepairCenter : null;
        return data;
    };
    return BundleContentViewModel;
}());
export { BundleContentViewModel };
var BundleDefinitionViewModel = /** @class */ (function () {
    function BundleDefinitionViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BundleDefinitionViewModel.prototype.init = function (data) {
        if (data) {
            this.bundleDefinitionId = data["bundleDefinitionId"] !== undefined ? data["bundleDefinitionId"] : null;
            this.name = data["name"] !== undefined ? data["name"] : null;
            if (data["content"] && data["content"].constructor === Array) {
                this.content = [];
                for (var _i = 0, _a = data["content"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.content.push(BundleContentDefinitionViewModel.fromJS(item));
                }
            }
        }
    };
    BundleDefinitionViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BundleDefinitionViewModel();
        result.init(data);
        return result;
    };
    BundleDefinitionViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["bundleDefinitionId"] = this.bundleDefinitionId !== undefined ? this.bundleDefinitionId : null;
        data["name"] = this.name !== undefined ? this.name : null;
        if (this.content && this.content.constructor === Array) {
            data["content"] = [];
            for (var _i = 0, _a = this.content; _i < _a.length; _i++) {
                var item = _a[_i];
                data["content"].push(item.toJSON());
            }
        }
        return data;
    };
    return BundleDefinitionViewModel;
}());
export { BundleDefinitionViewModel };
/** The comment view model. */
var CommentViewModel = /** @class */ (function () {
    function CommentViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CommentViewModel.prototype.init = function (data) {
        if (data) {
            this.commentId = data["commentId"] !== undefined ? data["commentId"] : null;
            this.commentText = data["commentText"] !== undefined ? data["commentText"] : null;
        }
    };
    CommentViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CommentViewModel();
        result.init(data);
        return result;
    };
    CommentViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["commentId"] = this.commentId !== undefined ? this.commentId : null;
        data["commentText"] = this.commentText !== undefined ? this.commentText : null;
        return data;
    };
    return CommentViewModel;
}());
export { CommentViewModel };
/** The address view model. */
var AddressViewModel = /** @class */ (function () {
    function AddressViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AddressViewModel.prototype.init = function (data) {
        if (data) {
            this.addressId = data["addressId"] !== undefined ? data["addressId"] : null;
            this.street = data["street"] !== undefined ? data["street"] : null;
            this.zipCode = data["zipCode"] !== undefined ? data["zipCode"] : null;
            this.city = data["city"] !== undefined ? data["city"] : null;
            this.state = data["state"] !== undefined ? data["state"] : null;
            this.country = data["country"] ? CountryViewModel.fromJS(data["country"]) : null;
            this.countryId = data["countryId"] !== undefined ? data["countryId"] : null;
            this.contactName = data["contactName"] !== undefined ? data["contactName"] : null;
        }
    };
    AddressViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AddressViewModel();
        result.init(data);
        return result;
    };
    AddressViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["addressId"] = this.addressId !== undefined ? this.addressId : null;
        data["street"] = this.street !== undefined ? this.street : null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : null;
        data["city"] = this.city !== undefined ? this.city : null;
        data["state"] = this.state !== undefined ? this.state : null;
        data["country"] = this.country ? this.country.toJSON() : null;
        data["countryId"] = this.countryId !== undefined ? this.countryId : null;
        data["contactName"] = this.contactName !== undefined ? this.contactName : null;
        return data;
    };
    return AddressViewModel;
}());
export { AddressViewModel };
var CountryViewModel = /** @class */ (function () {
    function CountryViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CountryViewModel.prototype.init = function (data) {
        if (data) {
            this.countryId = data["countryId"] !== undefined ? data["countryId"] : null;
            this.code = data["code"] !== undefined ? data["code"] : null;
        }
    };
    CountryViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CountryViewModel();
        result.init(data);
        return result;
    };
    CountryViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId !== undefined ? this.countryId : null;
        data["code"] = this.code !== undefined ? this.code : null;
        return data;
    };
    return CountryViewModel;
}());
export { CountryViewModel };
var BoolResultViewModel = /** @class */ (function () {
    function BoolResultViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BoolResultViewModel.prototype.init = function (data) {
        if (data) {
            this.result = data["result"] !== undefined ? data["result"] : null;
        }
    };
    BoolResultViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BoolResultViewModel();
        result.init(data);
        return result;
    };
    BoolResultViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result !== undefined ? this.result : null;
        return data;
    };
    return BoolResultViewModel;
}());
export { BoolResultViewModel };
/** Standard model for returning id after saving an entity. */
var ResponseViewModel = /** @class */ (function () {
    function ResponseViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ResponseViewModel.prototype.init = function (data) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : null;
        }
    };
    ResponseViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ResponseViewModel();
        result.init(data);
        return result;
    };
    ResponseViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null;
        return data;
    };
    return ResponseViewModel;
}());
export { ResponseViewModel };
var ContextTargetViewModel = /** @class */ (function () {
    function ContextTargetViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ContextTargetViewModel.prototype.init = function (data) {
        if (data) {
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [];
                for (var _i = 0, _a = data["data"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.data.push(ContextTargetData.fromJS(item));
                }
            }
        }
    };
    ContextTargetViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ContextTargetViewModel();
        result.init(data);
        return result;
    };
    ContextTargetViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (var _i = 0, _a = this.data; _i < _a.length; _i++) {
                var item = _a[_i];
                data["data"].push(item.toJSON());
            }
        }
        return data;
    };
    return ContextTargetViewModel;
}());
export { ContextTargetViewModel };
/** The context target data. */
var ContextTargetData = /** @class */ (function () {
    function ContextTargetData(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ContextTargetData.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"] !== undefined ? data["tenantId"] : null;
            this.code = data["code"] !== undefined ? data["code"] : null;
            this.name = data["name"] !== undefined ? data["name"] : null;
            this.contextLevelType = data["contextLevelType"] !== undefined ? data["contextLevelType"] : null;
            if (data["children"] && data["children"].constructor === Array) {
                this.children = [];
                for (var _i = 0, _a = data["children"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.children.push(ContextTargetData.fromJS(item));
                }
            }
        }
    };
    ContextTargetData.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ContextTargetData();
        result.init(data);
        return result;
    };
    ContextTargetData.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null;
        data["code"] = this.code !== undefined ? this.code : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["contextLevelType"] = this.contextLevelType !== undefined ? this.contextLevelType : null;
        if (this.children && this.children.constructor === Array) {
            data["children"] = [];
            for (var _i = 0, _a = this.children; _i < _a.length; _i++) {
                var item = _a[_i];
                data["children"].push(item.toJSON());
            }
        }
        return data;
    };
    return ContextTargetData;
}());
export { ContextTargetData };
var CurrentContextViewModel = /** @class */ (function () {
    function CurrentContextViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CurrentContextViewModel.prototype.init = function (data) {
        if (data) {
            this.context = data["context"] ? ContextData.fromJS(data["context"]) : null;
            this.settings = data["settings"] ? AccountSettingsViewModel.fromJS(data["settings"]) : null;
        }
    };
    CurrentContextViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CurrentContextViewModel();
        result.init(data);
        return result;
    };
    CurrentContextViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["context"] = this.context ? this.context.toJSON() : null;
        data["settings"] = this.settings ? this.settings.toJSON() : null;
        return data;
    };
    return CurrentContextViewModel;
}());
export { CurrentContextViewModel };
/** The context target data. */
var ContextData = /** @class */ (function () {
    function ContextData(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ContextData.prototype.init = function (data) {
        if (data) {
            if (data["tenants"] && data["tenants"].constructor === Array) {
                this.tenants = [];
                for (var _i = 0, _a = data["tenants"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.tenants.push(ContextDataItemInfo.fromJS(item));
                }
            }
            this.customContext = data["customContext"] !== undefined ? data["customContext"] : null;
            this.contextLevelType = data["contextLevelType"] !== undefined ? data["contextLevelType"] : null;
            this.userContextLevelType = data["userContextLevelType"] !== undefined ? data["userContextLevelType"] : null;
        }
    };
    ContextData.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ContextData();
        result.init(data);
        return result;
    };
    ContextData.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.tenants && this.tenants.constructor === Array) {
            data["tenants"] = [];
            for (var _i = 0, _a = this.tenants; _i < _a.length; _i++) {
                var item = _a[_i];
                data["tenants"].push(item.toJSON());
            }
        }
        data["customContext"] = this.customContext !== undefined ? this.customContext : null;
        data["contextLevelType"] = this.contextLevelType !== undefined ? this.contextLevelType : null;
        data["userContextLevelType"] = this.userContextLevelType !== undefined ? this.userContextLevelType : null;
        return data;
    };
    return ContextData;
}());
export { ContextData };
/** The context data item info. */
var ContextDataItemInfo = /** @class */ (function () {
    function ContextDataItemInfo(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ContextDataItemInfo.prototype.init = function (data) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : null;
            this.code = data["code"] !== undefined ? data["code"] : null;
            this.name = data["name"] !== undefined ? data["name"] : null;
            this.zipCode = data["zipCode"] !== undefined ? data["zipCode"] : null;
            this.city = data["city"] !== undefined ? data["city"] : null;
            this.companyName = data["companyName"] !== undefined ? data["companyName"] : null;
            this.hasConditionalChildren = data["hasConditionalChildren"] !== undefined ? data["hasConditionalChildren"] : null;
        }
    };
    ContextDataItemInfo.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ContextDataItemInfo();
        result.init(data);
        return result;
    };
    ContextDataItemInfo.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null;
        data["code"] = this.code !== undefined ? this.code : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : null;
        data["city"] = this.city !== undefined ? this.city : null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null;
        data["hasConditionalChildren"] = this.hasConditionalChildren !== undefined ? this.hasConditionalChildren : null;
        return data;
    };
    return ContextDataItemInfo;
}());
export { ContextDataItemInfo };
export var OperationContextLevel;
(function (OperationContextLevel) {
    OperationContextLevel[OperationContextLevel["Circlon"] = 10] = "Circlon";
    OperationContextLevel[OperationContextLevel["Reseller"] = 20] = "Reseller";
    OperationContextLevel[OperationContextLevel["Client"] = 30] = "Client";
    OperationContextLevel[OperationContextLevel["Location"] = 40] = "Location";
})(OperationContextLevel || (OperationContextLevel = {}));
/** The account settings view model. */
var AccountSettingsViewModel = /** @class */ (function () {
    function AccountSettingsViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AccountSettingsViewModel.prototype.init = function (data) {
        if (data) {
            this.languageSettings = data["languageSettings"] ? LanguageViewModel.fromJS(data["languageSettings"]) : null;
        }
    };
    AccountSettingsViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AccountSettingsViewModel();
        result.init(data);
        return result;
    };
    AccountSettingsViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["languageSettings"] = this.languageSettings ? this.languageSettings.toJSON() : null;
        return data;
    };
    return AccountSettingsViewModel;
}());
export { AccountSettingsViewModel };
/** The language edit view model. */
var LanguageViewModel = /** @class */ (function () {
    function LanguageViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LanguageViewModel.prototype.init = function (data) {
        if (data) {
            if (data["languages"] && data["languages"].constructor === Array) {
                this.languages = [];
                for (var _i = 0, _a = data["languages"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.languages.push(item);
                }
            }
            this.defaultLanguage = data["defaultLanguage"] !== undefined ? data["defaultLanguage"] : null;
        }
    };
    LanguageViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LanguageViewModel();
        result.init(data);
        return result;
    };
    LanguageViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.languages && this.languages.constructor === Array) {
            data["languages"] = [];
            for (var _i = 0, _a = this.languages; _i < _a.length; _i++) {
                var item = _a[_i];
                data["languages"].push(item);
            }
        }
        data["defaultLanguage"] = this.defaultLanguage !== undefined ? this.defaultLanguage : null;
        return data;
    };
    return LanguageViewModel;
}());
export { LanguageViewModel };
var BatchImportViewModel = /** @class */ (function () {
    function BatchImportViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BatchImportViewModel.prototype.init = function (data) {
        if (data) {
            this.entityType = data["entityType"] !== undefined ? data["entityType"] : null;
            this.tenantId = data["tenantId"] !== undefined ? data["tenantId"] : null;
            if (data["entities"] && data["entities"].constructor === Array) {
                this.entities = [];
                for (var _i = 0, _a = data["entities"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.entities.push(item);
                }
            }
            this.importOnValidationSuccess = data["importOnValidationSuccess"] !== undefined ? data["importOnValidationSuccess"] : null;
        }
    };
    BatchImportViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BatchImportViewModel();
        result.init(data);
        return result;
    };
    BatchImportViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["entityType"] = this.entityType !== undefined ? this.entityType : null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null;
        if (this.entities && this.entities.constructor === Array) {
            data["entities"] = [];
            for (var _i = 0, _a = this.entities; _i < _a.length; _i++) {
                var item = _a[_i];
                data["entities"].push(item);
            }
        }
        data["importOnValidationSuccess"] = this.importOnValidationSuccess !== undefined ? this.importOnValidationSuccess : null;
        return data;
    };
    return BatchImportViewModel;
}());
export { BatchImportViewModel };
var ImportJobIssueViewModel = /** @class */ (function () {
    function ImportJobIssueViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ImportJobIssueViewModel.prototype.init = function (data) {
        if (data) {
            this.importJobIssueId = data["importJobIssueId"] !== undefined ? data["importJobIssueId"] : null;
            this.importJobId = data["importJobId"] !== undefined ? data["importJobId"] : null;
            this.rowNumber = data["rowNumber"] !== undefined ? data["rowNumber"] : null;
            this.columnName = data["columnName"] !== undefined ? data["columnName"] : null;
            this.issue = data["issue"] !== undefined ? data["issue"] : null;
        }
    };
    ImportJobIssueViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ImportJobIssueViewModel();
        result.init(data);
        return result;
    };
    ImportJobIssueViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["importJobIssueId"] = this.importJobIssueId !== undefined ? this.importJobIssueId : null;
        data["importJobId"] = this.importJobId !== undefined ? this.importJobId : null;
        data["rowNumber"] = this.rowNumber !== undefined ? this.rowNumber : null;
        data["columnName"] = this.columnName !== undefined ? this.columnName : null;
        data["issue"] = this.issue !== undefined ? this.issue : null;
        return data;
    };
    return ImportJobIssueViewModel;
}());
export { ImportJobIssueViewModel };
var ImportJobViewModel = /** @class */ (function () {
    function ImportJobViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ImportJobViewModel.prototype.init = function (data) {
        if (data) {
            this.importJobId = data["importJobId"] !== undefined ? data["importJobId"] : null;
            this.userId = data["userId"] !== undefined ? data["userId"] : null;
            this.entityType = data["entityType"] !== undefined ? data["entityType"] : null;
            this.contentId = data["contentId"] !== undefined ? data["contentId"] : null;
            this.invalidContentId = data["invalidContentId"] !== undefined ? data["invalidContentId"] : null;
            this.status = data["status"] !== undefined ? data["status"] : null;
            this.dateCreated = data["dateCreated"] ? new Date(data["dateCreated"].toString()) : null;
            this.lastChanged = data["lastChanged"] ? new Date(data["lastChanged"].toString()) : null;
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : null;
            this.finishTime = data["finishTime"] ? new Date(data["finishTime"].toString()) : null;
            this.totalRowCount = data["totalRowCount"] !== undefined ? data["totalRowCount"] : null;
            this.processedRowCount = data["processedRowCount"] !== undefined ? data["processedRowCount"] : null;
            this.successfulRowCount = data["successfulRowCount"] !== undefined ? data["successfulRowCount"] : null;
            this.failedRowCount = data["failedRowCount"] !== undefined ? data["failedRowCount"] : null;
            this.notes = data["notes"] !== undefined ? data["notes"] : null;
            if (data["importJobIssues"] && data["importJobIssues"].constructor === Array) {
                this.importJobIssues = [];
                for (var _i = 0, _a = data["importJobIssues"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.importJobIssues.push(ImportJobIssueViewModel.fromJS(item));
                }
            }
        }
    };
    ImportJobViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ImportJobViewModel();
        result.init(data);
        return result;
    };
    ImportJobViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["importJobId"] = this.importJobId !== undefined ? this.importJobId : null;
        data["userId"] = this.userId !== undefined ? this.userId : null;
        data["entityType"] = this.entityType !== undefined ? this.entityType : null;
        data["contentId"] = this.contentId !== undefined ? this.contentId : null;
        data["invalidContentId"] = this.invalidContentId !== undefined ? this.invalidContentId : null;
        data["status"] = this.status !== undefined ? this.status : null;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : null;
        data["lastChanged"] = this.lastChanged ? this.lastChanged.toISOString() : null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : null;
        data["finishTime"] = this.finishTime ? this.finishTime.toISOString() : null;
        data["totalRowCount"] = this.totalRowCount !== undefined ? this.totalRowCount : null;
        data["processedRowCount"] = this.processedRowCount !== undefined ? this.processedRowCount : null;
        data["successfulRowCount"] = this.successfulRowCount !== undefined ? this.successfulRowCount : null;
        data["failedRowCount"] = this.failedRowCount !== undefined ? this.failedRowCount : null;
        data["notes"] = this.notes !== undefined ? this.notes : null;
        if (this.importJobIssues && this.importJobIssues.constructor === Array) {
            data["importJobIssues"] = [];
            for (var _i = 0, _a = this.importJobIssues; _i < _a.length; _i++) {
                var item = _a[_i];
                data["importJobIssues"].push(item.toJSON());
            }
        }
        return data;
    };
    return ImportJobViewModel;
}());
export { ImportJobViewModel };
export var ImportJobStatus;
(function (ImportJobStatus) {
    ImportJobStatus[ImportJobStatus["New"] = 0] = "New";
    ImportJobStatus[ImportJobStatus["Running"] = 1] = "Running";
    ImportJobStatus[ImportJobStatus["Finished"] = 2] = "Finished";
    ImportJobStatus[ImportJobStatus["Canceled"] = 9] = "Canceled";
})(ImportJobStatus || (ImportJobStatus = {}));
var ImportViewModel = /** @class */ (function () {
    function ImportViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ImportViewModel.prototype.init = function (data) {
        if (data) {
            this.entity = data["entity"] !== undefined ? data["entity"] : null;
            this.fileBase64Content = data["fileBase64Content"] !== undefined ? data["fileBase64Content"] : null;
            this.fileExtenstion = data["fileExtenstion"] !== undefined ? data["fileExtenstion"] : null;
            this.tenantId = data["tenantId"] !== undefined ? data["tenantId"] : null;
            this.clientTenantId = data["clientTenantId"] !== undefined ? data["clientTenantId"] : null;
            this.assetDefinitionId = data["assetDefinitionId"] !== undefined ? data["assetDefinitionId"] : null;
            this.roleId = data["roleId"] !== undefined ? data["roleId"] : null;
            this.health = data["health"] !== undefined ? data["health"] : null;
        }
    };
    ImportViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ImportViewModel();
        result.init(data);
        return result;
    };
    ImportViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["entity"] = this.entity !== undefined ? this.entity : null;
        data["fileBase64Content"] = this.fileBase64Content !== undefined ? this.fileBase64Content : null;
        data["fileExtenstion"] = this.fileExtenstion !== undefined ? this.fileExtenstion : null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null;
        data["clientTenantId"] = this.clientTenantId !== undefined ? this.clientTenantId : null;
        data["assetDefinitionId"] = this.assetDefinitionId !== undefined ? this.assetDefinitionId : null;
        data["roleId"] = this.roleId !== undefined ? this.roleId : null;
        data["health"] = this.health !== undefined ? this.health : null;
        return data;
    };
    return ImportViewModel;
}());
export { ImportViewModel };
var AssetImportViewModel = /** @class */ (function () {
    function AssetImportViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AssetImportViewModel.prototype.init = function (data) {
        if (data) {
            this.serialNumber = data["serialNumber"] !== undefined ? data["serialNumber"] : null;
            this.alternativeNumber = data["alternativeNumber"] !== undefined ? data["alternativeNumber"] : null;
            this.imei = data["imei"] !== undefined ? data["imei"] : null;
            this.macAddress = data["macAddress"] !== undefined ? data["macAddress"] : null;
            this.bluetoothMacAddress = data["bluetoothMacAddress"] !== undefined ? data["bluetoothMacAddress"] : null;
            this.isPeakDevice = data["isPeakDevice"] !== undefined ? data["isPeakDevice"] : null;
            this.softwareVersionNumber = data["softwareVersionNumber"] !== undefined ? data["softwareVersionNumber"] : null;
            this.contractNumber = data["contractNumber"] !== undefined ? data["contractNumber"] : null;
            this.location = data["location"] !== undefined ? data["location"] : null;
            this.parentLocation = data["parentLocation"] !== undefined ? data["parentLocation"] : null;
            this.assetDefinitionId = data["assetDefinitionId"] !== undefined ? data["assetDefinitionId"] : null;
            this.manufacturingDate = data["manufacturingDate"] ? new Date(data["manufacturingDate"].toString()) : null;
            this.acquisitionDate = data["acquisitionDate"] ? new Date(data["acquisitionDate"].toString()) : null;
            this.rollOutDate = data["rollOutDate"] ? new Date(data["rollOutDate"].toString()) : null;
            this.wlanIp = data["wlanIp"] !== undefined ? data["wlanIp"] : null;
            this.phoneNumber = data["phoneNumber"] !== undefined ? data["phoneNumber"] : null;
            this.pin = data["pin"] !== undefined ? data["pin"] : null;
            this.puk = data["puk"] !== undefined ? data["puk"] : null;
            if (data["validationIssues"] && data["validationIssues"].constructor === Array) {
                this.validationIssues = [];
                for (var _i = 0, _a = data["validationIssues"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.validationIssues.push(ImportValidationIssueModel.fromJS(item));
                }
            }
        }
    };
    AssetImportViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AssetImportViewModel();
        result.init(data);
        return result;
    };
    AssetImportViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null;
        data["alternativeNumber"] = this.alternativeNumber !== undefined ? this.alternativeNumber : null;
        data["imei"] = this.imei !== undefined ? this.imei : null;
        data["macAddress"] = this.macAddress !== undefined ? this.macAddress : null;
        data["bluetoothMacAddress"] = this.bluetoothMacAddress !== undefined ? this.bluetoothMacAddress : null;
        data["isPeakDevice"] = this.isPeakDevice !== undefined ? this.isPeakDevice : null;
        data["softwareVersionNumber"] = this.softwareVersionNumber !== undefined ? this.softwareVersionNumber : null;
        data["contractNumber"] = this.contractNumber !== undefined ? this.contractNumber : null;
        data["location"] = this.location !== undefined ? this.location : null;
        data["parentLocation"] = this.parentLocation !== undefined ? this.parentLocation : null;
        data["assetDefinitionId"] = this.assetDefinitionId !== undefined ? this.assetDefinitionId : null;
        data["manufacturingDate"] = this.manufacturingDate ? this.manufacturingDate.toISOString() : null;
        data["acquisitionDate"] = this.acquisitionDate ? this.acquisitionDate.toISOString() : null;
        data["rollOutDate"] = this.rollOutDate ? this.rollOutDate.toISOString() : null;
        data["wlanIp"] = this.wlanIp !== undefined ? this.wlanIp : null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null;
        data["pin"] = this.pin !== undefined ? this.pin : null;
        data["puk"] = this.puk !== undefined ? this.puk : null;
        if (this.validationIssues && this.validationIssues.constructor === Array) {
            data["validationIssues"] = [];
            for (var _i = 0, _a = this.validationIssues; _i < _a.length; _i++) {
                var item = _a[_i];
                data["validationIssues"].push(item.toJSON());
            }
        }
        return data;
    };
    return AssetImportViewModel;
}());
export { AssetImportViewModel };
var ImportValidationIssueModel = /** @class */ (function () {
    function ImportValidationIssueModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ImportValidationIssueModel.prototype.init = function (data) {
        if (data) {
            this.column = data["column"] !== undefined ? data["column"] : null;
            this.validationIssue = data["validationIssue"] !== undefined ? data["validationIssue"] : null;
            this.lineNumber = data["lineNumber"] !== undefined ? data["lineNumber"] : null;
        }
    };
    ImportValidationIssueModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ImportValidationIssueModel();
        result.init(data);
        return result;
    };
    ImportValidationIssueModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["column"] = this.column !== undefined ? this.column : null;
        data["validationIssue"] = this.validationIssue !== undefined ? this.validationIssue : null;
        data["lineNumber"] = this.lineNumber !== undefined ? this.lineNumber : null;
        return data;
    };
    return ImportValidationIssueModel;
}());
export { ImportValidationIssueModel };
var ServiceContractBatchImportViewModel = /** @class */ (function () {
    function ServiceContractBatchImportViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ServiceContractBatchImportViewModel.prototype.init = function (data) {
        if (data) {
            this.serialNumber = data["serialNumber"] !== undefined ? data["serialNumber"] : null;
            this.contractNumber = data["contractNumber"] !== undefined ? data["contractNumber"] : null;
            this.tenantId = data["tenantId"] !== undefined ? data["tenantId"] : null;
            this.assetDefinitionId = data["assetDefinitionId"] !== undefined ? data["assetDefinitionId"] : null;
            if (data["validationIssues"] && data["validationIssues"].constructor === Array) {
                this.validationIssues = [];
                for (var _i = 0, _a = data["validationIssues"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.validationIssues.push(ImportValidationIssueModel.fromJS(item));
                }
            }
        }
    };
    ServiceContractBatchImportViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ServiceContractBatchImportViewModel();
        result.init(data);
        return result;
    };
    ServiceContractBatchImportViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null;
        data["contractNumber"] = this.contractNumber !== undefined ? this.contractNumber : null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null;
        data["assetDefinitionId"] = this.assetDefinitionId !== undefined ? this.assetDefinitionId : null;
        if (this.validationIssues && this.validationIssues.constructor === Array) {
            data["validationIssues"] = [];
            for (var _i = 0, _a = this.validationIssues; _i < _a.length; _i++) {
                var item = _a[_i];
                data["validationIssues"].push(item.toJSON());
            }
        }
        return data;
    };
    return ServiceContractBatchImportViewModel;
}());
export { ServiceContractBatchImportViewModel };
var ServiceContractImportViewModel = /** @class */ (function () {
    function ServiceContractImportViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ServiceContractImportViewModel.prototype.init = function (data) {
        if (data) {
            this.contractNumber = data["contractNumber"] !== undefined ? data["contractNumber"] : null;
            this.clientTenantId = data["clientTenantId"] !== undefined ? data["clientTenantId"] : null;
            this.manufacturerId = data["manufacturerId"] !== undefined ? data["manufacturerId"] : null;
            this.validFrom = data["validFrom"] ? new Date(data["validFrom"].toString()) : null;
            this.validTo = data["validTo"] ? new Date(data["validTo"].toString()) : null;
            this.description = data["description"] !== undefined ? data["description"] : null;
            if (data["validationIssues"] && data["validationIssues"].constructor === Array) {
                this.validationIssues = [];
                for (var _i = 0, _a = data["validationIssues"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.validationIssues.push(ImportValidationIssueModel.fromJS(item));
                }
            }
        }
    };
    ServiceContractImportViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ServiceContractImportViewModel();
        result.init(data);
        return result;
    };
    ServiceContractImportViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["contractNumber"] = this.contractNumber !== undefined ? this.contractNumber : null;
        data["clientTenantId"] = this.clientTenantId !== undefined ? this.clientTenantId : null;
        data["manufacturerId"] = this.manufacturerId !== undefined ? this.manufacturerId : null;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : null;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : null;
        data["description"] = this.description !== undefined ? this.description : null;
        if (this.validationIssues && this.validationIssues.constructor === Array) {
            data["validationIssues"] = [];
            for (var _i = 0, _a = this.validationIssues; _i < _a.length; _i++) {
                var item = _a[_i];
                data["validationIssues"].push(item.toJSON());
            }
        }
        return data;
    };
    return ServiceContractImportViewModel;
}());
export { ServiceContractImportViewModel };
var UserImportViewModel = /** @class */ (function () {
    function UserImportViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserImportViewModel.prototype.init = function (data) {
        if (data) {
            this.firstName = data["firstName"] !== undefined ? data["firstName"] : null;
            this.lastName = data["lastName"] !== undefined ? data["lastName"] : null;
            this.locationName = data["locationName"] !== undefined ? data["locationName"] : null;
            this.email = data["email"] !== undefined ? data["email"] : null;
            if (data["validationIssues"] && data["validationIssues"].constructor === Array) {
                this.validationIssues = [];
                for (var _i = 0, _a = data["validationIssues"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.validationIssues.push(ImportValidationIssueModel.fromJS(item));
                }
            }
            this.parentLocationName = data["parentLocationName"] !== undefined ? data["parentLocationName"] : null;
            this.roleId = data["roleId"] !== undefined ? data["roleId"] : null;
        }
    };
    UserImportViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserImportViewModel();
        result.init(data);
        return result;
    };
    UserImportViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null;
        data["locationName"] = this.locationName !== undefined ? this.locationName : null;
        data["email"] = this.email !== undefined ? this.email : null;
        if (this.validationIssues && this.validationIssues.constructor === Array) {
            data["validationIssues"] = [];
            for (var _i = 0, _a = this.validationIssues; _i < _a.length; _i++) {
                var item = _a[_i];
                data["validationIssues"].push(item.toJSON());
            }
        }
        data["parentLocationName"] = this.parentLocationName !== undefined ? this.parentLocationName : null;
        data["roleId"] = this.roleId !== undefined ? this.roleId : null;
        return data;
    };
    return UserImportViewModel;
}());
export { UserImportViewModel };
/** Feature view model */
var FeatureViewModel = /** @class */ (function () {
    function FeatureViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FeatureViewModel.prototype.init = function (data) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : null;
            this.displayName = data["displayName"] !== undefined ? data["displayName"] : null;
            if (data["permissions"] && data["permissions"].constructor === Array) {
                this.permissions = [];
                for (var _i = 0, _a = data["permissions"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.permissions.push(item);
                }
            }
        }
    };
    FeatureViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FeatureViewModel();
        result.init(data);
        return result;
    };
    FeatureViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null;
        data["displayName"] = this.displayName !== undefined ? this.displayName : null;
        if (this.permissions && this.permissions.constructor === Array) {
            data["permissions"] = [];
            for (var _i = 0, _a = this.permissions; _i < _a.length; _i++) {
                var item = _a[_i];
                data["permissions"].push(item);
            }
        }
        return data;
    };
    return FeatureViewModel;
}());
export { FeatureViewModel };
/** The module feature view model. */
var ModuleFeatureViewModel = /** @class */ (function () {
    function ModuleFeatureViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ModuleFeatureViewModel.prototype.init = function (data) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : null;
            this.displayName = data["displayName"] !== undefined ? data["displayName"] : null;
            this.description = data["description"] !== undefined ? data["description"] : null;
            this.isCoreFeature = data["isCoreFeature"] !== undefined ? data["isCoreFeature"] : null;
        }
    };
    ModuleFeatureViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ModuleFeatureViewModel();
        result.init(data);
        return result;
    };
    ModuleFeatureViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null;
        data["displayName"] = this.displayName !== undefined ? this.displayName : null;
        data["description"] = this.description !== undefined ? this.description : null;
        data["isCoreFeature"] = this.isCoreFeature !== undefined ? this.isCoreFeature : null;
        return data;
    };
    return ModuleFeatureViewModel;
}());
export { ModuleFeatureViewModel };
/** Module allowed to user */
var ModuleInfoViewModel = /** @class */ (function () {
    function ModuleInfoViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ModuleInfoViewModel.prototype.init = function (data) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : null;
            if (data["features"] && data["features"].constructor === Array) {
                this.features = [];
                for (var _i = 0, _a = data["features"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.features.push(FeatureViewModel.fromJS(item));
                }
            }
            if (data["permissions"] && data["permissions"].constructor === Array) {
                this.permissions = [];
                for (var _b = 0, _c = data["permissions"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.permissions.push(item);
                }
            }
        }
    };
    ModuleInfoViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ModuleInfoViewModel();
        result.init(data);
        return result;
    };
    ModuleInfoViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null;
        if (this.features && this.features.constructor === Array) {
            data["features"] = [];
            for (var _i = 0, _a = this.features; _i < _a.length; _i++) {
                var item = _a[_i];
                data["features"].push(item.toJSON());
            }
        }
        if (this.permissions && this.permissions.constructor === Array) {
            data["permissions"] = [];
            for (var _b = 0, _c = this.permissions; _b < _c.length; _b++) {
                var item = _c[_b];
                data["permissions"].push(item);
            }
        }
        return data;
    };
    return ModuleInfoViewModel;
}());
export { ModuleInfoViewModel };
/** The module view model. */
var ModuleViewModel = /** @class */ (function () {
    function ModuleViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ModuleViewModel.prototype.init = function (data) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : null;
            this.displayName = data["displayName"] !== undefined ? data["displayName"] : null;
            this.description = data["description"] !== undefined ? data["description"] : null;
            this.isCoreModule = data["isCoreModule"] !== undefined ? data["isCoreModule"] : null;
            if (data["features"] && data["features"].constructor === Array) {
                this.features = [];
                for (var _i = 0, _a = data["features"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.features.push(ModuleFeatureViewModel.fromJS(item));
                }
            }
            if (data["coreFeatures"] && data["coreFeatures"].constructor === Array) {
                this.coreFeatures = [];
                for (var _b = 0, _c = data["coreFeatures"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.coreFeatures.push(ModuleFeatureViewModel.fromJS(item));
                }
            }
            this.settings = data["settings"] ? ModuleSettings.fromJS(data["settings"]) : null;
        }
    };
    ModuleViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ModuleViewModel();
        result.init(data);
        return result;
    };
    ModuleViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null;
        data["displayName"] = this.displayName !== undefined ? this.displayName : null;
        data["description"] = this.description !== undefined ? this.description : null;
        data["isCoreModule"] = this.isCoreModule !== undefined ? this.isCoreModule : null;
        if (this.features && this.features.constructor === Array) {
            data["features"] = [];
            for (var _i = 0, _a = this.features; _i < _a.length; _i++) {
                var item = _a[_i];
                data["features"].push(item.toJSON());
            }
        }
        if (this.coreFeatures && this.coreFeatures.constructor === Array) {
            data["coreFeatures"] = [];
            for (var _b = 0, _c = this.coreFeatures; _b < _c.length; _b++) {
                var item = _c[_b];
                data["coreFeatures"].push(item.toJSON());
            }
        }
        data["settings"] = this.settings ? this.settings.toJSON() : null;
        return data;
    };
    return ModuleViewModel;
}());
export { ModuleViewModel };
var ModuleSettings = /** @class */ (function () {
    function ModuleSettings(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ModuleSettings.prototype.init = function (data) {
        if (data) {
        }
    };
    ModuleSettings.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ModuleSettings();
        result.init(data);
        return result;
    };
    ModuleSettings.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        return data;
    };
    return ModuleSettings;
}());
export { ModuleSettings };
/** The tenant module view model. */
var TenantModuleViewModel = /** @class */ (function () {
    function TenantModuleViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantModuleViewModel.prototype.init = function (data) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : null;
            if (data["enabledFeatures"] && data["enabledFeatures"].constructor === Array) {
                this.enabledFeatures = [];
                for (var _i = 0, _a = data["enabledFeatures"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.enabledFeatures.push(ModuleFeatureViewModel.fromJS(item));
                }
            }
            this.settings = data["settings"] ? ModuleSettings.fromJS(data["settings"]) : null;
            this.isEnabled = data["isEnabled"] !== undefined ? data["isEnabled"] : null;
        }
    };
    TenantModuleViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantModuleViewModel();
        result.init(data);
        return result;
    };
    TenantModuleViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null;
        if (this.enabledFeatures && this.enabledFeatures.constructor === Array) {
            data["enabledFeatures"] = [];
            for (var _i = 0, _a = this.enabledFeatures; _i < _a.length; _i++) {
                var item = _a[_i];
                data["enabledFeatures"].push(item.toJSON());
            }
        }
        data["settings"] = this.settings ? this.settings.toJSON() : null;
        data["isEnabled"] = this.isEnabled !== undefined ? this.isEnabled : null;
        return data;
    };
    return TenantModuleViewModel;
}());
export { TenantModuleViewModel };
/** Module allowed to user */
var UserModuleViewModel = /** @class */ (function () {
    function UserModuleViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserModuleViewModel.prototype.init = function (data) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : null;
            if (data["enabledFeatures"] && data["enabledFeatures"].constructor === Array) {
                this.enabledFeatures = [];
                for (var _i = 0, _a = data["enabledFeatures"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.enabledFeatures.push(FeatureViewModel.fromJS(item));
                }
            }
            if (data["permissions"] && data["permissions"].constructor === Array) {
                this.permissions = [];
                for (var _b = 0, _c = data["permissions"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.permissions.push(item);
                }
            }
        }
    };
    UserModuleViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserModuleViewModel();
        result.init(data);
        return result;
    };
    UserModuleViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null;
        if (this.enabledFeatures && this.enabledFeatures.constructor === Array) {
            data["enabledFeatures"] = [];
            for (var _i = 0, _a = this.enabledFeatures; _i < _a.length; _i++) {
                var item = _a[_i];
                data["enabledFeatures"].push(item.toJSON());
            }
        }
        if (this.permissions && this.permissions.constructor === Array) {
            data["permissions"] = [];
            for (var _b = 0, _c = this.permissions; _b < _c.length; _b++) {
                var item = _c[_b];
                data["permissions"].push(item);
            }
        }
        return data;
    };
    return UserModuleViewModel;
}());
export { UserModuleViewModel };
var AccessoryModel = /** @class */ (function () {
    function AccessoryModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AccessoryModel.prototype.init = function (data) {
        if (data) {
            this.name = data["name"] !== undefined ? data["name"] : null;
            this.serialNumber = data["serialNumber"] !== undefined ? data["serialNumber"] : null;
        }
    };
    AccessoryModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AccessoryModel();
        result.init(data);
        return result;
    };
    AccessoryModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null;
        return data;
    };
    return AccessoryModel;
}());
export { AccessoryModel };
var CheckRepairViewModel = /** @class */ (function () {
    function CheckRepairViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CheckRepairViewModel.prototype.init = function (data) {
        if (data) {
            if (data["symptomCodes"] && data["symptomCodes"].constructor === Array) {
                this.symptomCodes = [];
                for (var _i = 0, _a = data["symptomCodes"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.symptomCodes.push(AssetStatusCodeViewModel.fromJS(item));
                }
            }
            if (data["serviceCodes"] && data["serviceCodes"].constructor === Array) {
                this.serviceCodes = [];
                for (var _b = 0, _c = data["serviceCodes"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.serviceCodes.push(AssetStatusCodeViewModel.fromJS(item));
                }
            }
            if (data["bundleContent"] && data["bundleContent"].constructor === Array) {
                this.bundleContent = [];
                for (var _d = 0, _e = data["bundleContent"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.bundleContent.push(BundleContentViewModel.fromJS(item));
                }
            }
            this.description = data["description"] !== undefined ? data["description"] : null;
        }
    };
    CheckRepairViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CheckRepairViewModel();
        result.init(data);
        return result;
    };
    CheckRepairViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.symptomCodes && this.symptomCodes.constructor === Array) {
            data["symptomCodes"] = [];
            for (var _i = 0, _a = this.symptomCodes; _i < _a.length; _i++) {
                var item = _a[_i];
                data["symptomCodes"].push(item.toJSON());
            }
        }
        if (this.serviceCodes && this.serviceCodes.constructor === Array) {
            data["serviceCodes"] = [];
            for (var _b = 0, _c = this.serviceCodes; _b < _c.length; _b++) {
                var item = _c[_b];
                data["serviceCodes"].push(item.toJSON());
            }
        }
        if (this.bundleContent && this.bundleContent.constructor === Array) {
            data["bundleContent"] = [];
            for (var _d = 0, _e = this.bundleContent; _d < _e.length; _d++) {
                var item = _e[_d];
                data["bundleContent"].push(item.toJSON());
            }
        }
        data["description"] = this.description !== undefined ? this.description : null;
        return data;
    };
    return CheckRepairViewModel;
}());
export { CheckRepairViewModel };
var CheckSerialViewModel = /** @class */ (function () {
    function CheckSerialViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CheckSerialViewModel.prototype.init = function (data) {
        if (data) {
            this.serialNumber = data["serialNumber"] !== undefined ? data["serialNumber"] : null;
            this.rmaId = data["rmaId"] !== undefined ? data["rmaId"] : null;
        }
    };
    CheckSerialViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CheckSerialViewModel();
        result.init(data);
        return result;
    };
    CheckSerialViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null;
        data["rmaId"] = this.rmaId !== undefined ? this.rmaId : null;
        return data;
    };
    return CheckSerialViewModel;
}());
export { CheckSerialViewModel };
var CloseViewModel = /** @class */ (function () {
    function CloseViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CloseViewModel.prototype.init = function (data) {
        if (data) {
            this.reason = data["reason"] !== undefined ? data["reason"] : null;
        }
    };
    CloseViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CloseViewModel();
        result.init(data);
        return result;
    };
    CloseViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason !== undefined ? this.reason : null;
        return data;
    };
    return CloseViewModel;
}());
export { CloseViewModel };
/** View model for the RMA repair actions. */
var RepairViewModel = /** @class */ (function () {
    function RepairViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RepairViewModel.prototype.init = function (data) {
        if (data) {
            if (data["repairCodes"] && data["repairCodes"].constructor === Array) {
                this.repairCodes = [];
                for (var _i = 0, _a = data["repairCodes"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.repairCodes.push(AssetStatusCodeViewModel.fromJS(item));
                }
            }
            this.repairStartDate = data["repairStartDate"] ? new Date(data["repairStartDate"].toString()) : null;
            if (data["bundleContent"] && data["bundleContent"].constructor === Array) {
                this.bundleContent = [];
                for (var _b = 0, _c = data["bundleContent"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.bundleContent.push(BundleContentViewModel.fromJS(item));
                }
            }
        }
    };
    RepairViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RepairViewModel();
        result.init(data);
        return result;
    };
    RepairViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.repairCodes && this.repairCodes.constructor === Array) {
            data["repairCodes"] = [];
            for (var _i = 0, _a = this.repairCodes; _i < _a.length; _i++) {
                var item = _a[_i];
                data["repairCodes"].push(item.toJSON());
            }
        }
        data["repairStartDate"] = this.repairStartDate ? this.repairStartDate.toISOString() : null;
        if (this.bundleContent && this.bundleContent.constructor === Array) {
            data["bundleContent"] = [];
            for (var _b = 0, _c = this.bundleContent; _b < _c.length; _b++) {
                var item = _c[_b];
                data["bundleContent"].push(item.toJSON());
            }
        }
        return data;
    };
    return RepairViewModel;
}());
export { RepairViewModel };
var RmaAccessoriesResultViewModel = /** @class */ (function () {
    function RmaAccessoriesResultViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RmaAccessoriesResultViewModel.prototype.init = function (data) {
        if (data) {
            this.accessoriesFromAnotherBundle = data["accessoriesFromAnotherBundle"] !== undefined ? data["accessoriesFromAnotherBundle"] : null;
        }
    };
    RmaAccessoriesResultViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RmaAccessoriesResultViewModel();
        result.init(data);
        return result;
    };
    RmaAccessoriesResultViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["accessoriesFromAnotherBundle"] = this.accessoriesFromAnotherBundle !== undefined ? this.accessoriesFromAnotherBundle : null;
        return data;
    };
    return RmaAccessoriesResultViewModel;
}());
export { RmaAccessoriesResultViewModel };
var RmaBundleViewModel = /** @class */ (function () {
    function RmaBundleViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RmaBundleViewModel.prototype.init = function (data) {
        if (data) {
            this.assetId = data["assetId"] !== undefined ? data["assetId"] : null;
            this.assetDefinitionId = data["assetDefinitionId"] !== undefined ? data["assetDefinitionId"] : null;
            if (data["bundleContentList"] && data["bundleContentList"].constructor === Array) {
                this.bundleContentList = [];
                for (var _i = 0, _a = data["bundleContentList"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.bundleContentList.push(BundleContentViewModel.fromJS(item));
                }
            }
        }
    };
    RmaBundleViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RmaBundleViewModel();
        result.init(data);
        return result;
    };
    RmaBundleViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["assetId"] = this.assetId !== undefined ? this.assetId : null;
        data["assetDefinitionId"] = this.assetDefinitionId !== undefined ? this.assetDefinitionId : null;
        if (this.bundleContentList && this.bundleContentList.constructor === Array) {
            data["bundleContentList"] = [];
            for (var _i = 0, _a = this.bundleContentList; _i < _a.length; _i++) {
                var item = _a[_i];
                data["bundleContentList"].push(item.toJSON());
            }
        }
        return data;
    };
    return RmaBundleViewModel;
}());
export { RmaBundleViewModel };
var RmaCloseAfterRepairViewModel = /** @class */ (function () {
    function RmaCloseAfterRepairViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RmaCloseAfterRepairViewModel.prototype.init = function (data) {
        if (data) {
            this.rmaId = data["rmaId"] !== undefined ? data["rmaId"] : null;
            this.assetWasExchanged = data["assetWasExchanged"] !== undefined ? data["assetWasExchanged"] : null;
            this.assetLocation = data["assetLocation"] !== undefined ? data["assetLocation"] : null;
            this.closed = data["closed"] !== undefined ? data["closed"] : null;
            this.exceptionMessage = data["exceptionMessage"] !== undefined ? data["exceptionMessage"] : null;
        }
    };
    RmaCloseAfterRepairViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RmaCloseAfterRepairViewModel();
        result.init(data);
        return result;
    };
    RmaCloseAfterRepairViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["rmaId"] = this.rmaId !== undefined ? this.rmaId : null;
        data["assetWasExchanged"] = this.assetWasExchanged !== undefined ? this.assetWasExchanged : null;
        data["assetLocation"] = this.assetLocation !== undefined ? this.assetLocation : null;
        data["closed"] = this.closed !== undefined ? this.closed : null;
        data["exceptionMessage"] = this.exceptionMessage !== undefined ? this.exceptionMessage : null;
        return data;
    };
    return RmaCloseAfterRepairViewModel;
}());
export { RmaCloseAfterRepairViewModel };
var RmaDetailsViewModel = /** @class */ (function () {
    function RmaDetailsViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RmaDetailsViewModel.prototype.init = function (data) {
        if (data) {
            this.brokenAsset = data["brokenAsset"] ? AssetViewModel.fromJS(data["brokenAsset"]) : null;
            this.replacementAsset = data["replacementAsset"] ? AssetViewModel.fromJS(data["replacementAsset"]) : null;
            this.availableDocumentViewModel = data["availableDocumentViewModel"] ? AvailableDocumentViewModel.fromJS(data["availableDocumentViewModel"]) : null;
            this.creationDate = data["creationDate"] ? new Date(data["creationDate"].toString()) : null;
            this.replacedDate = data["replacedDate"] ? new Date(data["replacedDate"].toString()) : null;
            this.rmaId = data["rmaId"] !== undefined ? data["rmaId"] : null;
            this.poolReclamation = data["poolReclamation"] !== undefined ? data["poolReclamation"] : null;
            this.rmaNumber = data["rmaNumber"] !== undefined ? data["rmaNumber"] : null;
            this.description = data["description"] !== undefined ? data["description"] : null;
            this.errorDescription = data["errorDescription"] !== undefined ? data["errorDescription"] : null;
            if (data["brokenAssetAccessories"] && data["brokenAssetAccessories"].constructor === Array) {
                this.brokenAssetAccessories = [];
                for (var _i = 0, _a = data["brokenAssetAccessories"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.brokenAssetAccessories.push(BundleContentViewModel.fromJS(item));
                }
            }
            if (data["replacementAssetAccessories"] && data["replacementAssetAccessories"].constructor === Array) {
                this.replacementAssetAccessories = [];
                for (var _b = 0, _c = data["replacementAssetAccessories"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.replacementAssetAccessories.push(BundleContentViewModel.fromJS(item));
                }
            }
            this.customerName = data["customerName"] !== undefined ? data["customerName"] : null;
            if (data["symptomCodeGroups"] && data["symptomCodeGroups"].constructor === Array) {
                this.symptomCodeGroups = [];
                for (var _d = 0, _e = data["symptomCodeGroups"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.symptomCodeGroups.push(AssetStatusCodeGroupViewModel.fromJS(item));
                }
            }
            if (data["repairCodeGroups"] && data["repairCodeGroups"].constructor === Array) {
                this.repairCodeGroups = [];
                for (var _f = 0, _g = data["repairCodeGroups"]; _f < _g.length; _f++) {
                    var item = _g[_f];
                    this.repairCodeGroups.push(AssetStatusCodeGroupViewModel.fromJS(item));
                }
            }
            if (data["serviceCodeGroups"] && data["serviceCodeGroups"].constructor === Array) {
                this.serviceCodeGroups = [];
                for (var _h = 0, _j = data["serviceCodeGroups"]; _h < _j.length; _h++) {
                    var item = _j[_h];
                    this.serviceCodeGroups.push(AssetStatusCodeGroupViewModel.fromJS(item));
                }
            }
            if (data["rmaEvents"] && data["rmaEvents"].constructor === Array) {
                this.rmaEvents = [];
                for (var _k = 0, _l = data["rmaEvents"]; _k < _l.length; _k++) {
                    var item = _l[_k];
                    this.rmaEvents.push(ProgressBarItem.fromJS(item));
                }
            }
            this.rmaEventKey = data["rmaEventKey"] !== undefined ? data["rmaEventKey"] : null;
            if (data["involvedPersons"] && data["involvedPersons"].constructor === Array) {
                this.involvedPersons = [];
                for (var _m = 0, _o = data["involvedPersons"]; _m < _o.length; _m++) {
                    var item = _o[_m];
                    this.involvedPersons.push(InvolvedPersonsViewModel.fromJS(item));
                }
            }
            if (data["rmaHistorys"] && data["rmaHistorys"].constructor === Array) {
                this.rmaHistorys = [];
                for (var _p = 0, _q = data["rmaHistorys"]; _p < _q.length; _p++) {
                    var item = _q[_p];
                    this.rmaHistorys.push(RmaHistoryModel.fromJS(item));
                }
            }
            this.parentRmaId = data["parentRmaId"] !== undefined ? data["parentRmaId"] : null;
            this.childRmaId = data["childRmaId"] !== undefined ? data["childRmaId"] : null;
            this.parentRmaNumber = data["parentRmaNumber"] !== undefined ? data["parentRmaNumber"] : null;
            this.serviceContract = data["serviceContract"] ? ServiceContractViewModel.fromJS(data["serviceContract"]) : null;
            this.exchangeAssetSent = data["exchangeAssetSent"] !== undefined ? data["exchangeAssetSent"] : null;
            this.sourceLocation = data["sourceLocation"] !== undefined ? data["sourceLocation"] : null;
            this.destinationLocation = data["destinationLocation"] !== undefined ? data["destinationLocation"] : null;
            this.trackingNumberSwap = data["trackingNumberSwap"] !== undefined ? data["trackingNumberSwap"] : null;
            this.trackingLinkSwap = data["trackingLinkSwap"] !== undefined ? data["trackingLinkSwap"] : null;
            this.trackingNumberLocation = data["trackingNumberLocation"] !== undefined ? data["trackingNumberLocation"] : null;
            this.trackingLinkLocation = data["trackingLinkLocation"] !== undefined ? data["trackingLinkLocation"] : null;
            this.hasDeliveryService = data["hasDeliveryService"] !== undefined ? data["hasDeliveryService"] : null;
            this.returnAddress = data["returnAddress"] ? AddressViewModel.fromJS(data["returnAddress"]) : null;
            this.comment = data["comment"] ? CommentViewModel.fromJS(data["comment"]) : null;
        }
    };
    RmaDetailsViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RmaDetailsViewModel();
        result.init(data);
        return result;
    };
    RmaDetailsViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["brokenAsset"] = this.brokenAsset ? this.brokenAsset.toJSON() : null;
        data["replacementAsset"] = this.replacementAsset ? this.replacementAsset.toJSON() : null;
        data["availableDocumentViewModel"] = this.availableDocumentViewModel ? this.availableDocumentViewModel.toJSON() : null;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : null;
        data["replacedDate"] = this.replacedDate ? this.replacedDate.toISOString() : null;
        data["rmaId"] = this.rmaId !== undefined ? this.rmaId : null;
        data["poolReclamation"] = this.poolReclamation !== undefined ? this.poolReclamation : null;
        data["rmaNumber"] = this.rmaNumber !== undefined ? this.rmaNumber : null;
        data["description"] = this.description !== undefined ? this.description : null;
        data["errorDescription"] = this.errorDescription !== undefined ? this.errorDescription : null;
        if (this.brokenAssetAccessories && this.brokenAssetAccessories.constructor === Array) {
            data["brokenAssetAccessories"] = [];
            for (var _i = 0, _a = this.brokenAssetAccessories; _i < _a.length; _i++) {
                var item = _a[_i];
                data["brokenAssetAccessories"].push(item.toJSON());
            }
        }
        if (this.replacementAssetAccessories && this.replacementAssetAccessories.constructor === Array) {
            data["replacementAssetAccessories"] = [];
            for (var _b = 0, _c = this.replacementAssetAccessories; _b < _c.length; _b++) {
                var item = _c[_b];
                data["replacementAssetAccessories"].push(item.toJSON());
            }
        }
        data["customerName"] = this.customerName !== undefined ? this.customerName : null;
        if (this.symptomCodeGroups && this.symptomCodeGroups.constructor === Array) {
            data["symptomCodeGroups"] = [];
            for (var _d = 0, _e = this.symptomCodeGroups; _d < _e.length; _d++) {
                var item = _e[_d];
                data["symptomCodeGroups"].push(item.toJSON());
            }
        }
        if (this.repairCodeGroups && this.repairCodeGroups.constructor === Array) {
            data["repairCodeGroups"] = [];
            for (var _f = 0, _g = this.repairCodeGroups; _f < _g.length; _f++) {
                var item = _g[_f];
                data["repairCodeGroups"].push(item.toJSON());
            }
        }
        if (this.serviceCodeGroups && this.serviceCodeGroups.constructor === Array) {
            data["serviceCodeGroups"] = [];
            for (var _h = 0, _j = this.serviceCodeGroups; _h < _j.length; _h++) {
                var item = _j[_h];
                data["serviceCodeGroups"].push(item.toJSON());
            }
        }
        if (this.rmaEvents && this.rmaEvents.constructor === Array) {
            data["rmaEvents"] = [];
            for (var _k = 0, _l = this.rmaEvents; _k < _l.length; _k++) {
                var item = _l[_k];
                data["rmaEvents"].push(item.toJSON());
            }
        }
        data["rmaEventKey"] = this.rmaEventKey !== undefined ? this.rmaEventKey : null;
        if (this.involvedPersons && this.involvedPersons.constructor === Array) {
            data["involvedPersons"] = [];
            for (var _m = 0, _o = this.involvedPersons; _m < _o.length; _m++) {
                var item = _o[_m];
                data["involvedPersons"].push(item.toJSON());
            }
        }
        if (this.rmaHistorys && this.rmaHistorys.constructor === Array) {
            data["rmaHistorys"] = [];
            for (var _p = 0, _q = this.rmaHistorys; _p < _q.length; _p++) {
                var item = _q[_p];
                data["rmaHistorys"].push(item.toJSON());
            }
        }
        data["parentRmaId"] = this.parentRmaId !== undefined ? this.parentRmaId : null;
        data["childRmaId"] = this.childRmaId !== undefined ? this.childRmaId : null;
        data["parentRmaNumber"] = this.parentRmaNumber !== undefined ? this.parentRmaNumber : null;
        data["serviceContract"] = this.serviceContract ? this.serviceContract.toJSON() : null;
        data["exchangeAssetSent"] = this.exchangeAssetSent !== undefined ? this.exchangeAssetSent : null;
        data["sourceLocation"] = this.sourceLocation !== undefined ? this.sourceLocation : null;
        data["destinationLocation"] = this.destinationLocation !== undefined ? this.destinationLocation : null;
        data["trackingNumberSwap"] = this.trackingNumberSwap !== undefined ? this.trackingNumberSwap : null;
        data["trackingLinkSwap"] = this.trackingLinkSwap !== undefined ? this.trackingLinkSwap : null;
        data["trackingNumberLocation"] = this.trackingNumberLocation !== undefined ? this.trackingNumberLocation : null;
        data["trackingLinkLocation"] = this.trackingLinkLocation !== undefined ? this.trackingLinkLocation : null;
        data["hasDeliveryService"] = this.hasDeliveryService !== undefined ? this.hasDeliveryService : null;
        data["returnAddress"] = this.returnAddress ? this.returnAddress.toJSON() : null;
        data["comment"] = this.comment ? this.comment.toJSON() : null;
        return data;
    };
    return RmaDetailsViewModel;
}());
export { RmaDetailsViewModel };
var AvailableDocumentViewModel = /** @class */ (function () {
    function AvailableDocumentViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AvailableDocumentViewModel.prototype.init = function (data) {
        if (data) {
            if (data["documentTypes"] && data["documentTypes"].constructor === Array) {
                this.documentTypes = [];
                for (var _i = 0, _a = data["documentTypes"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.documentTypes.push(item);
                }
            }
        }
    };
    AvailableDocumentViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AvailableDocumentViewModel();
        result.init(data);
        return result;
    };
    AvailableDocumentViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.documentTypes && this.documentTypes.constructor === Array) {
            data["documentTypes"] = [];
            for (var _i = 0, _a = this.documentTypes; _i < _a.length; _i++) {
                var item = _a[_i];
                data["documentTypes"].push(item);
            }
        }
        return data;
    };
    return AvailableDocumentViewModel;
}());
export { AvailableDocumentViewModel };
var ProgressBarItem = /** @class */ (function () {
    function ProgressBarItem(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ProgressBarItem.prototype.init = function (data) {
        if (data) {
            this.progressBarItemKey = data["progressBarItemKey"] !== undefined ? data["progressBarItemKey"] : null;
            this.completed = data["completed"] !== undefined ? data["completed"] : null;
            this.performDateTime = data["performDateTime"] ? new Date(data["performDateTime"].toString()) : null;
            this.estimatedDateTime = data["estimatedDateTime"] ? new Date(data["estimatedDateTime"].toString()) : null;
            this.skipAutoCompletePastEstimatedDate = data["skipAutoCompletePastEstimatedDate"] !== undefined ? data["skipAutoCompletePastEstimatedDate"] : null;
        }
    };
    ProgressBarItem.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ProgressBarItem();
        result.init(data);
        return result;
    };
    ProgressBarItem.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["progressBarItemKey"] = this.progressBarItemKey !== undefined ? this.progressBarItemKey : null;
        data["completed"] = this.completed !== undefined ? this.completed : null;
        data["performDateTime"] = this.performDateTime ? this.performDateTime.toISOString() : null;
        data["estimatedDateTime"] = this.estimatedDateTime ? this.estimatedDateTime.toISOString() : null;
        data["skipAutoCompletePastEstimatedDate"] = this.skipAutoCompletePastEstimatedDate !== undefined ? this.skipAutoCompletePastEstimatedDate : null;
        return data;
    };
    return ProgressBarItem;
}());
export { ProgressBarItem };
export var ProgressBarItemKey;
(function (ProgressBarItemKey) {
    ProgressBarItemKey[ProgressBarItemKey["RmaGenerated"] = 0] = "RmaGenerated";
    ProgressBarItemKey[ProgressBarItemKey["DeviceReceived"] = 1] = "DeviceReceived";
    ProgressBarItemKey[ProgressBarItemKey["DeviceRepaired"] = 2] = "DeviceRepaired";
    ProgressBarItemKey[ProgressBarItemKey["DeviceSent"] = 3] = "DeviceSent";
    ProgressBarItemKey[ProgressBarItemKey["ExchangeArrived"] = 4] = "ExchangeArrived";
})(ProgressBarItemKey || (ProgressBarItemKey = {}));
var InvolvedPersonsViewModel = /** @class */ (function () {
    function InvolvedPersonsViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    InvolvedPersonsViewModel.prototype.init = function (data) {
        if (data) {
            this.fullName = data["fullName"] !== undefined ? data["fullName"] : null;
        }
    };
    InvolvedPersonsViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new InvolvedPersonsViewModel();
        result.init(data);
        return result;
    };
    InvolvedPersonsViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName !== undefined ? this.fullName : null;
        return data;
    };
    return InvolvedPersonsViewModel;
}());
export { InvolvedPersonsViewModel };
var RmaHistoryModel = /** @class */ (function () {
    function RmaHistoryModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RmaHistoryModel.prototype.init = function (data) {
        if (data) {
            this.date = data["date"] ? new Date(data["date"].toString()) : null;
            this.key = data["key"] !== undefined ? data["key"] : null;
            this.description = data["description"] !== undefined ? data["description"] : null;
            this.userName = data["userName"] !== undefined ? data["userName"] : null;
            this.location = data["location"] !== undefined ? data["location"] : null;
            this.fromLocation = data["fromLocation"] !== undefined ? data["fromLocation"] : null;
            this.toLocation = data["toLocation"] !== undefined ? data["toLocation"] : null;
        }
    };
    RmaHistoryModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RmaHistoryModel();
        result.init(data);
        return result;
    };
    RmaHistoryModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : null;
        data["key"] = this.key !== undefined ? this.key : null;
        data["description"] = this.description !== undefined ? this.description : null;
        data["userName"] = this.userName !== undefined ? this.userName : null;
        data["location"] = this.location !== undefined ? this.location : null;
        data["fromLocation"] = this.fromLocation !== undefined ? this.fromLocation : null;
        data["toLocation"] = this.toLocation !== undefined ? this.toLocation : null;
        return data;
    };
    return RmaHistoryModel;
}());
export { RmaHistoryModel };
var RmaEventViewModel = /** @class */ (function () {
    function RmaEventViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RmaEventViewModel.prototype.init = function (data) {
        if (data) {
            this.rmaEventId = data["rmaEventId"] !== undefined ? data["rmaEventId"] : null;
            this.key = data["key"] !== undefined ? data["key"] : null;
        }
    };
    RmaEventViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RmaEventViewModel();
        result.init(data);
        return result;
    };
    RmaEventViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["rmaEventId"] = this.rmaEventId !== undefined ? this.rmaEventId : null;
        data["key"] = this.key !== undefined ? this.key : null;
        return data;
    };
    return RmaEventViewModel;
}());
export { RmaEventViewModel };
var RmaExchangeViewModel = /** @class */ (function () {
    function RmaExchangeViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RmaExchangeViewModel.prototype.init = function (data) {
        if (data) {
            this.serialNumber = data["serialNumber"] !== undefined ? data["serialNumber"] : null;
            this.assetId = data["assetId"] !== undefined ? data["assetId"] : null;
        }
    };
    RmaExchangeViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RmaExchangeViewModel();
        result.init(data);
        return result;
    };
    RmaExchangeViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null;
        data["assetId"] = this.assetId !== undefined ? this.assetId : null;
        return data;
    };
    return RmaExchangeViewModel;
}());
export { RmaExchangeViewModel };
var RmaGenerateViewModel = /** @class */ (function () {
    function RmaGenerateViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RmaGenerateViewModel.prototype.init = function (data) {
        if (data) {
            this.rmaId = data["rmaId"] !== undefined ? data["rmaId"] : null;
            this.assetId = data["assetId"] !== undefined ? data["assetId"] : null;
            this.description = data["description"] !== undefined ? data["description"] : null;
            this.errorDescription = data["errorDescription"] !== undefined ? data["errorDescription"] : null;
            this.repairComplaint = data["repairComplaint"] !== undefined ? data["repairComplaint"] : null;
            if (data["symptomCodeIds"] && data["symptomCodeIds"].constructor === Array) {
                this.symptomCodeIds = [];
                for (var _i = 0, _a = data["symptomCodeIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.symptomCodeIds.push(item);
                }
            }
            this.returnAddress = data["returnAddress"] ? AddressViewModel.fromJS(data["returnAddress"]) : null;
        }
    };
    RmaGenerateViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RmaGenerateViewModel();
        result.init(data);
        return result;
    };
    RmaGenerateViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["rmaId"] = this.rmaId !== undefined ? this.rmaId : null;
        data["assetId"] = this.assetId !== undefined ? this.assetId : null;
        data["description"] = this.description !== undefined ? this.description : null;
        data["errorDescription"] = this.errorDescription !== undefined ? this.errorDescription : null;
        data["repairComplaint"] = this.repairComplaint !== undefined ? this.repairComplaint : null;
        if (this.symptomCodeIds && this.symptomCodeIds.constructor === Array) {
            data["symptomCodeIds"] = [];
            for (var _i = 0, _a = this.symptomCodeIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["symptomCodeIds"].push(item);
            }
        }
        data["returnAddress"] = this.returnAddress ? this.returnAddress.toJSON() : null;
        return data;
    };
    return RmaGenerateViewModel;
}());
export { RmaGenerateViewModel };
var RmaShippingViewModel = /** @class */ (function () {
    function RmaShippingViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RmaShippingViewModel.prototype.init = function (data) {
        if (data) {
            if (data["bundleContent"] && data["bundleContent"].constructor === Array) {
                this.bundleContent = [];
                for (var _i = 0, _a = data["bundleContent"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.bundleContent.push(BundleContentViewModel.fromJS(item));
                }
            }
            this.tracking = data["tracking"] ? TrackingViewModel.fromJS(data["tracking"]) : null;
        }
    };
    RmaShippingViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RmaShippingViewModel();
        result.init(data);
        return result;
    };
    RmaShippingViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.bundleContent && this.bundleContent.constructor === Array) {
            data["bundleContent"] = [];
            for (var _i = 0, _a = this.bundleContent; _i < _a.length; _i++) {
                var item = _a[_i];
                data["bundleContent"].push(item.toJSON());
            }
        }
        data["tracking"] = this.tracking ? this.tracking.toJSON() : null;
        return data;
    };
    return RmaShippingViewModel;
}());
export { RmaShippingViewModel };
var TrackingViewModel = /** @class */ (function () {
    function TrackingViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TrackingViewModel.prototype.init = function (data) {
        if (data) {
            this.shipping = data["shipping"] !== undefined ? data["shipping"] : null;
            this.returnShipping = data["returnShipping"] !== undefined ? data["returnShipping"] : null;
        }
    };
    TrackingViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TrackingViewModel();
        result.init(data);
        return result;
    };
    TrackingViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["shipping"] = this.shipping !== undefined ? this.shipping : null;
        data["returnShipping"] = this.returnShipping !== undefined ? this.returnShipping : null;
        return data;
    };
    return TrackingViewModel;
}());
export { TrackingViewModel };
var RmaViewModel = /** @class */ (function () {
    function RmaViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RmaViewModel.prototype.init = function (data) {
        if (data) {
            this.rmaNumber = data["rmaNumber"] !== undefined ? data["rmaNumber"] : null;
            this.rmaId = data["rmaId"] !== undefined ? data["rmaId"] : null;
            this.status = data["status"] !== undefined ? data["status"] : null;
            this.assetId = data["assetId"] !== undefined ? data["assetId"] : null;
            this.poolReclamation = data["poolReclamation"] !== undefined ? data["poolReclamation"] : null;
            this.tracking = data["tracking"] !== undefined ? data["tracking"] : null;
            this.trackingReturn = data["trackingReturn"] !== undefined ? data["trackingReturn"] : null;
        }
    };
    RmaViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RmaViewModel();
        result.init(data);
        return result;
    };
    RmaViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["rmaNumber"] = this.rmaNumber !== undefined ? this.rmaNumber : null;
        data["rmaId"] = this.rmaId !== undefined ? this.rmaId : null;
        data["status"] = this.status !== undefined ? this.status : null;
        data["assetId"] = this.assetId !== undefined ? this.assetId : null;
        data["poolReclamation"] = this.poolReclamation !== undefined ? this.poolReclamation : null;
        data["tracking"] = this.tracking !== undefined ? this.tracking : null;
        data["trackingReturn"] = this.trackingReturn !== undefined ? this.trackingReturn : null;
        return data;
    };
    return RmaViewModel;
}());
export { RmaViewModel };
/** View model for role creation and editing. */
var RoleEditViewModel = /** @class */ (function () {
    function RoleEditViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RoleEditViewModel.prototype.init = function (data) {
        if (data) {
            this.roleId = data["roleId"] !== undefined ? data["roleId"] : null;
            this.tenantId = data["tenantId"] !== undefined ? data["tenantId"] : null;
            this.tenantName = data["tenantName"] !== undefined ? data["tenantName"] : null;
            this.name = data["name"] !== undefined ? data["name"] : null;
            if (data["permissions"] && data["permissions"].constructor === Array) {
                this.permissions = [];
                for (var _i = 0, _a = data["permissions"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.permissions.push(item);
                }
            }
            this.isUserReseller = data["isUserReseller"] !== undefined ? data["isUserReseller"] : null;
            this.isGlobal = data["isGlobal"] !== undefined ? data["isGlobal"] : null;
        }
    };
    RoleEditViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RoleEditViewModel();
        result.init(data);
        return result;
    };
    RoleEditViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId !== undefined ? this.roleId : null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null;
        data["tenantName"] = this.tenantName !== undefined ? this.tenantName : null;
        data["name"] = this.name !== undefined ? this.name : null;
        if (this.permissions && this.permissions.constructor === Array) {
            data["permissions"] = [];
            for (var _i = 0, _a = this.permissions; _i < _a.length; _i++) {
                var item = _a[_i];
                data["permissions"].push(item);
            }
        }
        data["isUserReseller"] = this.isUserReseller !== undefined ? this.isUserReseller : null;
        data["isGlobal"] = this.isGlobal !== undefined ? this.isGlobal : null;
        return data;
    };
    return RoleEditViewModel;
}());
export { RoleEditViewModel };
var RoleViewModel = /** @class */ (function () {
    function RoleViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RoleViewModel.prototype.init = function (data) {
        if (data) {
            this.roleId = data["roleId"] !== undefined ? data["roleId"] : null;
            this.code = data["code"] !== undefined ? data["code"] : null;
            this.roleName = data["roleName"] !== undefined ? data["roleName"] : null;
            this.tenantName = data["tenantName"] !== undefined ? data["tenantName"] : null;
            if (data["permissions"] && data["permissions"].constructor === Array) {
                this.permissions = [];
                for (var _i = 0, _a = data["permissions"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.permissions.push(item);
                }
            }
            this.roleType = data["roleType"] !== undefined ? data["roleType"] : null;
        }
    };
    RoleViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RoleViewModel();
        result.init(data);
        return result;
    };
    RoleViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId !== undefined ? this.roleId : null;
        data["code"] = this.code !== undefined ? this.code : null;
        data["roleName"] = this.roleName !== undefined ? this.roleName : null;
        data["tenantName"] = this.tenantName !== undefined ? this.tenantName : null;
        if (this.permissions && this.permissions.constructor === Array) {
            data["permissions"] = [];
            for (var _i = 0, _a = this.permissions; _i < _a.length; _i++) {
                var item = _a[_i];
                data["permissions"].push(item);
            }
        }
        data["roleType"] = this.roleType !== undefined ? this.roleType : null;
        return data;
    };
    return RoleViewModel;
}());
export { RoleViewModel };
var ServiceContractEditModel = /** @class */ (function () {
    function ServiceContractEditModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ServiceContractEditModel.prototype.init = function (data) {
        if (data) {
            this.serviceContractId = data["serviceContractId"] !== undefined ? data["serviceContractId"] : null;
            this.contractNumber = data["contractNumber"] !== undefined ? data["contractNumber"] : null;
            this.clientTenantId = data["clientTenantId"] !== undefined ? data["clientTenantId"] : null;
            this.manufacturerId = data["manufacturerId"] !== undefined ? data["manufacturerId"] : null;
            this.validFrom = data["validFrom"] ? new Date(data["validFrom"].toString()) : null;
            this.validTo = data["validTo"] ? new Date(data["validTo"].toString()) : null;
            this.slidingExpirationInMonths = data["slidingExpirationInMonths"] !== undefined ? data["slidingExpirationInMonths"] : null;
            this.description = data["description"] !== undefined ? data["description"] : null;
            this.notActive = data["notActive"] !== undefined ? data["notActive"] : null;
            this.repairTime = data["repairTime"] !== undefined ? data["repairTime"] : null;
        }
    };
    ServiceContractEditModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ServiceContractEditModel();
        result.init(data);
        return result;
    };
    ServiceContractEditModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["serviceContractId"] = this.serviceContractId !== undefined ? this.serviceContractId : null;
        data["contractNumber"] = this.contractNumber !== undefined ? this.contractNumber : null;
        data["clientTenantId"] = this.clientTenantId !== undefined ? this.clientTenantId : null;
        data["manufacturerId"] = this.manufacturerId !== undefined ? this.manufacturerId : null;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : null;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : null;
        data["slidingExpirationInMonths"] = this.slidingExpirationInMonths !== undefined ? this.slidingExpirationInMonths : null;
        data["description"] = this.description !== undefined ? this.description : null;
        data["notActive"] = this.notActive !== undefined ? this.notActive : null;
        data["repairTime"] = this.repairTime !== undefined ? this.repairTime : null;
        return data;
    };
    return ServiceContractEditModel;
}());
export { ServiceContractEditModel };
var ServiceContractOverview = /** @class */ (function () {
    function ServiceContractOverview(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ServiceContractOverview.prototype.init = function (data) {
        if (data) {
            this.serviceContractId = data["serviceContractId"] !== undefined ? data["serviceContractId"] : null;
            this.clientName = data["clientName"] !== undefined ? data["clientName"] : null;
            this.contractNumber = data["contractNumber"] !== undefined ? data["contractNumber"] : null;
            this.validFrom = data["validFrom"] ? new Date(data["validFrom"].toString()) : null;
            this.validTo = data["validTo"] ? new Date(data["validTo"].toString()) : null;
            this.slidingExpirationInMonths = data["slidingExpirationInMonths"] !== undefined ? data["slidingExpirationInMonths"] : null;
            this.providerName = data["providerName"] !== undefined ? data["providerName"] : null;
        }
    };
    ServiceContractOverview.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ServiceContractOverview();
        result.init(data);
        return result;
    };
    ServiceContractOverview.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["serviceContractId"] = this.serviceContractId !== undefined ? this.serviceContractId : null;
        data["clientName"] = this.clientName !== undefined ? this.clientName : null;
        data["contractNumber"] = this.contractNumber !== undefined ? this.contractNumber : null;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : null;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : null;
        data["slidingExpirationInMonths"] = this.slidingExpirationInMonths !== undefined ? this.slidingExpirationInMonths : null;
        data["providerName"] = this.providerName !== undefined ? this.providerName : null;
        return data;
    };
    return ServiceContractOverview;
}());
export { ServiceContractOverview };
var TenantAssetDefinitionSearchItem = /** @class */ (function () {
    function TenantAssetDefinitionSearchItem(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantAssetDefinitionSearchItem.prototype.init = function (data) {
        if (data) {
            this.assetDefinitionId = data["assetDefinitionId"] !== undefined ? data["assetDefinitionId"] : null;
            this.assetDefinitionName = data["assetDefinitionName"] !== undefined ? data["assetDefinitionName"] : null;
            this.fullName = data["fullName"] !== undefined ? data["fullName"] : null;
            this.description = data["description"] !== undefined ? data["description"] : null;
            this.notActive = data["notActive"] !== undefined ? data["notActive"] : null;
            this.manufacturerName = data["manufacturerName"] !== undefined ? data["manufacturerName"] : null;
            this.assetTypeDescription = data["assetTypeDescription"] !== undefined ? data["assetTypeDescription"] : null;
            this.tenantAssetDefOwnerId = data["tenantAssetDefOwnerId"] !== undefined ? data["tenantAssetDefOwnerId"] : null;
            this.tenantAssetDefinitionOwner = data["tenantAssetDefinitionOwner"] !== undefined ? data["tenantAssetDefinitionOwner"] : null;
            this.pictureUrl = data["pictureUrl"] !== undefined ? data["pictureUrl"] : null;
            this.tenantParentId = data["tenantParentId"] !== undefined ? data["tenantParentId"] : null;
        }
    };
    TenantAssetDefinitionSearchItem.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantAssetDefinitionSearchItem();
        result.init(data);
        return result;
    };
    TenantAssetDefinitionSearchItem.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["assetDefinitionId"] = this.assetDefinitionId !== undefined ? this.assetDefinitionId : null;
        data["assetDefinitionName"] = this.assetDefinitionName !== undefined ? this.assetDefinitionName : null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null;
        data["description"] = this.description !== undefined ? this.description : null;
        data["notActive"] = this.notActive !== undefined ? this.notActive : null;
        data["manufacturerName"] = this.manufacturerName !== undefined ? this.manufacturerName : null;
        data["assetTypeDescription"] = this.assetTypeDescription !== undefined ? this.assetTypeDescription : null;
        data["tenantAssetDefOwnerId"] = this.tenantAssetDefOwnerId !== undefined ? this.tenantAssetDefOwnerId : null;
        data["tenantAssetDefinitionOwner"] = this.tenantAssetDefinitionOwner !== undefined ? this.tenantAssetDefinitionOwner : null;
        data["pictureUrl"] = this.pictureUrl !== undefined ? this.pictureUrl : null;
        data["tenantParentId"] = this.tenantParentId !== undefined ? this.tenantParentId : null;
        return data;
    };
    return TenantAssetDefinitionSearchItem;
}());
export { TenantAssetDefinitionSearchItem };
/** The tenant config view model. */
var TenantConfigViewModel = /** @class */ (function () {
    function TenantConfigViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantConfigViewModel.prototype.init = function (data) {
        if (data) {
            this.code = data["code"] !== undefined ? data["code"] : null;
            this.wspRootUrl = data["wspRootUrl"] !== undefined ? data["wspRootUrl"] : null;
            this.languageConfig = data["languageConfig"] ? TenantLanguageConfigurationViewModel.fromJS(data["languageConfig"]) : null;
            this.serviceConfig = data["serviceConfig"] ? TenantServiceConfig.fromJS(data["serviceConfig"]) : null;
        }
    };
    TenantConfigViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantConfigViewModel();
        result.init(data);
        return result;
    };
    TenantConfigViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : null;
        data["wspRootUrl"] = this.wspRootUrl !== undefined ? this.wspRootUrl : null;
        data["languageConfig"] = this.languageConfig ? this.languageConfig.toJSON() : null;
        data["serviceConfig"] = this.serviceConfig ? this.serviceConfig.toJSON() : null;
        return data;
    };
    return TenantConfigViewModel;
}());
export { TenantConfigViewModel };
/** The tenant language configuration view model. */
var TenantLanguageConfigurationViewModel = /** @class */ (function () {
    function TenantLanguageConfigurationViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantLanguageConfigurationViewModel.prototype.init = function (data) {
        if (data) {
            this.defaultLanguage = data["defaultLanguage"] !== undefined ? data["defaultLanguage"] : null;
            if (data["languages"] && data["languages"].constructor === Array) {
                this.languages = [];
                for (var _i = 0, _a = data["languages"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.languages.push(item);
                }
            }
        }
    };
    TenantLanguageConfigurationViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantLanguageConfigurationViewModel();
        result.init(data);
        return result;
    };
    TenantLanguageConfigurationViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["defaultLanguage"] = this.defaultLanguage !== undefined ? this.defaultLanguage : null;
        if (this.languages && this.languages.constructor === Array) {
            data["languages"] = [];
            for (var _i = 0, _a = this.languages; _i < _a.length; _i++) {
                var item = _a[_i];
                data["languages"].push(item);
            }
        }
        return data;
    };
    return TenantLanguageConfigurationViewModel;
}());
export { TenantLanguageConfigurationViewModel };
var TenantServiceConfig = /** @class */ (function () {
    function TenantServiceConfig(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantServiceConfig.prototype.init = function (data) {
        if (data) {
            this.mdmServiceConfig = data["mdmServiceConfig"] ? TenantMdmServiceConfig.fromJS(data["mdmServiceConfig"]) : null;
        }
    };
    TenantServiceConfig.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantServiceConfig();
        result.init(data);
        return result;
    };
    TenantServiceConfig.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["mdmServiceConfig"] = this.mdmServiceConfig ? this.mdmServiceConfig.toJSON() : null;
        return data;
    };
    return TenantServiceConfig;
}());
export { TenantServiceConfig };
var TenantMdmServiceConfig = /** @class */ (function () {
    function TenantMdmServiceConfig(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantMdmServiceConfig.prototype.init = function (data) {
        if (data) {
            this.mdmSystem = data["mdmSystem"] !== undefined ? data["mdmSystem"] : null;
            this.sotiMdmServiceConfig = data["sotiMdmServiceConfig"] ? SotiMdmServiceConfig.fromJS(data["sotiMdmServiceConfig"]) : null;
        }
    };
    TenantMdmServiceConfig.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantMdmServiceConfig();
        result.init(data);
        return result;
    };
    TenantMdmServiceConfig.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["mdmSystem"] = this.mdmSystem !== undefined ? this.mdmSystem : null;
        data["sotiMdmServiceConfig"] = this.sotiMdmServiceConfig ? this.sotiMdmServiceConfig.toJSON() : null;
        return data;
    };
    return TenantMdmServiceConfig;
}());
export { TenantMdmServiceConfig };
export var SupportedMDMSystemsEnum;
(function (SupportedMDMSystemsEnum) {
    SupportedMDMSystemsEnum[SupportedMDMSystemsEnum["NonIntegrated"] = 0] = "NonIntegrated";
    SupportedMDMSystemsEnum[SupportedMDMSystemsEnum["SOTI"] = 10] = "SOTI";
})(SupportedMDMSystemsEnum || (SupportedMDMSystemsEnum = {}));
var SotiMdmServiceConfig = /** @class */ (function () {
    function SotiMdmServiceConfig(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SotiMdmServiceConfig.prototype.init = function (data) {
        if (data) {
            this.mdmBaseEndpointUrl = data["mdmBaseEndpointUrl"] !== undefined ? data["mdmBaseEndpointUrl"] : null;
            this.clientId = data["clientId"] !== undefined ? data["clientId"] : null;
            this.clientSecret = data["clientSecret"] !== undefined ? data["clientSecret"] : null;
        }
    };
    SotiMdmServiceConfig.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SotiMdmServiceConfig();
        result.init(data);
        return result;
    };
    SotiMdmServiceConfig.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["mdmBaseEndpointUrl"] = this.mdmBaseEndpointUrl !== undefined ? this.mdmBaseEndpointUrl : null;
        data["clientId"] = this.clientId !== undefined ? this.clientId : null;
        data["clientSecret"] = this.clientSecret !== undefined ? this.clientSecret : null;
        return data;
    };
    return SotiMdmServiceConfig;
}());
export { SotiMdmServiceConfig };
var TenantSettingsViewModel = /** @class */ (function () {
    function TenantSettingsViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantSettingsViewModel.prototype.init = function (data) {
        if (data) {
            this.canManageAssetsInExchangePools = data["canManageAssetsInExchangePools"] !== undefined ? data["canManageAssetsInExchangePools"] : null;
        }
    };
    TenantSettingsViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantSettingsViewModel();
        result.init(data);
        return result;
    };
    TenantSettingsViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["canManageAssetsInExchangePools"] = this.canManageAssetsInExchangePools !== undefined ? this.canManageAssetsInExchangePools : null;
        return data;
    };
    return TenantSettingsViewModel;
}());
export { TenantSettingsViewModel };
var TenantEditViewModel = /** @class */ (function () {
    function TenantEditViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantEditViewModel.prototype.init = function (data) {
        if (data) {
            this.parentTenantId = data["parentTenantId"] !== undefined ? data["parentTenantId"] : null;
            if (data["parentTenantPath"] && data["parentTenantPath"].constructor === Array) {
                this.parentTenantPath = [];
                for (var _i = 0, _a = data["parentTenantPath"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.parentTenantPath.push(TenantParentPathViewModel.fromJS(item));
                }
            }
            this.parentTenantName = data["parentTenantName"] !== undefined ? data["parentTenantName"] : null;
            this.tenantId = data["tenantId"] !== undefined ? data["tenantId"] : null;
            this.name = data["name"] !== undefined ? data["name"] : null;
            this.code = data["code"] !== undefined ? data["code"] : null;
            this.countryId = data["countryId"] !== undefined ? data["countryId"] : null;
            this.streetNumber = data["streetNumber"] !== undefined ? data["streetNumber"] : null;
            this.street = data["street"] !== undefined ? data["street"] : null;
            this.city = data["city"] !== undefined ? data["city"] : null;
            this.zipCode = data["zipCode"] !== undefined ? data["zipCode"] : null;
            this.state = data["state"] !== undefined ? data["state"] : null;
            this.phone = data["phone"] !== undefined ? data["phone"] : null;
            this.fax = data["fax"] !== undefined ? data["fax"] : null;
            this.fileName = data["fileName"] !== undefined ? data["fileName"] : null;
            this.fileBase64Content = data["fileBase64Content"] !== undefined ? data["fileBase64Content"] : null;
            this.logoImageUrl = data["logoImageUrl"] !== undefined ? data["logoImageUrl"] : null;
            this.legalForm = data["legalForm"] !== undefined ? data["legalForm"] : null;
            this.vatNumber = data["vatNumber"] !== undefined ? data["vatNumber"] : null;
            this.email = data["email"] !== undefined ? data["email"] : null;
            this.contactName = data["contactName"] !== undefined ? data["contactName"] : null;
            this.contactEmail = data["contactEmail"] !== undefined ? data["contactEmail"] : null;
            this.companyUnit = data["companyUnit"] !== undefined ? data["companyUnit"] : null;
            this.companyName = data["companyName"] !== undefined ? data["companyName"] : null;
            this.addressId = data["addressId"] !== undefined ? data["addressId"] : null;
            this.scopeId = data["scopeId"] !== undefined ? data["scopeId"] : null;
            this.tenantType = data["tenantType"] !== undefined ? data["tenantType"] : null;
            this.tenantSettings = data["tenantSettings"] ? TenantSettingsViewModel.fromJS(data["tenantSettings"]) : null;
            this.canDeactivate = data["canDeactivate"] !== undefined ? data["canDeactivate"] : null;
            this.isMovable = data["isMovable"] !== undefined ? data["isMovable"] : null;
            this.isUserReseller = data["isUserReseller"] !== undefined ? data["isUserReseller"] : null;
        }
    };
    TenantEditViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantEditViewModel();
        result.init(data);
        return result;
    };
    TenantEditViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["parentTenantId"] = this.parentTenantId !== undefined ? this.parentTenantId : null;
        if (this.parentTenantPath && this.parentTenantPath.constructor === Array) {
            data["parentTenantPath"] = [];
            for (var _i = 0, _a = this.parentTenantPath; _i < _a.length; _i++) {
                var item = _a[_i];
                data["parentTenantPath"].push(item.toJSON());
            }
        }
        data["parentTenantName"] = this.parentTenantName !== undefined ? this.parentTenantName : null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["code"] = this.code !== undefined ? this.code : null;
        data["countryId"] = this.countryId !== undefined ? this.countryId : null;
        data["streetNumber"] = this.streetNumber !== undefined ? this.streetNumber : null;
        data["street"] = this.street !== undefined ? this.street : null;
        data["city"] = this.city !== undefined ? this.city : null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : null;
        data["state"] = this.state !== undefined ? this.state : null;
        data["phone"] = this.phone !== undefined ? this.phone : null;
        data["fax"] = this.fax !== undefined ? this.fax : null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null;
        data["fileBase64Content"] = this.fileBase64Content !== undefined ? this.fileBase64Content : null;
        data["logoImageUrl"] = this.logoImageUrl !== undefined ? this.logoImageUrl : null;
        data["legalForm"] = this.legalForm !== undefined ? this.legalForm : null;
        data["vatNumber"] = this.vatNumber !== undefined ? this.vatNumber : null;
        data["email"] = this.email !== undefined ? this.email : null;
        data["contactName"] = this.contactName !== undefined ? this.contactName : null;
        data["contactEmail"] = this.contactEmail !== undefined ? this.contactEmail : null;
        data["companyUnit"] = this.companyUnit !== undefined ? this.companyUnit : null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null;
        data["addressId"] = this.addressId !== undefined ? this.addressId : null;
        data["scopeId"] = this.scopeId !== undefined ? this.scopeId : null;
        data["tenantType"] = this.tenantType !== undefined ? this.tenantType : null;
        data["tenantSettings"] = this.tenantSettings ? this.tenantSettings.toJSON() : null;
        data["canDeactivate"] = this.canDeactivate !== undefined ? this.canDeactivate : null;
        data["isMovable"] = this.isMovable !== undefined ? this.isMovable : null;
        data["isUserReseller"] = this.isUserReseller !== undefined ? this.isUserReseller : null;
        return data;
    };
    return TenantEditViewModel;
}());
export { TenantEditViewModel };
var TenantParentPathViewModel = /** @class */ (function () {
    function TenantParentPathViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantParentPathViewModel.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"] !== undefined ? data["tenantId"] : null;
            this.name = data["name"] !== undefined ? data["name"] : null;
            this.level = data["level"] !== undefined ? data["level"] : null;
        }
    };
    TenantParentPathViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantParentPathViewModel();
        result.init(data);
        return result;
    };
    TenantParentPathViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["level"] = this.level !== undefined ? this.level : null;
        return data;
    };
    return TenantParentPathViewModel;
}());
export { TenantParentPathViewModel };
var TenantFlatOverviewViewModel = /** @class */ (function () {
    function TenantFlatOverviewViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantFlatOverviewViewModel.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"] !== undefined ? data["tenantId"] : null;
            this.tenantName = data["tenantName"] !== undefined ? data["tenantName"] : null;
            this.parentTenantId = data["parentTenantId"] !== undefined ? data["parentTenantId"] : null;
            this.parentName = data["parentName"] !== undefined ? data["parentName"] : null;
            this.customerTenantId = data["customerTenantId"] !== undefined ? data["customerTenantId"] : null;
            this.customerName = data["customerName"] !== undefined ? data["customerName"] : null;
            this.countryCode = data["countryCode"] !== undefined ? data["countryCode"] : null;
            this.countryId = data["countryId"] !== undefined ? data["countryId"] : null;
            this.city = data["city"] !== undefined ? data["city"] : null;
        }
    };
    TenantFlatOverviewViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantFlatOverviewViewModel();
        result.init(data);
        return result;
    };
    TenantFlatOverviewViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null;
        data["tenantName"] = this.tenantName !== undefined ? this.tenantName : null;
        data["parentTenantId"] = this.parentTenantId !== undefined ? this.parentTenantId : null;
        data["parentName"] = this.parentName !== undefined ? this.parentName : null;
        data["customerTenantId"] = this.customerTenantId !== undefined ? this.customerTenantId : null;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null;
        data["countryCode"] = this.countryCode !== undefined ? this.countryCode : null;
        data["countryId"] = this.countryId !== undefined ? this.countryId : null;
        data["city"] = this.city !== undefined ? this.city : null;
        return data;
    };
    return TenantFlatOverviewViewModel;
}());
export { TenantFlatOverviewViewModel };
var TenantOverviewViewModel = /** @class */ (function () {
    function TenantOverviewViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantOverviewViewModel.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"] !== undefined ? data["tenantId"] : null;
            this.name = data["name"] !== undefined ? data["name"] : null;
            this.countryId = data["countryId"] !== undefined ? data["countryId"] : null;
            this.streetNumber = data["streetNumber"] !== undefined ? data["streetNumber"] : null;
            this.street = data["street"] !== undefined ? data["street"] : null;
            this.city = data["city"] !== undefined ? data["city"] : null;
            this.zipCode = data["zipCode"] !== undefined ? data["zipCode"] : null;
            this.phone = data["phone"] !== undefined ? data["phone"] : null;
            this.fax = data["fax"] !== undefined ? data["fax"] : null;
            this.countryName = data["countryName"] !== undefined ? data["countryName"] : null;
            this.logoImageUrl = data["logoImageUrl"] !== undefined ? data["logoImageUrl"] : null;
            this.contactName = data["contactName"] !== undefined ? data["contactName"] : null;
            this.legalForm = data["legalForm"] !== undefined ? data["legalForm"] : null;
            this.vatNumber = data["vatNumber"] !== undefined ? data["vatNumber"] : null;
            this.email = data["email"] !== undefined ? data["email"] : null;
        }
    };
    TenantOverviewViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantOverviewViewModel();
        result.init(data);
        return result;
    };
    TenantOverviewViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["countryId"] = this.countryId !== undefined ? this.countryId : null;
        data["streetNumber"] = this.streetNumber !== undefined ? this.streetNumber : null;
        data["street"] = this.street !== undefined ? this.street : null;
        data["city"] = this.city !== undefined ? this.city : null;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : null;
        data["phone"] = this.phone !== undefined ? this.phone : null;
        data["fax"] = this.fax !== undefined ? this.fax : null;
        data["countryName"] = this.countryName !== undefined ? this.countryName : null;
        data["logoImageUrl"] = this.logoImageUrl !== undefined ? this.logoImageUrl : null;
        data["contactName"] = this.contactName !== undefined ? this.contactName : null;
        data["legalForm"] = this.legalForm !== undefined ? this.legalForm : null;
        data["vatNumber"] = this.vatNumber !== undefined ? this.vatNumber : null;
        data["email"] = this.email !== undefined ? this.email : null;
        return data;
    };
    return TenantOverviewViewModel;
}());
export { TenantOverviewViewModel };
/** Used on location search to find tenant */
var TenantSearchItem = /** @class */ (function () {
    function TenantSearchItem(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantSearchItem.prototype.init = function (data) {
        if (data) {
            this.level = data["level"] !== undefined ? data["level"] : null;
            this.tenantId = data["tenantId"] !== undefined ? data["tenantId"] : null;
            this.tenantName = data["tenantName"] !== undefined ? data["tenantName"] : null;
            this.parentTenantId = data["parentTenantId"] !== undefined ? data["parentTenantId"] : null;
            this.parentName = data["parentName"] !== undefined ? data["parentName"] : null;
        }
    };
    TenantSearchItem.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantSearchItem();
        result.init(data);
        return result;
    };
    TenantSearchItem.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level !== undefined ? this.level : null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null;
        data["tenantName"] = this.tenantName !== undefined ? this.tenantName : null;
        data["parentTenantId"] = this.parentTenantId !== undefined ? this.parentTenantId : null;
        data["parentName"] = this.parentName !== undefined ? this.parentName : null;
        return data;
    };
    return TenantSearchItem;
}());
export { TenantSearchItem };
var TenantViewModel = /** @class */ (function () {
    function TenantViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantViewModel.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"] !== undefined ? data["tenantId"] : null;
            this.code = data["code"] !== undefined ? data["code"] : null;
            this.name = data["name"] !== undefined ? data["name"] : null;
            this.logoImage = data["logoImage"] !== undefined ? data["logoImage"] : null;
            this.level = data["level"] !== undefined ? data["level"] : null;
            this.address = data["address"] ? AddressViewModel.fromJS(data["address"]) : null;
        }
    };
    TenantViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantViewModel();
        result.init(data);
        return result;
    };
    TenantViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null;
        data["code"] = this.code !== undefined ? this.code : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["logoImage"] = this.logoImage !== undefined ? this.logoImage : null;
        data["level"] = this.level !== undefined ? this.level : null;
        data["address"] = this.address ? this.address.toJSON() : null;
        return data;
    };
    return TenantViewModel;
}());
export { TenantViewModel };
/** The account edit view model. */
var AccountViewModel = /** @class */ (function () {
    function AccountViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AccountViewModel.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"] !== undefined ? data["tenantId"] : null;
            this.code = data["code"] !== undefined ? data["code"] : null;
            this.tenantName = data["tenantName"] !== undefined ? data["tenantName"] : null;
            this.vatId = data["vatId"] !== undefined ? data["vatId"] : null;
            this.isVatIdRequired = data["isVatIdRequired"] !== undefined ? data["isVatIdRequired"] : null;
            this.address = data["address"] ? AddressViewModel.fromJS(data["address"]) : null;
        }
    };
    AccountViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AccountViewModel();
        result.init(data);
        return result;
    };
    AccountViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null;
        data["code"] = this.code !== undefined ? this.code : null;
        data["tenantName"] = this.tenantName !== undefined ? this.tenantName : null;
        data["vatId"] = this.vatId !== undefined ? this.vatId : null;
        data["isVatIdRequired"] = this.isVatIdRequired !== undefined ? this.isVatIdRequired : null;
        data["address"] = this.address ? this.address.toJSON() : null;
        return data;
    };
    return AccountViewModel;
}());
export { AccountViewModel };
/** The change password view model. */
var ChangePasswordViewModel = /** @class */ (function () {
    function ChangePasswordViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ChangePasswordViewModel.prototype.init = function (data) {
        if (data) {
            this.password = data["password"] !== undefined ? data["password"] : null;
            this.newPassword = data["newPassword"] !== undefined ? data["newPassword"] : null;
            this.passwordConfirmation = data["passwordConfirmation"] !== undefined ? data["passwordConfirmation"] : null;
        }
    };
    ChangePasswordViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ChangePasswordViewModel();
        result.init(data);
        return result;
    };
    ChangePasswordViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password !== undefined ? this.password : null;
        data["newPassword"] = this.newPassword !== undefined ? this.newPassword : null;
        data["passwordConfirmation"] = this.passwordConfirmation !== undefined ? this.passwordConfirmation : null;
        return data;
    };
    return ChangePasswordViewModel;
}());
export { ChangePasswordViewModel };
var FeedbackViewModel = /** @class */ (function () {
    function FeedbackViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FeedbackViewModel.prototype.init = function (data) {
        if (data) {
            this.content = data["content"] !== undefined ? data["content"] : null;
            this.screenshot = data["screenshot"] !== undefined ? data["screenshot"] : null;
            this.browser = data["browser"] !== undefined ? data["browser"] : null;
            this.date = data["date"] ? new Date(data["date"].toString()) : null;
        }
    };
    FeedbackViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FeedbackViewModel();
        result.init(data);
        return result;
    };
    FeedbackViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content !== undefined ? this.content : null;
        data["screenshot"] = this.screenshot !== undefined ? this.screenshot : null;
        data["browser"] = this.browser !== undefined ? this.browser : null;
        data["date"] = this.date ? this.date.toISOString() : null;
        return data;
    };
    return FeedbackViewModel;
}());
export { FeedbackViewModel };
var ResetAccountViewModel = /** @class */ (function () {
    function ResetAccountViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ResetAccountViewModel.prototype.init = function (data) {
        if (data) {
            this.email = data["email"] !== undefined ? data["email"] : null;
        }
    };
    ResetAccountViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ResetAccountViewModel();
        result.init(data);
        return result;
    };
    ResetAccountViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : null;
        return data;
    };
    return ResetAccountViewModel;
}());
export { ResetAccountViewModel };
var SetNewPasswordViewModel = /** @class */ (function () {
    function SetNewPasswordViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SetNewPasswordViewModel.prototype.init = function (data) {
        if (data) {
            this.newPassword = data["newPassword"] !== undefined ? data["newPassword"] : null;
        }
    };
    SetNewPasswordViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SetNewPasswordViewModel();
        result.init(data);
        return result;
    };
    SetNewPasswordViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["newPassword"] = this.newPassword !== undefined ? this.newPassword : null;
        return data;
    };
    return SetNewPasswordViewModel;
}());
export { SetNewPasswordViewModel };
/** The user authorization view model. */
var UserAuthorizationViewModel = /** @class */ (function () {
    function UserAuthorizationViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserAuthorizationViewModel.prototype.init = function (data) {
        if (data) {
            this.userName = data["userName"] !== undefined ? data["userName"] : null;
            this.status = data["status"] !== undefined ? data["status"] : null;
            this.lastLogin = data["lastLogin"] ? new Date(data["lastLogin"].toString()) : null;
            this.disabledOn = data["disabledOn"] ? new Date(data["disabledOn"].toString()) : null;
            if (data["allowedActions"] && data["allowedActions"].constructor === Array) {
                this.allowedActions = [];
                for (var _i = 0, _a = data["allowedActions"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.allowedActions.push(item);
                }
            }
        }
    };
    UserAuthorizationViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserAuthorizationViewModel();
        result.init(data);
        return result;
    };
    UserAuthorizationViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName !== undefined ? this.userName : null;
        data["status"] = this.status !== undefined ? this.status : null;
        data["lastLogin"] = this.lastLogin ? this.lastLogin.toISOString() : null;
        data["disabledOn"] = this.disabledOn ? this.disabledOn.toISOString() : null;
        if (this.allowedActions && this.allowedActions.constructor === Array) {
            data["allowedActions"] = [];
            for (var _i = 0, _a = this.allowedActions; _i < _a.length; _i++) {
                var item = _a[_i];
                data["allowedActions"].push(item);
            }
        }
        return data;
    };
    return UserAuthorizationViewModel;
}());
export { UserAuthorizationViewModel };
export var UserAuthorizationStatus;
(function (UserAuthorizationStatus) {
    UserAuthorizationStatus[UserAuthorizationStatus["Active"] = 10] = "Active";
    UserAuthorizationStatus[UserAuthorizationStatus["Blocked"] = 20] = "Blocked";
    UserAuthorizationStatus[UserAuthorizationStatus["Disabled"] = 30] = "Disabled";
    UserAuthorizationStatus[UserAuthorizationStatus["Temporary"] = 40] = "Temporary";
})(UserAuthorizationStatus || (UserAuthorizationStatus = {}));
/** The user edit view model. */
var UserEditViewModel = /** @class */ (function () {
    function UserEditViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserEditViewModel.prototype.init = function (data) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : null;
            this.firstName = data["firstName"] !== undefined ? data["firstName"] : null;
            this.lastName = data["lastName"] !== undefined ? data["lastName"] : null;
            this.middleName = data["middleName"] !== undefined ? data["middleName"] : null;
            this.authorization = data["authorization"] ? UserAuthorizationViewModel.fromJS(data["authorization"]) : null;
            this.phone = data["phone"] !== undefined ? data["phone"] : null;
            this.email = data["email"] !== undefined ? data["email"] : null;
            this.jobTitle = data["jobTitle"] !== undefined ? data["jobTitle"] : null;
            this.department = data["department"] !== undefined ? data["department"] : null;
            this.userStatus = data["userStatus"] !== undefined ? data["userStatus"] : null;
            this.userType = data["userType"] !== undefined ? data["userType"] : null;
            this.roleId = data["roleId"] !== undefined ? data["roleId"] : null;
            this.roleName = data["roleName"] !== undefined ? data["roleName"] : null;
            this.superUser = data["superUser"] !== undefined ? data["superUser"] : null;
            this.fileName = data["fileName"] !== undefined ? data["fileName"] : null;
            this.fileBase64Content = data["fileBase64Content"] !== undefined ? data["fileBase64Content"] : null;
            this.picture = data["picture"] !== undefined ? data["picture"] : null;
            this.pictureUrl = data["pictureUrl"] !== undefined ? data["pictureUrl"] : null;
            if (data["tenants"] && data["tenants"].constructor === Array) {
                this.tenants = [];
                for (var _i = 0, _a = data["tenants"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.tenants.push(AccountViewModel.fromJS(item));
                }
            }
        }
    };
    UserEditViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserEditViewModel();
        result.init(data);
        return result;
    };
    UserEditViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null;
        data["middleName"] = this.middleName !== undefined ? this.middleName : null;
        data["authorization"] = this.authorization ? this.authorization.toJSON() : null;
        data["phone"] = this.phone !== undefined ? this.phone : null;
        data["email"] = this.email !== undefined ? this.email : null;
        data["jobTitle"] = this.jobTitle !== undefined ? this.jobTitle : null;
        data["department"] = this.department !== undefined ? this.department : null;
        data["userStatus"] = this.userStatus !== undefined ? this.userStatus : null;
        data["userType"] = this.userType !== undefined ? this.userType : null;
        data["roleId"] = this.roleId !== undefined ? this.roleId : null;
        data["roleName"] = this.roleName !== undefined ? this.roleName : null;
        data["superUser"] = this.superUser !== undefined ? this.superUser : null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null;
        data["fileBase64Content"] = this.fileBase64Content !== undefined ? this.fileBase64Content : null;
        data["picture"] = this.picture !== undefined ? this.picture : null;
        data["pictureUrl"] = this.pictureUrl !== undefined ? this.pictureUrl : null;
        if (this.tenants && this.tenants.constructor === Array) {
            data["tenants"] = [];
            for (var _i = 0, _a = this.tenants; _i < _a.length; _i++) {
                var item = _a[_i];
                data["tenants"].push(item.toJSON());
            }
        }
        return data;
    };
    return UserEditViewModel;
}());
export { UserEditViewModel };
export var UserStatus;
(function (UserStatus) {
    UserStatus[UserStatus["Active"] = 0] = "Active";
    UserStatus[UserStatus["Disabled"] = 1] = "Disabled";
})(UserStatus || (UserStatus = {}));
export var UserType;
(function (UserType) {
    UserType[UserType["Location"] = 10] = "Location";
    UserType[UserType["Client"] = 20] = "Client";
    UserType[UserType["Reseller"] = 30] = "Reseller";
    UserType[UserType["Circlon"] = 40] = "Circlon";
})(UserType || (UserType = {}));
/** The user search item. */
var UserSearchItem = /** @class */ (function () {
    function UserSearchItem(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserSearchItem.prototype.init = function (data) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : null;
            this.userName = data["userName"] !== undefined ? data["userName"] : null;
            this.firstName = data["firstName"] !== undefined ? data["firstName"] : null;
            this.lastName = data["lastName"] !== undefined ? data["lastName"] : null;
            this.email = data["email"] !== undefined ? data["email"] : null;
            this.phone = data["phone"] !== undefined ? data["phone"] : null;
            this.userType = data["userType"] !== undefined ? data["userType"] : null;
            this.status = data["status"] !== undefined ? data["status"] : null;
            this.statusKey = data["statusKey"] !== undefined ? data["statusKey"] : null;
            this.location = data["location"] !== undefined ? data["location"] : null;
            this.roleName = data["roleName"] !== undefined ? data["roleName"] : null;
            this.fullName = data["fullName"] !== undefined ? data["fullName"] : null;
            this.picture = data["picture"] !== undefined ? data["picture"] : null;
            this.pictureUrl = data["pictureUrl"] !== undefined ? data["pictureUrl"] : null;
            this.customerName = data["customerName"] !== undefined ? data["customerName"] : null;
        }
    };
    UserSearchItem.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserSearchItem();
        result.init(data);
        return result;
    };
    UserSearchItem.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null;
        data["userName"] = this.userName !== undefined ? this.userName : null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null;
        data["email"] = this.email !== undefined ? this.email : null;
        data["phone"] = this.phone !== undefined ? this.phone : null;
        data["userType"] = this.userType !== undefined ? this.userType : null;
        data["status"] = this.status !== undefined ? this.status : null;
        data["statusKey"] = this.statusKey !== undefined ? this.statusKey : null;
        data["location"] = this.location !== undefined ? this.location : null;
        data["roleName"] = this.roleName !== undefined ? this.roleName : null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null;
        data["picture"] = this.picture !== undefined ? this.picture : null;
        data["pictureUrl"] = this.pictureUrl !== undefined ? this.pictureUrl : null;
        data["customerName"] = this.customerName !== undefined ? this.customerName : null;
        return data;
    };
    return UserSearchItem;
}());
export { UserSearchItem };
var UserViewModel = /** @class */ (function () {
    function UserViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserViewModel.prototype.init = function (data) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : null;
            this.userName = data["userName"] !== undefined ? data["userName"] : null;
            this.firstName = data["firstName"] !== undefined ? data["firstName"] : null;
            this.middleName = data["middleName"] !== undefined ? data["middleName"] : null;
            this.lastName = data["lastName"] !== undefined ? data["lastName"] : null;
            this.email = data["email"] !== undefined ? data["email"] : null;
            this.phone = data["phone"] !== undefined ? data["phone"] : null;
            this.userType = data["userType"] !== undefined ? data["userType"] : null;
            this.fullName = data["fullName"] !== undefined ? data["fullName"] : null;
            if (data["operations"] && data["operations"].constructor === Array) {
                this.operations = [];
                for (var _i = 0, _a = data["operations"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.operations.push(item);
                }
            }
            this.languageCode = data["languageCode"] !== undefined ? data["languageCode"] : null;
            this.pictureUrl = data["pictureUrl"] !== undefined ? data["pictureUrl"] : null;
            this.showReleaseNotes = data["showReleaseNotes"] !== undefined ? data["showReleaseNotes"] : null;
            this.roleId = data["roleId"] !== undefined ? data["roleId"] : null;
            this.tenantTheme = data["tenantTheme"] ? TenantThemeModel.fromJS(data["tenantTheme"]) : null;
        }
    };
    UserViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserViewModel();
        result.init(data);
        return result;
    };
    UserViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null;
        data["userName"] = this.userName !== undefined ? this.userName : null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null;
        data["middleName"] = this.middleName !== undefined ? this.middleName : null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null;
        data["email"] = this.email !== undefined ? this.email : null;
        data["phone"] = this.phone !== undefined ? this.phone : null;
        data["userType"] = this.userType !== undefined ? this.userType : null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null;
        if (this.operations && this.operations.constructor === Array) {
            data["operations"] = [];
            for (var _i = 0, _a = this.operations; _i < _a.length; _i++) {
                var item = _a[_i];
                data["operations"].push(item);
            }
        }
        data["languageCode"] = this.languageCode !== undefined ? this.languageCode : null;
        data["pictureUrl"] = this.pictureUrl !== undefined ? this.pictureUrl : null;
        data["showReleaseNotes"] = this.showReleaseNotes !== undefined ? this.showReleaseNotes : null;
        data["roleId"] = this.roleId !== undefined ? this.roleId : null;
        data["tenantTheme"] = this.tenantTheme ? this.tenantTheme.toJSON() : null;
        return data;
    };
    return UserViewModel;
}());
export { UserViewModel };
var TenantThemeModel = /** @class */ (function () {
    function TenantThemeModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantThemeModel.prototype.init = function (data) {
        if (data) {
            this.tenantThemeId = data["tenantThemeId"] !== undefined ? data["tenantThemeId"] : null;
            this.tenantId = data["tenantId"] !== undefined ? data["tenantId"] : null;
            this.primary = data["primary"] !== undefined ? data["primary"] : null;
            this.primaryDarker = data["primaryDarker"] !== undefined ? data["primaryDarker"] : null;
            this.primaryDark = data["primaryDark"] !== undefined ? data["primaryDark"] : null;
            this.secondary = data["secondary"] !== undefined ? data["secondary"] : null;
            this.danger = data["danger"] !== undefined ? data["danger"] : null;
            this.text = data["text"] !== undefined ? data["text"] : null;
            this.textLight = data["textLight"] !== undefined ? data["textLight"] : null;
            this.textMuted = data["textMuted"] !== undefined ? data["textMuted"] : null;
            this.bg = data["bg"] !== undefined ? data["bg"] : null;
            this.fontFamily = data["fontFamily"] !== undefined ? data["fontFamily"] : null;
            this.gray50 = data["gray50"] !== undefined ? data["gray50"] : null;
            this.gray75 = data["gray75"] !== undefined ? data["gray75"] : null;
            this.gray100 = data["gray100"] !== undefined ? data["gray100"] : null;
            this.gray200 = data["gray200"] !== undefined ? data["gray200"] : null;
            this.gray300 = data["gray300"] !== undefined ? data["gray300"] : null;
            this.gray400 = data["gray400"] !== undefined ? data["gray400"] : null;
            this.gray500 = data["gray500"] !== undefined ? data["gray500"] : null;
            this.gray600 = data["gray600"] !== undefined ? data["gray600"] : null;
            this.gray700 = data["gray700"] !== undefined ? data["gray700"] : null;
            this.gray800 = data["gray800"] !== undefined ? data["gray800"] : null;
            this.gray900 = data["gray900"] !== undefined ? data["gray900"] : null;
            this.gray950 = data["gray950"] !== undefined ? data["gray950"] : null;
            this.borderRadius = data["borderRadius"] !== undefined ? data["borderRadius"] : null;
            this.tableStripe = data["tableStripe"] !== undefined ? data["tableStripe"] : null;
            this.tableLoadingContrast = data["tableLoadingContrast"] !== undefined ? data["tableLoadingContrast"] : null;
            this.headerBorderWidth = data["headerBorderWidth"] !== undefined ? data["headerBorderWidth"] : null;
            this.headerBorderColor = data["headerBorderColor"] !== undefined ? data["headerBorderColor"] : null;
            this.navBg = data["navBg"] !== undefined ? data["navBg"] : null;
            this.navItem = data["navItem"] !== undefined ? data["navItem"] : null;
            this.navItemColor = data["navItemColor"] !== undefined ? data["navItemColor"] : null;
            this.navItemLinkColor = data["navItemLinkColor"] !== undefined ? data["navItemLinkColor"] : null;
            this.navItemActive = data["navItemActive"] !== undefined ? data["navItemActive"] : null;
            this.navItemActiveColor = data["navItemActiveColor"] !== undefined ? data["navItemActiveColor"] : null;
            this.navItemActiveLinkColor = data["navItemActiveLinkColor"] !== undefined ? data["navItemActiveLinkColor"] : null;
            this.navItemHover = data["navItemHover"] !== undefined ? data["navItemHover"] : null;
            this.navItemHoverColor = data["navItemHoverColor"] !== undefined ? data["navItemHoverColor"] : null;
            this.navItemHoverLinkColor = data["navItemHoverLinkColor"] !== undefined ? data["navItemHoverLinkColor"] : null;
            this.navToggle = data["navToggle"] !== undefined ? data["navToggle"] : null;
            this.navToggleActive = data["navToggleActive"] !== undefined ? data["navToggleActive"] : null;
            this.navBorderRight = data["navBorderRight"] !== undefined ? data["navBorderRight"] : null;
            this.logo = data["logo"] !== undefined ? data["logo"] : null;
        }
    };
    TenantThemeModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantThemeModel();
        result.init(data);
        return result;
    };
    TenantThemeModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantThemeId"] = this.tenantThemeId !== undefined ? this.tenantThemeId : null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null;
        data["primary"] = this.primary !== undefined ? this.primary : null;
        data["primaryDarker"] = this.primaryDarker !== undefined ? this.primaryDarker : null;
        data["primaryDark"] = this.primaryDark !== undefined ? this.primaryDark : null;
        data["secondary"] = this.secondary !== undefined ? this.secondary : null;
        data["danger"] = this.danger !== undefined ? this.danger : null;
        data["text"] = this.text !== undefined ? this.text : null;
        data["textLight"] = this.textLight !== undefined ? this.textLight : null;
        data["textMuted"] = this.textMuted !== undefined ? this.textMuted : null;
        data["bg"] = this.bg !== undefined ? this.bg : null;
        data["fontFamily"] = this.fontFamily !== undefined ? this.fontFamily : null;
        data["gray50"] = this.gray50 !== undefined ? this.gray50 : null;
        data["gray75"] = this.gray75 !== undefined ? this.gray75 : null;
        data["gray100"] = this.gray100 !== undefined ? this.gray100 : null;
        data["gray200"] = this.gray200 !== undefined ? this.gray200 : null;
        data["gray300"] = this.gray300 !== undefined ? this.gray300 : null;
        data["gray400"] = this.gray400 !== undefined ? this.gray400 : null;
        data["gray500"] = this.gray500 !== undefined ? this.gray500 : null;
        data["gray600"] = this.gray600 !== undefined ? this.gray600 : null;
        data["gray700"] = this.gray700 !== undefined ? this.gray700 : null;
        data["gray800"] = this.gray800 !== undefined ? this.gray800 : null;
        data["gray900"] = this.gray900 !== undefined ? this.gray900 : null;
        data["gray950"] = this.gray950 !== undefined ? this.gray950 : null;
        data["borderRadius"] = this.borderRadius !== undefined ? this.borderRadius : null;
        data["tableStripe"] = this.tableStripe !== undefined ? this.tableStripe : null;
        data["tableLoadingContrast"] = this.tableLoadingContrast !== undefined ? this.tableLoadingContrast : null;
        data["headerBorderWidth"] = this.headerBorderWidth !== undefined ? this.headerBorderWidth : null;
        data["headerBorderColor"] = this.headerBorderColor !== undefined ? this.headerBorderColor : null;
        data["navBg"] = this.navBg !== undefined ? this.navBg : null;
        data["navItem"] = this.navItem !== undefined ? this.navItem : null;
        data["navItemColor"] = this.navItemColor !== undefined ? this.navItemColor : null;
        data["navItemLinkColor"] = this.navItemLinkColor !== undefined ? this.navItemLinkColor : null;
        data["navItemActive"] = this.navItemActive !== undefined ? this.navItemActive : null;
        data["navItemActiveColor"] = this.navItemActiveColor !== undefined ? this.navItemActiveColor : null;
        data["navItemActiveLinkColor"] = this.navItemActiveLinkColor !== undefined ? this.navItemActiveLinkColor : null;
        data["navItemHover"] = this.navItemHover !== undefined ? this.navItemHover : null;
        data["navItemHoverColor"] = this.navItemHoverColor !== undefined ? this.navItemHoverColor : null;
        data["navItemHoverLinkColor"] = this.navItemHoverLinkColor !== undefined ? this.navItemHoverLinkColor : null;
        data["navToggle"] = this.navToggle !== undefined ? this.navToggle : null;
        data["navToggleActive"] = this.navToggleActive !== undefined ? this.navToggleActive : null;
        data["navBorderRight"] = this.navBorderRight !== undefined ? this.navBorderRight : null;
        data["logo"] = this.logo !== undefined ? this.logo : null;
        return data;
    };
    return TenantThemeModel;
}());
export { TenantThemeModel };
var SelfCheckDefinitionViewModel = /** @class */ (function () {
    function SelfCheckDefinitionViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SelfCheckDefinitionViewModel.prototype.init = function (data) {
        if (data) {
            this.selfCheckDefinitionId = data["selfCheckDefinitionId"] !== undefined ? data["selfCheckDefinitionId"] : null;
            this.tenantAssetDefinitionId = data["tenantAssetDefinitionId"] !== undefined ? data["tenantAssetDefinitionId"] : null;
            this.title = data["title"] !== undefined ? data["title"] : null;
            this.order = data["order"] !== undefined ? data["order"] : null;
            this.content = data["content"] !== undefined ? data["content"] : null;
            this.contentId = data["contentId"] !== undefined ? data["contentId"] : null;
        }
    };
    SelfCheckDefinitionViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SelfCheckDefinitionViewModel();
        result.init(data);
        return result;
    };
    SelfCheckDefinitionViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["selfCheckDefinitionId"] = this.selfCheckDefinitionId !== undefined ? this.selfCheckDefinitionId : null;
        data["tenantAssetDefinitionId"] = this.tenantAssetDefinitionId !== undefined ? this.tenantAssetDefinitionId : null;
        data["title"] = this.title !== undefined ? this.title : null;
        data["order"] = this.order !== undefined ? this.order : null;
        data["content"] = this.content !== undefined ? this.content : null;
        data["contentId"] = this.contentId !== undefined ? this.contentId : null;
        return data;
    };
    return SelfCheckDefinitionViewModel;
}());
export { SelfCheckDefinitionViewModel };
var TenantAssetDefinitionDocumentViewModel = /** @class */ (function () {
    function TenantAssetDefinitionDocumentViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantAssetDefinitionDocumentViewModel.prototype.init = function (data) {
        if (data) {
            this.assetDefinitionId = data["assetDefinitionId"] !== undefined ? data["assetDefinitionId"] : null;
            this.tenantId = data["tenantId"] !== undefined ? data["tenantId"] : null;
            this.file = data["file"] !== undefined ? data["file"] : null;
            this.fileUrl = data["fileUrl"] !== undefined ? data["fileUrl"] : null;
            this.order = data["order"] !== undefined ? data["order"] : null;
            this.fileName = data["fileName"] !== undefined ? data["fileName"] : null;
            this.fileBase64Content = data["fileBase64Content"] !== undefined ? data["fileBase64Content"] : null;
        }
    };
    TenantAssetDefinitionDocumentViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantAssetDefinitionDocumentViewModel();
        result.init(data);
        return result;
    };
    TenantAssetDefinitionDocumentViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["assetDefinitionId"] = this.assetDefinitionId !== undefined ? this.assetDefinitionId : null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null;
        data["file"] = this.file !== undefined ? this.file : null;
        data["fileUrl"] = this.fileUrl !== undefined ? this.fileUrl : null;
        data["order"] = this.order !== undefined ? this.order : null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null;
        data["fileBase64Content"] = this.fileBase64Content !== undefined ? this.fileBase64Content : null;
        return data;
    };
    return TenantAssetDefinitionDocumentViewModel;
}());
export { TenantAssetDefinitionDocumentViewModel };
export var DataDocumentTypeViewEnum;
(function (DataDocumentTypeViewEnum) {
    DataDocumentTypeViewEnum[DataDocumentTypeViewEnum["AssetDefinition"] = 0] = "AssetDefinition";
    DataDocumentTypeViewEnum[DataDocumentTypeViewEnum["TenantAssetDefinition"] = 1] = "TenantAssetDefinition";
    DataDocumentTypeViewEnum[DataDocumentTypeViewEnum["Tenant"] = 2] = "Tenant";
    DataDocumentTypeViewEnum[DataDocumentTypeViewEnum["ServiceContract"] = 3] = "ServiceContract";
})(DataDocumentTypeViewEnum || (DataDocumentTypeViewEnum = {}));
var DocumentViewModel = /** @class */ (function () {
    function DocumentViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DocumentViewModel.prototype.init = function (data) {
        if (data) {
            this.contentType = data["contentType"] !== undefined ? data["contentType"] : null;
            this.container = data["container"] !== undefined ? data["container"] : null;
            this.virtualFolderPath = data["virtualFolderPath"] !== undefined ? data["virtualFolderPath"] : null;
            this.fileName = data["fileName"] !== undefined ? data["fileName"] : null;
            this.documentName = data["documentName"] !== undefined ? data["documentName"] : null;
            this.documentDescription = data["documentDescription"] !== undefined ? data["documentDescription"] : null;
            this.dataDocumentType = data["dataDocumentType"] !== undefined ? data["dataDocumentType"] : null;
            this.fileBase64Content = data["fileBase64Content"] !== undefined ? data["fileBase64Content"] : null;
        }
    };
    DocumentViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DocumentViewModel();
        result.init(data);
        return result;
    };
    DocumentViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["contentType"] = this.contentType !== undefined ? this.contentType : null;
        data["container"] = this.container !== undefined ? this.container : null;
        data["virtualFolderPath"] = this.virtualFolderPath !== undefined ? this.virtualFolderPath : null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null;
        data["documentName"] = this.documentName !== undefined ? this.documentName : null;
        data["documentDescription"] = this.documentDescription !== undefined ? this.documentDescription : null;
        data["dataDocumentType"] = this.dataDocumentType !== undefined ? this.dataDocumentType : null;
        data["fileBase64Content"] = this.fileBase64Content !== undefined ? this.fileBase64Content : null;
        return data;
    };
    return DocumentViewModel;
}());
export { DocumentViewModel };
var FileViewModel = /** @class */ (function () {
    function FileViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FileViewModel.prototype.init = function (data) {
        if (data) {
            this.file = data["file"] !== undefined ? data["file"] : null;
            this.contentType = data["contentType"] !== undefined ? data["contentType"] : null;
            this.container = data["container"] !== undefined ? data["container"] : null;
            this.virtualFolderPath = data["virtualFolderPath"] !== undefined ? data["virtualFolderPath"] : null;
            this.fileName = data["fileName"] !== undefined ? data["fileName"] : null;
            this.documentName = data["documentName"] !== undefined ? data["documentName"] : null;
            this.documentDescription = data["documentDescription"] !== undefined ? data["documentDescription"] : null;
            this.dataDocumentType = data["dataDocumentType"] !== undefined ? data["dataDocumentType"] : null;
        }
    };
    FileViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FileViewModel();
        result.init(data);
        return result;
    };
    FileViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["file"] = this.file !== undefined ? this.file : null;
        data["contentType"] = this.contentType !== undefined ? this.contentType : null;
        data["container"] = this.container !== undefined ? this.container : null;
        data["virtualFolderPath"] = this.virtualFolderPath !== undefined ? this.virtualFolderPath : null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null;
        data["documentName"] = this.documentName !== undefined ? this.documentName : null;
        data["documentDescription"] = this.documentDescription !== undefined ? this.documentDescription : null;
        data["dataDocumentType"] = this.dataDocumentType !== undefined ? this.dataDocumentType : null;
        return data;
    };
    return FileViewModel;
}());
export { FileViewModel };
var ServiceProviderAssignmentViewModel = /** @class */ (function () {
    function ServiceProviderAssignmentViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ServiceProviderAssignmentViewModel.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"] !== undefined ? data["tenantId"] : null;
            this.assetDefinitionId = data["assetDefinitionId"] !== undefined ? data["assetDefinitionId"] : null;
            this.serviceCenterId = data["serviceCenterId"] !== undefined ? data["serviceCenterId"] : null;
            this.repairCenterId = data["repairCenterId"] !== undefined ? data["repairCenterId"] : null;
        }
    };
    ServiceProviderAssignmentViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ServiceProviderAssignmentViewModel();
        result.init(data);
        return result;
    };
    ServiceProviderAssignmentViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null;
        data["assetDefinitionId"] = this.assetDefinitionId !== undefined ? this.assetDefinitionId : null;
        data["serviceCenterId"] = this.serviceCenterId !== undefined ? this.serviceCenterId : null;
        data["repairCenterId"] = this.repairCenterId !== undefined ? this.repairCenterId : null;
        return data;
    };
    return ServiceProviderAssignmentViewModel;
}());
export { ServiceProviderAssignmentViewModel };
var TenantAssetDefinitionServiceProvidersViewModel = /** @class */ (function () {
    function TenantAssetDefinitionServiceProvidersViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantAssetDefinitionServiceProvidersViewModel.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"] !== undefined ? data["tenantId"] : null;
            this.tenantName = data["tenantName"] !== undefined ? data["tenantName"] : null;
            this.assetDefinitionId = data["assetDefinitionId"] !== undefined ? data["assetDefinitionId"] : null;
            if (data["tenantAssetDefinitionServiceProviderRelations"] && data["tenantAssetDefinitionServiceProviderRelations"].constructor === Array) {
                this.tenantAssetDefinitionServiceProviderRelations = [];
                for (var _i = 0, _a = data["tenantAssetDefinitionServiceProviderRelations"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.tenantAssetDefinitionServiceProviderRelations.push(TenantAssetDefinitionServiceProviderViewModel.fromJS(item));
                }
            }
        }
    };
    TenantAssetDefinitionServiceProvidersViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantAssetDefinitionServiceProvidersViewModel();
        result.init(data);
        return result;
    };
    TenantAssetDefinitionServiceProvidersViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null;
        data["tenantName"] = this.tenantName !== undefined ? this.tenantName : null;
        data["assetDefinitionId"] = this.assetDefinitionId !== undefined ? this.assetDefinitionId : null;
        if (this.tenantAssetDefinitionServiceProviderRelations && this.tenantAssetDefinitionServiceProviderRelations.constructor === Array) {
            data["tenantAssetDefinitionServiceProviderRelations"] = [];
            for (var _i = 0, _a = this.tenantAssetDefinitionServiceProviderRelations; _i < _a.length; _i++) {
                var item = _a[_i];
                data["tenantAssetDefinitionServiceProviderRelations"].push(item.toJSON());
            }
        }
        return data;
    };
    return TenantAssetDefinitionServiceProvidersViewModel;
}());
export { TenantAssetDefinitionServiceProvidersViewModel };
var TenantAssetDefinitionServiceProviderViewModel = /** @class */ (function () {
    function TenantAssetDefinitionServiceProviderViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantAssetDefinitionServiceProviderViewModel.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"] !== undefined ? data["tenantId"] : null;
            this.tenantName = data["tenantName"] !== undefined ? data["tenantName"] : null;
            if (data["parentTenants"] && data["parentTenants"].constructor === Array) {
                this.parentTenants = [];
                for (var _i = 0, _a = data["parentTenants"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.parentTenants.push(TenantViewModel.fromJS(item));
                }
            }
            this.serviceCenter = data["serviceCenter"] ? TenantViewModel.fromJS(data["serviceCenter"]) : null;
            this.repairCenter = data["repairCenter"] ? TenantViewModel.fromJS(data["repairCenter"]) : null;
        }
    };
    TenantAssetDefinitionServiceProviderViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantAssetDefinitionServiceProviderViewModel();
        result.init(data);
        return result;
    };
    TenantAssetDefinitionServiceProviderViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null;
        data["tenantName"] = this.tenantName !== undefined ? this.tenantName : null;
        if (this.parentTenants && this.parentTenants.constructor === Array) {
            data["parentTenants"] = [];
            for (var _i = 0, _a = this.parentTenants; _i < _a.length; _i++) {
                var item = _a[_i];
                data["parentTenants"].push(item.toJSON());
            }
        }
        data["serviceCenter"] = this.serviceCenter ? this.serviceCenter.toJSON() : null;
        data["repairCenter"] = this.repairCenter ? this.repairCenter.toJSON() : null;
        return data;
    };
    return TenantAssetDefinitionServiceProviderViewModel;
}());
export { TenantAssetDefinitionServiceProviderViewModel };
var LanguageTranslationEditViewModel = /** @class */ (function () {
    function LanguageTranslationEditViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LanguageTranslationEditViewModel.prototype.init = function (data) {
        if (data) {
            this.language = data["language"] ? LanguageViewModel.fromJS(data["language"]) : null;
            this.translation = data["translation"] !== undefined ? data["translation"] : null;
        }
    };
    LanguageTranslationEditViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LanguageTranslationEditViewModel();
        result.init(data);
        return result;
    };
    LanguageTranslationEditViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language ? this.language.toJSON() : null;
        data["translation"] = this.translation !== undefined ? this.translation : null;
        return data;
    };
    return LanguageTranslationEditViewModel;
}());
export { LanguageTranslationEditViewModel };
/** Implements the TranslationEditViewModel. */
var TranslationEditViewModel = /** @class */ (function () {
    function TranslationEditViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TranslationEditViewModel.prototype.init = function (data) {
        if (data) {
            this.key = data["key"] !== undefined ? data["key"] : null;
            this.group = data["group"] !== undefined ? data["group"] : null;
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (var _i = 0, _a = data["translations"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.translations.push(LanguageTranslationEditViewModel.fromJS(item));
                }
            }
            this.isResettable = data["isResettable"] !== undefined ? data["isResettable"] : null;
        }
    };
    TranslationEditViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TranslationEditViewModel();
        result.init(data);
        return result;
    };
    TranslationEditViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : null;
        data["group"] = this.group !== undefined ? this.group : null;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (var _i = 0, _a = this.translations; _i < _a.length; _i++) {
                var item = _a[_i];
                data["translations"].push(item.toJSON());
            }
        }
        data["isResettable"] = this.isResettable !== undefined ? this.isResettable : null;
        return data;
    };
    return TranslationEditViewModel;
}());
export { TranslationEditViewModel };
/** Enum of groups used in the i18n table. */
export var TranslationGroup;
(function (TranslationGroup) {
    TranslationGroup[TranslationGroup["AUTH"] = 0] = "AUTH";
    TranslationGroup[TranslationGroup["COMMON"] = 1] = "COMMON";
    TranslationGroup[TranslationGroup["OPERATE"] = 2] = "OPERATE";
})(TranslationGroup || (TranslationGroup = {}));
var CustomerModelConfigurationRepairLimitViewModel = /** @class */ (function () {
    function CustomerModelConfigurationRepairLimitViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CustomerModelConfigurationRepairLimitViewModel.prototype.init = function (data) {
        if (data) {
            this.modelRepairLimitNo = data["modelRepairLimitNo"] !== undefined ? data["modelRepairLimitNo"] : null;
            this.modelRepairLimit = data["modelRepairLimit"] !== undefined ? data["modelRepairLimit"] : null;
        }
    };
    CustomerModelConfigurationRepairLimitViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CustomerModelConfigurationRepairLimitViewModel();
        result.init(data);
        return result;
    };
    CustomerModelConfigurationRepairLimitViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["modelRepairLimitNo"] = this.modelRepairLimitNo !== undefined ? this.modelRepairLimitNo : null;
        data["modelRepairLimit"] = this.modelRepairLimit !== undefined ? this.modelRepairLimit : null;
        return data;
    };
    return CustomerModelConfigurationRepairLimitViewModel;
}());
export { CustomerModelConfigurationRepairLimitViewModel };
var CustomerModelConfigurationViewModel = /** @class */ (function () {
    function CustomerModelConfigurationViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CustomerModelConfigurationViewModel.prototype.init = function (data) {
        if (data) {
            this.skipRepairProcess = data["skipRepairProcess"] !== undefined ? data["skipRepairProcess"] : null;
            this.skipInitCheckSNProcess = data["skipInitCheckSNProcess"] !== undefined ? data["skipInitCheckSNProcess"] : null;
            this.skipExchangeProcess = data["skipExchangeProcess"] !== undefined ? data["skipExchangeProcess"] : null;
            this.skipTrackingNumber = data["skipTrackingNumber"] !== undefined ? data["skipTrackingNumber"] : null;
            this.moveAlternativeNumber = data["moveAlternativeNumber"] !== undefined ? data["moveAlternativeNumber"] : null;
            this.createBundleDuringExchange = data["createBundleDuringExchange"] !== undefined ? data["createBundleDuringExchange"] : null;
            this.sendDefectAssetToRepairCenter = data["sendDefectAssetToRepairCenter"] !== undefined ? data["sendDefectAssetToRepairCenter"] : null;
            this.clearBundleWhenNoFailureFound = data["clearBundleWhenNoFailureFound"] !== undefined ? data["clearBundleWhenNoFailureFound"] : null;
            this.returnToAlternativeAddress = data["returnToAlternativeAddress"] !== undefined ? data["returnToAlternativeAddress"] : null;
            this.assetReceivedConfirmation = data["assetReceivedConfirmation"] !== undefined ? data["assetReceivedConfirmation"] : null;
            this.modelRepairLimitNo = data["modelRepairLimitNo"] !== undefined ? data["modelRepairLimitNo"] : null;
            this.modelRepairLimit = data["modelRepairLimit"] !== undefined ? data["modelRepairLimit"] : null;
        }
    };
    CustomerModelConfigurationViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CustomerModelConfigurationViewModel();
        result.init(data);
        return result;
    };
    CustomerModelConfigurationViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["skipRepairProcess"] = this.skipRepairProcess !== undefined ? this.skipRepairProcess : null;
        data["skipInitCheckSNProcess"] = this.skipInitCheckSNProcess !== undefined ? this.skipInitCheckSNProcess : null;
        data["skipExchangeProcess"] = this.skipExchangeProcess !== undefined ? this.skipExchangeProcess : null;
        data["skipTrackingNumber"] = this.skipTrackingNumber !== undefined ? this.skipTrackingNumber : null;
        data["moveAlternativeNumber"] = this.moveAlternativeNumber !== undefined ? this.moveAlternativeNumber : null;
        data["createBundleDuringExchange"] = this.createBundleDuringExchange !== undefined ? this.createBundleDuringExchange : null;
        data["sendDefectAssetToRepairCenter"] = this.sendDefectAssetToRepairCenter !== undefined ? this.sendDefectAssetToRepairCenter : null;
        data["clearBundleWhenNoFailureFound"] = this.clearBundleWhenNoFailureFound !== undefined ? this.clearBundleWhenNoFailureFound : null;
        data["returnToAlternativeAddress"] = this.returnToAlternativeAddress !== undefined ? this.returnToAlternativeAddress : null;
        data["assetReceivedConfirmation"] = this.assetReceivedConfirmation !== undefined ? this.assetReceivedConfirmation : null;
        data["modelRepairLimitNo"] = this.modelRepairLimitNo !== undefined ? this.modelRepairLimitNo : null;
        data["modelRepairLimit"] = this.modelRepairLimit !== undefined ? this.modelRepairLimit : null;
        return data;
    };
    return CustomerModelConfigurationViewModel;
}());
export { CustomerModelConfigurationViewModel };
var ExchangePoolEditViewModel = /** @class */ (function (_super) {
    __extends(ExchangePoolEditViewModel, _super);
    function ExchangePoolEditViewModel(data) {
        return _super.call(this, data) || this;
    }
    ExchangePoolEditViewModel.prototype.init = function (data) {
        _super.prototype.init.call(this, data);
        if (data) {
            if (data["assignments"] && data["assignments"].constructor === Array) {
                this.assignments = [];
                for (var _i = 0, _a = data["assignments"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.assignments.push(item);
                }
            }
        }
    };
    ExchangePoolEditViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ExchangePoolEditViewModel();
        result.init(data);
        return result;
    };
    ExchangePoolEditViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.assignments && this.assignments.constructor === Array) {
            data["assignments"] = [];
            for (var _i = 0, _a = this.assignments; _i < _a.length; _i++) {
                var item = _a[_i];
                data["assignments"].push(item);
            }
        }
        _super.prototype.toJSON.call(this, data);
        return data;
    };
    return ExchangePoolEditViewModel;
}(TenantEditViewModel));
export { ExchangePoolEditViewModel };
var InventoryMessageViewModel = /** @class */ (function () {
    function InventoryMessageViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    InventoryMessageViewModel.prototype.init = function (data) {
        if (data) {
            this.lastConnection = data["lastConnection"] ? new Date(data["lastConnection"].toString()) : null;
            this.lastMessageType = data["lastMessageType"] !== undefined ? data["lastMessageType"] : null;
        }
    };
    InventoryMessageViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new InventoryMessageViewModel();
        result.init(data);
        return result;
    };
    InventoryMessageViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["lastConnection"] = this.lastConnection ? this.lastConnection.toISOString() : null;
        data["lastMessageType"] = this.lastMessageType !== undefined ? this.lastMessageType : null;
        return data;
    };
    return InventoryMessageViewModel;
}());
export { InventoryMessageViewModel };
var InventorySensorDataSummaryViewModel = /** @class */ (function () {
    function InventorySensorDataSummaryViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    InventorySensorDataSummaryViewModel.prototype.init = function (data) {
        if (data) {
            this.lastMessage = data["lastMessage"] ? InventoryMessageViewModel.fromJS(data["lastMessage"]) : null;
            if (data["inventoryAssets"] && data["inventoryAssets"].constructor === Array) {
                this.inventoryAssets = [];
                for (var _i = 0, _a = data["inventoryAssets"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.inventoryAssets.push(InventoryAssetViewModel.fromJS(item));
                }
            }
        }
    };
    InventorySensorDataSummaryViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new InventorySensorDataSummaryViewModel();
        result.init(data);
        return result;
    };
    InventorySensorDataSummaryViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["lastMessage"] = this.lastMessage ? this.lastMessage.toJSON() : null;
        if (this.inventoryAssets && this.inventoryAssets.constructor === Array) {
            data["inventoryAssets"] = [];
            for (var _i = 0, _a = this.inventoryAssets; _i < _a.length; _i++) {
                var item = _a[_i];
                data["inventoryAssets"].push(item.toJSON());
            }
        }
        return data;
    };
    return InventorySensorDataSummaryViewModel;
}());
export { InventorySensorDataSummaryViewModel };
/** Implements the InventoryAssetViewModel */
var InventoryAssetViewModel = /** @class */ (function () {
    function InventoryAssetViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    InventoryAssetViewModel.prototype.init = function (data) {
        if (data) {
            this.serialNumber = data["serialNumber"] !== undefined ? data["serialNumber"] : null;
            this.assetDefinitionName = data["assetDefinitionName"] !== undefined ? data["assetDefinitionName"] : null;
            this.manufacturerName = data["manufacturerName"] !== undefined ? data["manufacturerName"] : null;
            this.count = data["count"] !== undefined ? data["count"] : null;
            this.pictureUrl = data["pictureUrl"] !== undefined ? data["pictureUrl"] : null;
            this.identifiable = data["identifiable"] !== undefined ? data["identifiable"] : null;
            this.messageId = data["messageId"] !== undefined ? data["messageId"] : null;
            this.messageReceived = data["messageReceived"] ? new Date(data["messageReceived"].toString()) : null;
        }
    };
    InventoryAssetViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new InventoryAssetViewModel();
        result.init(data);
        return result;
    };
    InventoryAssetViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null;
        data["assetDefinitionName"] = this.assetDefinitionName !== undefined ? this.assetDefinitionName : null;
        data["manufacturerName"] = this.manufacturerName !== undefined ? this.manufacturerName : null;
        data["count"] = this.count !== undefined ? this.count : null;
        data["pictureUrl"] = this.pictureUrl !== undefined ? this.pictureUrl : null;
        data["identifiable"] = this.identifiable !== undefined ? this.identifiable : null;
        data["messageId"] = this.messageId !== undefined ? this.messageId : null;
        data["messageReceived"] = this.messageReceived ? this.messageReceived.toISOString() : null;
        return data;
    };
    return InventoryAssetViewModel;
}());
export { InventoryAssetViewModel };
var AssetSensorDataViewModel = /** @class */ (function () {
    function AssetSensorDataViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AssetSensorDataViewModel.prototype.init = function (data) {
        if (data) {
            this.sensorSourceSystem = data["sensorSourceSystem"] !== undefined ? data["sensorSourceSystem"] : null;
            this.battery = data["battery"] ? BatteryViewModel.fromJS(data["battery"]) : null;
            this.coordinate = data["coordinate"] ? CoordinateViewModel.fromJS(data["coordinate"]) : null;
        }
    };
    AssetSensorDataViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AssetSensorDataViewModel();
        result.init(data);
        return result;
    };
    AssetSensorDataViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["sensorSourceSystem"] = this.sensorSourceSystem !== undefined ? this.sensorSourceSystem : null;
        data["battery"] = this.battery ? this.battery.toJSON() : null;
        data["coordinate"] = this.coordinate ? this.coordinate.toJSON() : null;
        return data;
    };
    return AssetSensorDataViewModel;
}());
export { AssetSensorDataViewModel };
export var SensorSourceSystem;
(function (SensorSourceSystem) {
    SensorSourceSystem[SensorSourceSystem["Honeywell"] = 0] = "Honeywell";
    SensorSourceSystem[SensorSourceSystem["AssetSensorApp"] = 1] = "AssetSensorApp";
})(SensorSourceSystem || (SensorSourceSystem = {}));
var BatteryViewModel = /** @class */ (function () {
    function BatteryViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BatteryViewModel.prototype.init = function (data) {
        if (data) {
            this.hasPermission = data["hasPermission"] !== undefined ? data["hasPermission"] : null;
            this.isPluggedAc = data["isPluggedAc"] !== undefined ? data["isPluggedAc"] : null;
            this.isPluggedUsb = data["isPluggedUsb"] !== undefined ? data["isPluggedUsb"] : null;
            this.serialNumber = data["serialNumber"] !== undefined ? data["serialNumber"] : null;
            this.status = data["status"] !== undefined ? data["status"] : null;
            this.cycleCount = data["cycleCount"] !== undefined ? data["cycleCount"] : null;
            this.health = data["health"] !== undefined ? data["health"] : null;
            this.capacity = data["capacity"] !== undefined ? data["capacity"] : null;
            this.level = data["level"] !== undefined ? data["level"] : null;
            this.isCharging = data["isCharging"] !== undefined ? data["isCharging"] : null;
            this.createDate = data["createDate"] ? new Date(data["createDate"].toString()) : null;
            this.changeDate = data["changeDate"] ? new Date(data["changeDate"].toString()) : null;
        }
    };
    BatteryViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BatteryViewModel();
        result.init(data);
        return result;
    };
    BatteryViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["hasPermission"] = this.hasPermission !== undefined ? this.hasPermission : null;
        data["isPluggedAc"] = this.isPluggedAc !== undefined ? this.isPluggedAc : null;
        data["isPluggedUsb"] = this.isPluggedUsb !== undefined ? this.isPluggedUsb : null;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null;
        data["status"] = this.status !== undefined ? this.status : null;
        data["cycleCount"] = this.cycleCount !== undefined ? this.cycleCount : null;
        data["health"] = this.health !== undefined ? this.health : null;
        data["capacity"] = this.capacity !== undefined ? this.capacity : null;
        data["level"] = this.level !== undefined ? this.level : null;
        data["isCharging"] = this.isCharging !== undefined ? this.isCharging : null;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : null;
        data["changeDate"] = this.changeDate ? this.changeDate.toISOString() : null;
        return data;
    };
    return BatteryViewModel;
}());
export { BatteryViewModel };
var CoordinateViewModel = /** @class */ (function () {
    function CoordinateViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CoordinateViewModel.prototype.init = function (data) {
        if (data) {
            this.longitude = data["longitude"] !== undefined ? data["longitude"] : null;
            this.latitude = data["latitude"] !== undefined ? data["latitude"] : null;
            this.createDate = data["createDate"] ? new Date(data["createDate"].toString()) : null;
            this.changeDate = data["changeDate"] ? new Date(data["changeDate"].toString()) : null;
        }
    };
    CoordinateViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CoordinateViewModel();
        result.init(data);
        return result;
    };
    CoordinateViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["longitude"] = this.longitude !== undefined ? this.longitude : null;
        data["latitude"] = this.latitude !== undefined ? this.latitude : null;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : null;
        data["changeDate"] = this.changeDate ? this.changeDate.toISOString() : null;
        return data;
    };
    return CoordinateViewModel;
}());
export { CoordinateViewModel };
var InventoryIdentifiableViewModel = /** @class */ (function () {
    function InventoryIdentifiableViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    InventoryIdentifiableViewModel.prototype.init = function (data) {
        if (data) {
            if (data["asset"] && data["asset"].constructor === Array) {
                this.asset = [];
                for (var _i = 0, _a = data["asset"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.asset.push(InventoryAssetViewModel.fromJS(item));
                }
            }
        }
    };
    InventoryIdentifiableViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new InventoryIdentifiableViewModel();
        result.init(data);
        return result;
    };
    InventoryIdentifiableViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.asset && this.asset.constructor === Array) {
            data["asset"] = [];
            for (var _i = 0, _a = this.asset; _i < _a.length; _i++) {
                var item = _a[_i];
                data["asset"].push(item.toJSON());
            }
        }
        return data;
    };
    return InventoryIdentifiableViewModel;
}());
export { InventoryIdentifiableViewModel };
var InventorySensorDataViewModel = /** @class */ (function () {
    function InventorySensorDataViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    InventorySensorDataViewModel.prototype.init = function (data) {
        if (data) {
            this.identifiable = data["identifiable"] ? InventoryIdentifiableViewModel.fromJS(data["identifiable"]) : null;
            this.unidentifiable = data["unidentifiable"] ? InventoryIdentifiableViewModel.fromJS(data["unidentifiable"]) : null;
        }
    };
    InventorySensorDataViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new InventorySensorDataViewModel();
        result.init(data);
        return result;
    };
    InventorySensorDataViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["identifiable"] = this.identifiable ? this.identifiable.toJSON() : null;
        data["unidentifiable"] = this.unidentifiable ? this.unidentifiable.toJSON() : null;
        return data;
    };
    return InventorySensorDataViewModel;
}());
export { InventorySensorDataViewModel };
var RollInTaskHistoryViewModel = /** @class */ (function () {
    function RollInTaskHistoryViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RollInTaskHistoryViewModel.prototype.init = function (data) {
        if (data) {
            this.rollInTaskHistoryId = data["rollInTaskHistoryId"] !== undefined ? data["rollInTaskHistoryId"] : null;
            this.rollInTaskId = data["rollInTaskId"] !== undefined ? data["rollInTaskId"] : null;
            this.rollInTaskStatus = data["rollInTaskStatus"] !== undefined ? data["rollInTaskStatus"] : null;
            this.rollInTaskEvent = data["rollInTaskEvent"] !== undefined ? data["rollInTaskEvent"] : null;
            this.creationDate = data["creationDate"] ? new Date(data["creationDate"].toString()) : null;
            this.createdByUser = data["createdByUser"] !== undefined ? data["createdByUser"] : null;
        }
    };
    RollInTaskHistoryViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RollInTaskHistoryViewModel();
        result.init(data);
        return result;
    };
    RollInTaskHistoryViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["rollInTaskHistoryId"] = this.rollInTaskHistoryId !== undefined ? this.rollInTaskHistoryId : null;
        data["rollInTaskId"] = this.rollInTaskId !== undefined ? this.rollInTaskId : null;
        data["rollInTaskStatus"] = this.rollInTaskStatus !== undefined ? this.rollInTaskStatus : null;
        data["rollInTaskEvent"] = this.rollInTaskEvent !== undefined ? this.rollInTaskEvent : null;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : null;
        data["createdByUser"] = this.createdByUser !== undefined ? this.createdByUser : null;
        return data;
    };
    return RollInTaskHistoryViewModel;
}());
export { RollInTaskHistoryViewModel };
var RollInReasonViewModel = /** @class */ (function () {
    function RollInReasonViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RollInReasonViewModel.prototype.init = function (data) {
        if (data) {
            this.rollInReasonId = data["rollInReasonId"] !== undefined ? data["rollInReasonId"] : null;
            this.name = data["name"] !== undefined ? data["name"] : null;
            this.key = data["key"] !== undefined ? data["key"] : null;
        }
    };
    RollInReasonViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RollInReasonViewModel();
        result.init(data);
        return result;
    };
    RollInReasonViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["rollInReasonId"] = this.rollInReasonId !== undefined ? this.rollInReasonId : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["key"] = this.key !== undefined ? this.key : null;
        return data;
    };
    return RollInReasonViewModel;
}());
export { RollInReasonViewModel };
var RollInTaskAssetViewModel = /** @class */ (function () {
    function RollInTaskAssetViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RollInTaskAssetViewModel.prototype.init = function (data) {
        if (data) {
            this.rollInTaskId = data["rollInTaskId"] !== undefined ? data["rollInTaskId"] : null;
            this.assetId = data["assetId"] !== undefined ? data["assetId"] : null;
            this.status = data["status"] !== undefined ? data["status"] : null;
            this.assetSerialNumber = data["assetSerialNumber"] !== undefined ? data["assetSerialNumber"] : null;
        }
    };
    RollInTaskAssetViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RollInTaskAssetViewModel();
        result.init(data);
        return result;
    };
    RollInTaskAssetViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["rollInTaskId"] = this.rollInTaskId !== undefined ? this.rollInTaskId : null;
        data["assetId"] = this.assetId !== undefined ? this.assetId : null;
        data["status"] = this.status !== undefined ? this.status : null;
        data["assetSerialNumber"] = this.assetSerialNumber !== undefined ? this.assetSerialNumber : null;
        return data;
    };
    return RollInTaskAssetViewModel;
}());
export { RollInTaskAssetViewModel };
export var RollInTaskAssetStatusEnum;
(function (RollInTaskAssetStatusEnum) {
    RollInTaskAssetStatusEnum[RollInTaskAssetStatusEnum["None"] = 0] = "None";
    RollInTaskAssetStatusEnum[RollInTaskAssetStatusEnum["Received"] = 9] = "Received";
    RollInTaskAssetStatusEnum[RollInTaskAssetStatusEnum["NotReceived"] = 10] = "NotReceived";
})(RollInTaskAssetStatusEnum || (RollInTaskAssetStatusEnum = {}));
var RollInTaskViewModel = /** @class */ (function () {
    function RollInTaskViewModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RollInTaskViewModel.prototype.init = function (data) {
        if (data) {
            this.rollInTaskId = data["rollInTaskId"] !== undefined ? data["rollInTaskId"] : null;
            this.name = data["name"] !== undefined ? data["name"] : null;
            this.status = data["status"] !== undefined ? data["status"] : null;
            this.rollInReasonId = data["rollInReasonId"] !== undefined ? data["rollInReasonId"] : null;
            this.tenantAssetDefinitionId = data["tenantAssetDefinitionId"] !== undefined ? data["tenantAssetDefinitionId"] : null;
            this.assetDefinitionId = data["assetDefinitionId"] !== undefined ? data["assetDefinitionId"] : null;
            this.assetDefinitionName = data["assetDefinitionName"] !== undefined ? data["assetDefinitionName"] : null;
            this.locationId = data["locationId"] !== undefined ? data["locationId"] : null;
            this.userId = data["userId"] !== undefined ? data["userId"] : null;
            this.trackingNumber = data["trackingNumber"] !== undefined ? data["trackingNumber"] : null;
            this.notActive = data["notActive"] !== undefined ? data["notActive"] : null;
            if (data["rollInTaskAssets"] && data["rollInTaskAssets"].constructor === Array) {
                this.rollInTaskAssets = [];
                for (var _i = 0, _a = data["rollInTaskAssets"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.rollInTaskAssets.push(RollInTaskAssetViewModel.fromJS(item));
                }
            }
            if (data["rollInTaskHistories"] && data["rollInTaskHistories"].constructor === Array) {
                this.rollInTaskHistories = [];
                for (var _b = 0, _c = data["rollInTaskHistories"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.rollInTaskHistories.push(RollInTaskHistoryViewModel.fromJS(item));
                }
            }
        }
    };
    RollInTaskViewModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RollInTaskViewModel();
        result.init(data);
        return result;
    };
    RollInTaskViewModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["rollInTaskId"] = this.rollInTaskId !== undefined ? this.rollInTaskId : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["status"] = this.status !== undefined ? this.status : null;
        data["rollInReasonId"] = this.rollInReasonId !== undefined ? this.rollInReasonId : null;
        data["tenantAssetDefinitionId"] = this.tenantAssetDefinitionId !== undefined ? this.tenantAssetDefinitionId : null;
        data["assetDefinitionId"] = this.assetDefinitionId !== undefined ? this.assetDefinitionId : null;
        data["assetDefinitionName"] = this.assetDefinitionName !== undefined ? this.assetDefinitionName : null;
        data["locationId"] = this.locationId !== undefined ? this.locationId : null;
        data["userId"] = this.userId !== undefined ? this.userId : null;
        data["trackingNumber"] = this.trackingNumber !== undefined ? this.trackingNumber : null;
        data["notActive"] = this.notActive !== undefined ? this.notActive : null;
        if (this.rollInTaskAssets && this.rollInTaskAssets.constructor === Array) {
            data["rollInTaskAssets"] = [];
            for (var _i = 0, _a = this.rollInTaskAssets; _i < _a.length; _i++) {
                var item = _a[_i];
                data["rollInTaskAssets"].push(item.toJSON());
            }
        }
        if (this.rollInTaskHistories && this.rollInTaskHistories.constructor === Array) {
            data["rollInTaskHistories"] = [];
            for (var _b = 0, _c = this.rollInTaskHistories; _b < _c.length; _b++) {
                var item = _c[_b];
                data["rollInTaskHistories"].push(item.toJSON());
            }
        }
        return data;
    };
    return RollInTaskViewModel;
}());
export { RollInTaskViewModel };
export var RollInTaskStatusEnum;
(function (RollInTaskStatusEnum) {
    RollInTaskStatusEnum[RollInTaskStatusEnum["New"] = 0] = "New";
    RollInTaskStatusEnum[RollInTaskStatusEnum["Prepared"] = 1] = "Prepared";
    RollInTaskStatusEnum[RollInTaskStatusEnum["Finished"] = 2] = "Finished";
    RollInTaskStatusEnum[RollInTaskStatusEnum["Canceled"] = 99] = "Canceled";
})(RollInTaskStatusEnum || (RollInTaskStatusEnum = {}));
